/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  AccreditationDateTime: { input: string; output: string };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  AccreditationJSONObject: { input: Record<string, unknown>; output: Record<string, unknown> };
  AccreditationTransportOptions: { input: unknown; output: unknown };
  /** A date string, such as 2007-12-03 (YYYY-MM-DD), compliant with ISO 8601 standard for representation of dates using the Gregorian calendar. */
  Date: { input: string; output: string };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown> };
  /** Raw JSON value */
  Json: { input: unknown; output: unknown };
  /** Integers that will have a value of 0 or more. */
  MarketplaceNonNegativeInt: { input: number; output: number };
  MarketplaceObjMap: { input: Record<string, unknown>; output: Record<string, unknown> };
  /** Integers that will have a value greater than 0. */
  MarketplacePositiveInt: { input: number; output: number };
  ResolveToSourceArgs: { input: unknown; output: unknown };
  /** Slate-compatible RichText AST */
  RichTextAST: { input: unknown; output: unknown };
  TransportOptions: { input: unknown; output: unknown };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File };
  /** Represents NULL values */
  Void: { input: never; output: null };
  _DirectiveExtensions: { input: unknown; output: unknown };
};

export type AbrAbnLookupInput = {
  abn: Scalars['String']['input'];
};

export type AbrAbnLookupResult = {
  __typename?: 'AbrAbnLookupResult';
  abn: Scalars['String']['output'];
  abnStatus: Scalars['String']['output'];
  abnStatusEffectiveFrom: Scalars['String']['output'];
  acn?: Maybe<Scalars['String']['output']>;
  addressDate: Scalars['String']['output'];
  addressPostcode: Scalars['String']['output'];
  addressState: Scalars['String']['output'];
  businessNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityName: Scalars['String']['output'];
  entityTypeCode: Scalars['String']['output'];
  entityTypeName: Scalars['String']['output'];
  gst?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AbrAbnSearchInput = {
  query: Scalars['String']['input'];
};

export type AbrAbnSearchResult = {
  __typename?: 'AbrAbnSearchResult';
  abn?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameType?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AcceptApplicationContractInput = {
  applicantType: ApplicantType;
  applicationId: Scalars['String']['input'];
};

export type AccessFields = {
  isActive: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  marketplaceVisible: Scalars['Boolean']['input'];
};

export type Accordion = Entity & {
  __typename?: 'Accordion';
  content?: Maybe<RichText>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccordionGroup = Entity & {
  __typename?: 'AccordionGroup';
  accordionTheme?: Maybe<Theme>;
  accordions: Array<AccordionGroupaccordionsUnion>;
  /** Optional content to display between the heading and the accordions */
  content?: Maybe<RichText>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccordionGroupAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Identifies documents */
export type AccordionGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionTheme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  accordionTheme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  accordionTheme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  accordionTheme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** All values in which the union is empty. */
  accordions_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  accordions_some?: InputMaybe<AccordionGroupaccordionsUnionWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type AccordionGroupaccordionsUnion = Accordion;

export type AccordionGroupaccordionsUnionWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
};

export enum AccordionOrderByInput {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Identifies documents */
export type AccordionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type Account = {
  __typename?: 'Account';
  Quote?: Maybe<Array<Quote>>;
  advancePaymentAmount: Scalars['Float']['output'];
  agent?: Maybe<Employee>;
  allowWithdrawal: Scalars['Boolean']['output'];
  amountVendorGetPaid?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  balanceAvailable?: Maybe<Scalars['Float']['output']>;
  balanceOwing?: Maybe<Scalars['Float']['output']>;
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  canAddStages: Scalars['Boolean']['output'];
  canRequestPayment: Scalars['Boolean']['output'];
  category?: Maybe<Category>;
  confirmReceived: Scalars['Boolean']['output'];
  confirmRequested?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  creditLimit?: Maybe<Scalars['Float']['output']>;
  customerStatus?: Maybe<CustomerStatus>;
  customers: Array<Customer>;
  deposit: Scalars['Float']['output'];
  documents?: Maybe<Array<Document>>;
  /** @deprecated Energy bundle is no longer offered */
  energyBundle: Scalars['Boolean']['output'];
  enterprise?: Maybe<BusinessCustomer>;
  /** @deprecated Use `productConfiguration` instead */
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  financeAmountEditable: Scalars['Boolean']['output'];
  financedAmount?: Maybe<Scalars['Float']['output']>;
  financialProduct: FinancialProduct;
  financialProductId: Scalars['String']['output'];
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  installationAddress?: Maybe<AddressType>;
  insulationType?: Maybe<InsulationType>;
  /** @deprecated Use `productConfiguration` instead */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  introducerFee?: Maybe<Scalars['Float']['output']>;
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  isCashApplication?: Maybe<Scalars['Boolean']['output']>;
  isInstallBooked: Scalars['Boolean']['output'];
  /** @deprecated Legacy PHP admin portal id. Only use this for linking to the old admin portal until it is decommissioned. Use `id` (UUID) for all other purposes. */
  legacyId: Scalars['Int']['output'];
  loanStatusGroup?: Maybe<AccountLoanStatusGroup>;
  modified: Scalars['DateTime']['output'];
  needSecondaryApplicantDetails?: Maybe<Scalars['Boolean']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nextPayment?: Maybe<Scalars['DateTime']['output']>;
  numberOfRepaymentsRemaining?: Maybe<Scalars['Float']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  otherProductDetails?: Maybe<Scalars['String']['output']>;
  overdueAmount?: Maybe<Scalars['Float']['output']>;
  overdueDaysPastDue?: Maybe<Scalars['Float']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  paymentMethod: PaymentMethod;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Payment>>;
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  purchaseAmount: Scalars['Float']['output'];
  purchaseItems?: Maybe<Array<PurchaseItem>>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  /** @deprecated Use vendorRebates instead */
  rebates?: Maybe<Array<VendorRebate>>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  remainingDisbursementAmount: Scalars['Float']['output'];
  repaymentAmount: Scalars['Float']['output'];
  repaymentAmountAdjusted?: Maybe<Scalars['Float']['output']>;
  repaymentFrequency?: Maybe<AccountRepaymentFrequency>;
  repaymentTerm: Scalars['Int']['output'];
  repaymentTermByFrequency: Scalars['Float']['output'];
  requestPaymentRequirements?: Maybe<RequestPaymentRequirementsType>;
  settled?: Maybe<Scalars['DateTime']['output']>;
  settlementAmount: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  statusDescription: Scalars['String']['output'];
  statusGroup?: Maybe<AccountStatusGroup>;
  statusLabel: Scalars['String']['output'];
  stoveType?: Maybe<StoveType>;
  synced?: Maybe<Scalars['Boolean']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalInterest?: Maybe<Scalars['Float']['output']>;
  totalPayment?: Maybe<Scalars['Float']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Vendor>;
  vendorRebates?: Maybe<Array<VendorRebate>>;
  waitingForCca: Scalars['Boolean']['output'];
};

export type AccountAgentFilter = {
  id?: InputMaybe<StringFilter>;
};

export type AccountCalculatorInput = {
  deposit: Scalars['Float']['input'];
  financialProductId: Scalars['String']['input'];
  purchaseAmount: Scalars['Float']['input'];
};

export type AccountCalculatorResponse = {
  __typename?: 'AccountCalculatorResponse';
  financedAmount: Scalars['Float']['output'];
  rebate: Scalars['Float']['output'];
  settlementAmount: Scalars['Float']['output'];
};

export enum AccountLoanStatusGroup {
  Closed = 'CLOSED',
  Complaint = 'COMPLAINT',
  Hardship = 'HARDSHIP',
  OnHold = 'ON_HOLD',
  Overdue = 'OVERDUE',
  PaidInFull = 'PAID_IN_FULL',
}

export enum AccountRepaymentFrequency {
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly',
  Yearly = 'Yearly',
}

/** The account-level flag sets editable via vendorUpdateAccountSettingsFlags */
export enum AccountSettingsFlagType {
  General = 'GENERAL',
  Marketplace = 'MARKETPLACE',
}

export type AccountStatementInput = {
  accountId: Scalars['String']['input'];
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  documentType?: InputMaybe<FinanceDocumentType>;
};

export type AccountStatementResponse = {
  __typename?: 'AccountStatementResponse';
  accountId: Scalars['String']['output'];
  accountStatement: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum AccountStatusGroup {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Installation = 'INSTALLATION',
  Paid = 'PAID',
  Pending = 'PENDING',
  PendingInformation = 'PENDING_INFORMATION',
  PendingJointApplicant = 'PENDING_JOINT_APPLICANT',
  PendingVendorContract = 'PENDING_VENDOR_CONTRACT',
  PendAcpt = 'PEND_ACPT',
  PendPymt = 'PEND_PYMT',
  ReviewingEligibility = 'REVIEWING_ELIGIBILITY',
  ReviewingIncomeDocuments = 'REVIEWING_INCOME_DOCUMENTS',
  UnderReview = 'UNDER_REVIEW',
  Withdrawn = 'WITHDRAWN',
}

export type AccountSummaryByStatusGroupResponse = {
  __typename?: 'AccountSummaryByStatusGroupResponse';
  count: Scalars['Int']['output'];
  totalFinancedAmount: Scalars['Float']['output'];
};

export type AccountVendorFilter = {
  id?: InputMaybe<StringFilter>;
};

export type AccountsFilter = {
  AND?: InputMaybe<Array<AccountsFilterFields>>;
  OR?: InputMaybe<Array<AccountsFilterFields>>;
  agent?: InputMaybe<AccountAgentFilter>;
  categoryId?: InputMaybe<NumberFilter>;
  created?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<StringFilter>;
  financedAmount?: InputMaybe<NumberFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  loanTypeId?: InputMaybe<NumberFilter>;
  publicId?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  repaymentTerm?: InputMaybe<NumberFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringFilter>;
  statusGroup?: InputMaybe<AccountsStatusGroupFilter>;
  vendor?: InputMaybe<AccountVendorFilter>;
};

export type AccountsFilterFields = {
  agent?: InputMaybe<AccountAgentFilter>;
  categoryId?: InputMaybe<NumberFilter>;
  created?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<StringFilter>;
  financedAmount?: InputMaybe<NumberFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  loanTypeId?: InputMaybe<NumberFilter>;
  publicId?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  repaymentTerm?: InputMaybe<NumberFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringFilter>;
  statusGroup?: InputMaybe<AccountsStatusGroupFilter>;
  vendor?: InputMaybe<AccountVendorFilter>;
};

export type AccountsResponse = {
  __typename?: 'AccountsResponse';
  accounts: Array<Account>;
};

export type AccountsSort = {
  created?: InputMaybe<SortDir>;
};

export type AccountsStatusGroupFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The type of actor who performed the action (SYSTEM or ADMIN) */
export enum AccreditationActorType {
  Admin = 'ADMIN',
  System = 'SYSTEM',
}

export type AccreditationAddAccreditationIndividualInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Individual details to add */
  individual: AccreditationAddIndividualInput;
};

export type AccreditationAddAddressInput = {
  /** Address Id */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  postcode: Scalars['String']['input'];
  /** State or territory */
  state: Scalars['String']['input'];
  /** Street name */
  streetName: Scalars['String']['input'];
  /** Street number */
  streetNumber: Scalars['String']['input'];
  /** Suburb */
  suburb: Scalars['String']['input'];
  /** Unit or apartment number */
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationAddIndividualInput = {
  /** Residential address */
  address: AccreditationAddAddressInput;
  /** Email address */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Role type in organization */
  jobType: AccreditationJobType;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Mobile number */
  phone: Scalars['String']['input'];
};

export type AccreditationAddress = {
  __typename?: 'AccreditationAddress';
  /** Country code */
  country: Scalars['String']['output'];
  /** Postal code */
  postcode: Scalars['String']['output'];
  /** State or territory */
  state: Scalars['String']['output'];
  /** Street name */
  streetName: Scalars['String']['output'];
  /** Street number */
  streetNumber: Scalars['String']['output'];
  /** Suburb */
  suburb: Scalars['String']['output'];
  /** Unit or apartment number */
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type AccreditationAddressInput = {
  /** Country code */
  country: Scalars['String']['input'];
  /** Postal code */
  postcode: Scalars['String']['input'];
  /** State or territory */
  state: Scalars['String']['input'];
  /** Street name */
  streetName: Scalars['String']['input'];
  /** Street number */
  streetNumber: Scalars['String']['input'];
  /** Suburb */
  suburb: Scalars['String']['input'];
  /** Unit or apartment number */
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationAdminUser = {
  __typename?: 'AccreditationAdminUser';
  /** Residential address */
  address?: Maybe<AccreditationAddress>;
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Contract status */
  contractStatus?: Maybe<Scalars['String']['output']>;
  /** Date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  /** Driver license number */
  driverLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Role type in organization */
  jobType?: Maybe<AccreditationJobType>;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Phone number */
  phone: Scalars['String']['output'];
};

export type AccreditationApplicant = {
  __typename?: 'AccreditationApplicant';
  /** Auth0 user ID */
  authId: Scalars['String']['output'];
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Phone number */
  mobile: Scalars['String']['output'];
};

export type AccreditationApplication = {
  __typename?: 'AccreditationApplication';
  /** ABN number */
  abn: Scalars['String']['output'];
  /** ABN Registration Date */
  abnRegistrationDate: Scalars['AccreditationDateTime']['output'];
  /** Account branch name */
  accountBranch?: Maybe<Scalars['String']['output']>;
  /** Account BSB */
  accountBsb?: Maybe<Scalars['String']['output']>;
  /** Account financial institution name */
  accountFinancialInstitution?: Maybe<Scalars['String']['output']>;
  /** Bank account name */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Accredited at */
  accreditedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** ACN number */
  acn?: Maybe<Scalars['String']['output']>;
  /** Associated admin user */
  adminUser?: Maybe<AccreditationAdminUser>;
  /** Associated applicant */
  applicant: AccreditationApplicant;
  applicationWorkflowExecutions?: Maybe<Array<AccreditationApplicationWorkflowExecution>>;
  /** Approved at */
  approvedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** Average deal size */
  avgDealSize?: Maybe<Scalars['Float']['output']>;
  /** Business address */
  businessAddress: AccreditationAddress;
  /** Business size */
  businessSize?: Maybe<AccreditationBusinessSize>;
  /** Company ACN */
  companyAcn?: Maybe<Scalars['String']['output']>;
  companyCreditCheck?: Maybe<Scalars['AccreditationJSONObject']['output']>;
  /** Legal Name of Corporate Trustee */
  companyTrusteeLegalName?: Maybe<Scalars['String']['output']>;
  /** Created at */
  created: Scalars['AccreditationDateTime']['output'];
  /** Declaration consent */
  declarationConsent: Scalars['Boolean']['output'];
  /** Associated documents */
  documents?: Maybe<Array<AccreditationDocument>>;
  /** Email address */
  email: Scalars['String']['output'];
  /** Energy tech seller status */
  energyTechSeller?: Maybe<Scalars['Boolean']['output']>;
  /** Business name */
  entityBusinessName: Scalars['String']['output'];
  /** Legal entity name */
  entityLegalName: Scalars['String']['output'];
  /** Business entity structure */
  entityStructure: AccreditationEntityStructure;
  /** Finance providers */
  financeProviders?: Maybe<Scalars['String']['output']>;
  /** Types of finance interested in offering */
  financeTypes: Array<AccreditationFinanceType>;
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Associated individuals */
  individuals?: Maybe<Array<AccreditationIndividual>>;
  /** Installer engagement type */
  installerEngagement?: Maybe<AccreditationInstallerEngagement>;
  /** Installers accredited by SAA */
  installersAccreditedSaa?: Maybe<Scalars['Boolean']['output']>;
  /** Is finance provider */
  isFinanceProvider: Scalars['Boolean']['output'];
  /** Lead generation methods */
  leadGenMethod: Array<AccreditationLeadGenMethod>;
  logNotes?: Maybe<Array<AccreditationLogNote>>;
  /** Number of contractors */
  numberOfContractors?: Maybe<AccreditationNumberOfEmployees>;
  /** Number of employees */
  numberOfEmployees?: Maybe<AccreditationNumberOfEmployees>;
  /** Number of installation */
  numberOfInstallation?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of lead */
  numberOfLead?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of quote */
  numberOfQuote?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of sale agents */
  numberOfSaleAgents?: Maybe<AccreditationNumberOfEmployees>;
  /** Previous ABN */
  prevAbn?: Maybe<Scalars['String']['output']>;
  /** Product offerings */
  productOfferings: Array<Scalars['String']['output']>;
  /** Scope of service area */
  scopeOfServiceArea?: Maybe<AccreditationCoverageArea>;
  /** Australian state or territory */
  state: AccreditationAusState;
  /** Application status */
  status: AccreditationApplicationStatus;
  /** Submitted at */
  submittedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** Target markets for business operations (multiselect) */
  targetMarket: Array<Scalars['String']['output']>;
  /** Trading duration */
  tradingDuration: Scalars['Int']['output'];
  /** Updated at */
  updated: Scalars['AccreditationDateTime']['output'];
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type AccreditationApplicationApplicationWorkflowExecutionsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** The status of the application */
export enum AccreditationApplicationStatus {
  Approved = 'APPROVED',
  ContractSigned = 'CONTRACT_SIGNED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  InfoRequested = 'INFO_REQUESTED',
  Submitted = 'SUBMITTED',
  UnderReview = 'UNDER_REVIEW',
  Withdrawn = 'WITHDRAWN',
}

export type AccreditationApplicationWorkflowExecution = {
  __typename?: 'AccreditationApplicationWorkflowExecution';
  /** Application ID */
  applicationId: Scalars['String']['output'];
  /** Created at timestamp */
  created: Scalars['AccreditationDateTime']['output'];
  /** Execution ID */
  executionId: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Workflow progress */
  progress?: Maybe<AccreditationWorkflowProgress>;
  /** Workflow status */
  status: AccreditationExecutionStatus;
  /** Workflow ID */
  workflowId: Scalars['String']['output'];
  /** Workflow report */
  workflowReport?: Maybe<Scalars['AccreditationJSONObject']['output']>;
  /** Workflow report summary */
  workflowReportSummary?: Maybe<Scalars['AccreditationJSONObject']['output']>;
};

export type AccreditationApplicationsFilter = {
  /** Business size */
  businessSize?: InputMaybe<AccreditationBusinessSize>;
  /** Search query */
  search?: InputMaybe<Scalars['String']['input']>;
  /** State filter */
  state?: InputMaybe<AccreditationStateFilter>;
  /** Status filter */
  status?: InputMaybe<AccreditationStatusFilter>;
};

export type AccreditationApplicationsMeta = {
  __typename?: 'AccreditationApplicationsMeta';
  /** Number of applications to skip */
  skip?: Maybe<Scalars['Int']['output']>;
  /** Number of applications to take */
  take?: Maybe<Scalars['Int']['output']>;
  /** Total count of applications matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccreditationApplicationsResponse = {
  __typename?: 'AccreditationApplicationsResponse';
  /** List of applications */
  items: Array<AccreditationApplication>;
  /** Metadata about the applications */
  meta?: Maybe<AccreditationApplicationsMeta>;
};

export type AccreditationApplicationsSort = {
  /** Sort direction */
  direction: AccreditationSortDir;
  /** Field to sort by */
  field: AccreditationSortField;
};

/** Australian state or territory */
export enum AccreditationAusState {
  Act = 'ACT',
  Nsw = 'NSW',
  Nt = 'NT',
  Qld = 'QLD',
  Sa = 'SA',
  Tas = 'TAS',
  Vic = 'VIC',
  Wa = 'WA',
}

export type AccreditationBiometricCheck = {
  __typename?: 'AccreditationBiometricCheck';
  /** Detailed description of the check result */
  details?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the check */
  key?: Maybe<Scalars['String']['output']>;
  /** Display label for the check */
  label?: Maybe<Scalars['String']['output']>;
  /** Reference validation sources (e.g., Electoral Roll, Document Verification) */
  references?: Maybe<Array<AccreditationBiometricCheckReference>>;
  /** Check status (e.g., PASS, FAIL) */
  status?: Maybe<Scalars['String']['output']>;
  /** Type of check (CONTROL, REFERENCE) */
  type?: Maybe<Scalars['String']['output']>;
};

export type AccreditationBiometricCheckReference = {
  __typename?: 'AccreditationBiometricCheckReference';
  /** Unique identifier for the reference check */
  key?: Maybe<Scalars['String']['output']>;
  /** Display label for the reference check */
  label?: Maybe<Scalars['String']['output']>;
  /** Verification score (0-100) */
  score?: Maybe<Scalars['Int']['output']>;
  /** Verification status (e.g., PASS, FAIL) */
  status?: Maybe<Scalars['String']['output']>;
  /** Type of reference check */
  type?: Maybe<Scalars['String']['output']>;
};

/** The size of the business */
export enum AccreditationBusinessSize {
  MediumToLarge = 'MEDIUM_TO_LARGE',
  Small = 'SMALL',
}

/** The coverage area for business operations */
export enum AccreditationCoverageArea {
  Metropolitan = 'METROPOLITAN',
  MultistateOrNational = 'MULTISTATE_OR_NATIONAL',
  Regional = 'REGIONAL',
  Statewide = 'STATEWIDE',
}

export type AccreditationCreateAndSendContractInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
};

export type AccreditationCreateApplicationInput = {
  /** ABN number */
  abn: Scalars['String']['input'];
  /** ABN Registration Date */
  abnRegistrationDate: Scalars['String']['input'];
  /** ACN number */
  acn?: InputMaybe<Scalars['String']['input']>;
  /** Application ID */
  applicationId?: InputMaybe<Scalars['String']['input']>;
  /** Business address */
  businessAddress: AccreditationAddressInput;
  /** Company ACN */
  companyAcn?: InputMaybe<Scalars['String']['input']>;
  /** Corporate Trustee - when entity structure is TRUST and trustee is a company */
  companyTrusteeLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Document metadata for presigned URL generation */
  documents?: InputMaybe<Array<AccreditationDocumentInput>>;
  /** Email address */
  email: Scalars['String']['input'];
  /** Business name */
  entityBusinessName?: InputMaybe<Scalars['String']['input']>;
  /** Legal entity name */
  entityLegalName: Scalars['String']['input'];
  /** Entity structure */
  entityStructure: AccreditationEntityStructure;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Mobile number */
  mobile: Scalars['String']['input'];
  /** Previous ABN */
  prevAbn?: InputMaybe<Scalars['String']['input']>;
  /** Referral source read from the URL */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Australian state or territory */
  state: AccreditationAusState;
  /** Trading duration */
  tradingDuration: Scalars['Int']['input'];
  /** Website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationCreateCompanyCheckInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Whether to refresh the company check data */
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccreditationCreateDocumentInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Document metadata for presigned URL generation */
  documents: Array<AccreditationDocumentInput>;
};

export type AccreditationCreateIndividualCheckInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Individual IDs to check (if not provided, checks all) */
  individualIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to refresh the individual check data */
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccreditationCreateIndividualInput = {
  /** Residential address */
  address: AccreditationAddressInput;
  /** Email address */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Associated individual ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Role type in organization */
  jobType: AccreditationJobType;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Mobile number */
  phone: Scalars['String']['input'];
  /** Signer order for contract signing */
  signerOrder: Scalars['Int']['input'];
};

export type AccreditationCreateLogNoteInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Activity log message */
  message: Scalars['String']['input'];
};

/** Application with presigned upload fields for newly created documents */
export type AccreditationCreatedApplication = {
  __typename?: 'AccreditationCreatedApplication';
  /** ABN number */
  abn: Scalars['String']['output'];
  /** ABN Registration Date */
  abnRegistrationDate: Scalars['AccreditationDateTime']['output'];
  /** Account branch name */
  accountBranch?: Maybe<Scalars['String']['output']>;
  /** Account BSB */
  accountBsb?: Maybe<Scalars['String']['output']>;
  /** Account financial institution name */
  accountFinancialInstitution?: Maybe<Scalars['String']['output']>;
  /** Bank account name */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Accredited at */
  accreditedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** ACN number */
  acn?: Maybe<Scalars['String']['output']>;
  /** Associated admin user */
  adminUser?: Maybe<AccreditationAdminUser>;
  /** Associated applicant */
  applicant: AccreditationApplicant;
  /** Approved at */
  approvedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** Average deal size */
  avgDealSize?: Maybe<Scalars['Float']['output']>;
  /** Business address */
  businessAddress: AccreditationAddress;
  /** Business size */
  businessSize?: Maybe<AccreditationBusinessSize>;
  /** Company ACN */
  companyAcn?: Maybe<Scalars['String']['output']>;
  /** Legal Name of Corporate Trustee */
  companyTrusteeLegalName?: Maybe<Scalars['String']['output']>;
  /** Created at */
  created: Scalars['AccreditationDateTime']['output'];
  /** Declaration consent */
  declarationConsent: Scalars['Boolean']['output'];
  /** Associated documents with presigned upload fields */
  documents?: Maybe<Array<AccreditationCreatedDocument>>;
  /** Email address */
  email: Scalars['String']['output'];
  /** Energy tech seller status */
  energyTechSeller?: Maybe<Scalars['Boolean']['output']>;
  /** Business name */
  entityBusinessName: Scalars['String']['output'];
  /** Legal entity name */
  entityLegalName: Scalars['String']['output'];
  /** Business entity structure */
  entityStructure: AccreditationEntityStructure;
  /** Finance providers */
  financeProviders?: Maybe<Scalars['String']['output']>;
  /** Types of finance interested in offering */
  financeTypes: Array<AccreditationFinanceType>;
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Associated individuals */
  individuals?: Maybe<Array<AccreditationIndividual>>;
  /** Installer engagement type */
  installerEngagement?: Maybe<AccreditationInstallerEngagement>;
  /** Installers accredited by SAA */
  installersAccreditedSaa?: Maybe<Scalars['Boolean']['output']>;
  /** Is finance provider */
  isFinanceProvider: Scalars['Boolean']['output'];
  /** Lead generation methods */
  leadGenMethod: Array<AccreditationLeadGenMethod>;
  /** Number of contractors */
  numberOfContractors?: Maybe<AccreditationNumberOfEmployees>;
  /** Number of employees */
  numberOfEmployees?: Maybe<AccreditationNumberOfEmployees>;
  /** Number of installation */
  numberOfInstallation?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of lead */
  numberOfLead?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of quote */
  numberOfQuote?: Maybe<AccreditationNumberOfPipeline>;
  /** Number of sale agents */
  numberOfSaleAgents?: Maybe<AccreditationNumberOfEmployees>;
  /** Previous ABN */
  prevAbn?: Maybe<Scalars['String']['output']>;
  /** Product offerings */
  productOfferings: Array<Scalars['String']['output']>;
  /** Scope of service area */
  scopeOfServiceArea?: Maybe<AccreditationCoverageArea>;
  /** Australian state or territory */
  state: AccreditationAusState;
  /** Application status */
  status: AccreditationApplicationStatus;
  /** Submitted at */
  submittedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** Target markets for business operations (multiselect) */
  targetMarket: Array<Scalars['String']['output']>;
  /** Trading duration */
  tradingDuration: Scalars['Int']['output'];
  /** Updated at */
  updated: Scalars['AccreditationDateTime']['output'];
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Document with presigned upload fields (only returned when creating new documents) */
export type AccreditationCreatedDocument = {
  __typename?: 'AccreditationCreatedDocument';
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Document storage URI (permanent S3 URL) */
  documentUri: Scalars['String']['output'];
  /** Presigned POST form fields as JSON string for uploading this document (only present for newly created documents) */
  fieldsJson?: Maybe<Scalars['String']['output']>;
  /** Original filename */
  fileName: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Associated individual ID */
  individualId?: Maybe<Scalars['String']['output']>;
  /** Upload status of this document: PENDING (created, waiting for upload), SUCCESS (upload successful), FAILED (upload failed), DELETED (document removed) */
  status: AccreditationDocumentStatus;
  /** Type of document */
  type: AccreditationDocumentType;
  /** Presigned S3 POST URL for uploading this document (only present for newly created documents) */
  url?: Maybe<Scalars['String']['output']>;
};

export type AccreditationDeleteDocumentInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Document ID */
  documentId: Scalars['String']['input'];
};

export type AccreditationDocument = {
  __typename?: 'AccreditationDocument';
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Document storage URI (permanent S3 URL) */
  documentUri: Scalars['String']['output'];
  /** Original filename */
  fileName: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Associated individual ID */
  individualId?: Maybe<Scalars['String']['output']>;
  /** Upload status of this document: PENDING (created, waiting for upload), SUCCESS (upload successful), FAILED (upload failed), DELETED (document removed) */
  status: AccreditationDocumentStatus;
  /** Type of document */
  type: AccreditationDocumentType;
};

export type AccreditationDocumentInput = {
  /** File size in bytes */
  fileSize: Scalars['Int']['input'];
  /** Filename */
  filename: Scalars['String']['input'];
  /** Document type */
  type: AccreditationDocumentType;
};

/** The upload status of the document: PENDING (created, waiting for upload), SUCCESS (upload successful), FAILED (upload failed), DELETED (document deleted) */
export enum AccreditationDocumentStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type AccreditationDocumentStatusUpdateInput = {
  /** Document ID to update */
  documentId: Scalars['String']['input'];
  /** Status to set for this document */
  status: AccreditationDocumentStatus;
};

/** The type of document uploaded */
export enum AccreditationDocumentType {
  Contract = 'CONTRACT',
  DriverLicence = 'DRIVER_LICENCE',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  Report = 'REPORT',
  TrustDeed = 'TRUST_DEED',
}

/** The structure type of the business entity */
export enum AccreditationEntityStructure {
  Company = 'COMPANY',
  Partnership = 'PARTNERSHIP',
  SoleTrader = 'SOLE_TRADER',
  Trust = 'TRUST',
}

/** The status of the workflow execution */
export enum AccreditationExecutionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

/** The type of finance offerings */
export enum AccreditationFinanceType {
  BuyNowPayLater = 'BUY_NOW_PAY_LATER',
  GreenLoan = 'GREEN_LOAN',
  NotSure = 'NOT_SURE',
}

export type AccreditationGetWorkflowExecutionInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Execution ID */
  executionId: Scalars['String']['input'];
  /** Workflow ID */
  workflowId: Scalars['String']['input'];
};

export type AccreditationIdentityVerificationResponse = {
  __typename?: 'AccreditationIdentityVerificationResponse';
  /** Application ID */
  applicationId: Scalars['String']['output'];
  /** Individual ID */
  id: Scalars['String']['output'];
  /** Identity verification data */
  identityVerificationData: Scalars['AccreditationJSONObject']['output'];
  /** Identity verification status */
  identityVerificationStatus: AccreditationIdentityVerificationStatus;
};

/** The status of identity verification process */
export enum AccreditationIdentityVerificationStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

export type AccreditationIdentityVerificationSummary = {
  __typename?: 'AccreditationIdentityVerificationSummary';
  /** List of biometric verification checks */
  checks?: Maybe<Array<AccreditationBiometricCheck>>;
  /** Category identifier */
  key?: Maybe<Scalars['String']['output']>;
  /** Display label for the verification category */
  label?: Maybe<Scalars['String']['output']>;
  /** Check status (e.g., PASS, FAIL) */
  status?: Maybe<Scalars['String']['output']>;
  /** Type of verification (CATEGORY) */
  type?: Maybe<Scalars['String']['output']>;
};

export type AccreditationIndividual = {
  __typename?: 'AccreditationIndividual';
  /** Residential address */
  address?: Maybe<AccreditationAddress>;
  /** Account Admin indicator */
  admin: Scalars['Boolean']['output'];
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Date contract signing was requested */
  contractRequestedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** Date of contract signing */
  contractSignedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** Contract status */
  contractStatus?: Maybe<Scalars['String']['output']>;
  /** Date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  /** Driver license number */
  driverLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Identity verification completed at */
  identityVerificationCompletedAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  identityVerificationData?: Maybe<Scalars['AccreditationJSONObject']['output']>;
  /** Identity verification link sent at */
  identityVerificationLinkSentAt?: Maybe<Scalars['AccreditationDateTime']['output']>;
  /** Identity verification status */
  identityVerificationStatus: AccreditationIdentityVerificationStatus;
  identityVerificationSummary?: Maybe<AccreditationIdentityVerificationSummary>;
  individualCreditCheck?: Maybe<Scalars['AccreditationJSONObject']['output']>;
  /** Role type in organization */
  jobType: AccreditationJobType;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Phone number */
  phone: Scalars['String']['output'];
  /** Signer order for contract signing */
  signerOrder: Scalars['Int']['output'];
};

/** The type of installer engagement */
export enum AccreditationInstallerEngagement {
  Both = 'BOTH',
  Contractor = 'CONTRACTOR',
  Employee = 'EMPLOYEE',
}

/** The role type of an individual in the organization */
export enum AccreditationJobType {
  Director = 'DIRECTOR',
  None = 'NONE',
  Partner = 'PARTNER',
  SoleTrader = 'SOLE_TRADER',
  Trustee = 'TRUSTEE',
}

/** Lead generation methods */
export enum AccreditationLeadGenMethod {
  DigitalAdvertising = 'DIGITAL_ADVERTISING',
  DirectEmail = 'DIRECT_EMAIL',
  DoorToDoorSales = 'DOOR_TO_DOOR_SALES',
  Other = 'OTHER',
  ShoppingCentreAdvertising = 'SHOPPING_CENTRE_ADVERTISING',
  SocialMedia = 'SOCIAL_MEDIA',
  TvOrRadioAdvertising = 'TV_OR_RADIO_ADVERTISING',
}

export type AccreditationLogNote = {
  __typename?: 'AccreditationLogNote';
  /** Action performed */
  action: Scalars['String']['output'];
  /** Actor type (SYSTEM or ADMIN) */
  actorType: AccreditationActorType;
  /** Associated application ID */
  applicationId: Scalars['String']['output'];
  /** Creation timestamp */
  created: Scalars['AccreditationDateTime']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Log note message */
  message: Scalars['String']['output'];
  /** Reason for the action (e.g. decline reason) */
  reason?: Maybe<Scalars['String']['output']>;
  /** User ID who performed the action (null for SYSTEM) */
  userId?: Maybe<Scalars['String']['output']>;
};

export type AccreditationLogNoteInput = {
  /** Log note message */
  message: Scalars['String']['input'];
  /** Reason for the action (e.g. decline reason) */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationLogNotesMeta = {
  __typename?: 'AccreditationLogNotesMeta';
  /** Number of log notes skipped */
  skip: Scalars['Int']['output'];
  /** Number of log notes taken */
  take: Scalars['Int']['output'];
  /** Total count of log notes */
  totalCount: Scalars['Int']['output'];
};

export type AccreditationLogNotesResponse = {
  __typename?: 'AccreditationLogNotesResponse';
  /** List of log notes */
  items: Array<AccreditationLogNote>;
  /** Pagination metadata */
  meta?: Maybe<AccreditationLogNotesMeta>;
};

/** The number of employees in the business */
export enum AccreditationNumberOfEmployees {
  MoreThanFifty = 'MORE_THAN_FIFTY',
  OneToFive = 'ONE_TO_FIVE',
  SixToTwenty = 'SIX_TO_TWENTY',
  TwentyOneToFifty = 'TWENTY_ONE_TO_FIFTY',
  Zero = 'ZERO',
}

/** The number of pipeline items */
export enum AccreditationNumberOfPipeline {
  ElevenToThirty = 'ELEVEN_TO_THIRTY',
  MoreThanThirty = 'MORE_THAN_THIRTY',
  OneToTen = 'ONE_TO_TEN',
}

export type AccreditationPreviewContractInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
};

/** Input for removing a key person from an application */
export type AccreditationRemoveIndividualInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Individual ID to remove */
  individualId: Scalars['String']['input'];
};

export type AccreditationRequestIdentityVerificationInput = {
  applicationId: Scalars['String']['input'];
  individualId: Scalars['String']['input'];
};

export enum AccreditationSortDir {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum AccreditationSortField {
  Created = 'CREATED',
  SubmittedAt = 'SUBMITTED_AT',
  Updated = 'UPDATED',
}

export type AccreditationStartPasswordlessAuthInput = {
  /** User email address */
  email: Scalars['String']['input'];
};

export type AccreditationStartPasswordlessAuthResponse = {
  __typename?: 'AccreditationStartPasswordlessAuthResponse';
  /** User email address */
  email: Scalars['String']['output'];
};

export type AccreditationStateFilter = {
  /** Include these states */
  in?: InputMaybe<Array<AccreditationAusState>>;
  /** Exclude these states */
  notIn?: InputMaybe<Array<AccreditationAusState>>;
};

export type AccreditationStatusFilter = {
  /** Include these statuses */
  in?: InputMaybe<Array<AccreditationApplicationStatus>>;
  /** Exclude these statuses */
  notIn?: InputMaybe<Array<AccreditationApplicationStatus>>;
};

export type AccreditationSubmitApplicationInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Agreements consent */
  declarationConsent: Scalars['Boolean']['input'];
};

/** Input for manually triggering a workflow */
export type AccreditationTriggerWorkflowInput = {
  /** Application ID to trigger workflow for */
  applicationId: Scalars['String']['input'];
  /** Whether to refresh company credit check */
  refreshCompanyCreditCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of individual IDs to refresh credit checks for */
  refreshIndividualCreditChecks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AccreditationUpdateAccreditationApplicantInput = {
  /** Application Id */
  applicationId: Scalars['String']['input'];
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationUpdateAccreditationApplicationInput = {
  /** ABN number */
  abn?: InputMaybe<Scalars['String']['input']>;
  /** ABN Registration Date */
  abnRegistrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Account branch name */
  accountBranch?: InputMaybe<Scalars['String']['input']>;
  /** Account BSB */
  accountBsb?: InputMaybe<Scalars['String']['input']>;
  /** Account financial institution name */
  accountFinancialInstitution?: InputMaybe<Scalars['String']['input']>;
  /** Account name */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Account number */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** ACN number */
  acn?: InputMaybe<Scalars['String']['input']>;
  /** Application Id */
  applicationId: Scalars['String']['input'];
  /** Average deal size */
  avgDealSize?: InputMaybe<Scalars['Float']['input']>;
  /** Business address */
  businessAddress?: InputMaybe<AccreditationUpdateAddressInput>;
  /** Business size */
  businessSize?: InputMaybe<AccreditationBusinessSize>;
  /** Company ACN */
  companyAcn?: InputMaybe<Scalars['String']['input']>;
  /** Legal Name of Corporate Trustee */
  companyTrusteeLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Energy tech seller status */
  energyTechSeller?: InputMaybe<Scalars['Boolean']['input']>;
  /** Business name */
  entityBusinessName?: InputMaybe<Scalars['String']['input']>;
  /** Legal entity name */
  entityLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Entity structure */
  entityStructure?: InputMaybe<AccreditationEntityStructure>;
  /** Finance providers */
  financeProviders?: InputMaybe<Scalars['String']['input']>;
  /** Types of finance interested in offering */
  financeTypes?: InputMaybe<Array<AccreditationFinanceType>>;
  /** Installer engagement type */
  installerEngagement?: InputMaybe<AccreditationInstallerEngagement>;
  /** Installers accredited by SAA */
  installersAccreditedSaa?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is finance provider */
  isFinanceProvider?: InputMaybe<Scalars['Boolean']['input']>;
  /** How did the user generate Leads */
  leadGenMethod?: InputMaybe<Array<AccreditationLeadGenMethod>>;
  /** Log note */
  logNote?: InputMaybe<AccreditationLogNoteInput>;
  /** Number of contractors */
  numberOfContractors?: InputMaybe<AccreditationNumberOfEmployees>;
  /** Number of employees */
  numberOfEmployees?: InputMaybe<AccreditationNumberOfEmployees>;
  /** Number of Installation */
  numberOfInstallation?: InputMaybe<AccreditationNumberOfPipeline>;
  /** Number of Lead */
  numberOfLead?: InputMaybe<AccreditationNumberOfPipeline>;
  /** Number of Quote */
  numberOfQuote?: InputMaybe<AccreditationNumberOfPipeline>;
  /** Number of sale agents */
  numberOfSaleAgents?: InputMaybe<AccreditationNumberOfEmployees>;
  /** Previous ABN */
  prevAbn?: InputMaybe<Scalars['String']['input']>;
  /** Product offerings (multiselect) */
  productOfferings?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Scope of service area (dropdown) */
  scopeOfServiceArea?: InputMaybe<AccreditationCoverageArea>;
  /** Australian state or territory */
  state?: InputMaybe<AccreditationAusState>;
  /** Application status */
  status?: InputMaybe<AccreditationApplicationStatus>;
  /** Target markets for business operations (multiselect) */
  targetMarket?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Trading duration */
  tradingDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationUpdateAccreditationIndividualInput = {
  /** Address of the individual */
  address?: InputMaybe<AccreditationUpdateAddressInput>;
  /** Application Id */
  applicationId: Scalars['String']['input'];
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Individual Id */
  individualId: Scalars['String']['input'];
  /** Role type in organization */
  jobType?: InputMaybe<AccreditationJobType>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile number */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationUpdateAddressInput = {
  /** Address Id */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  postcode: Scalars['String']['input'];
  /** State or territory */
  state: Scalars['String']['input'];
  /** Street name */
  streetName: Scalars['String']['input'];
  /** Street number */
  streetNumber: Scalars['String']['input'];
  /** Suburb */
  suburb: Scalars['String']['input'];
  /** Unit or apartment number */
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationUpdateApplicationWorkflowExecutionInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Execution ID */
  executionId: Scalars['String']['input'];
  /** Workflow progress */
  progress?: InputMaybe<AccreditationWorkflowProgressInput>;
  /** Workflow execution status */
  status?: AccreditationExecutionStatus;
  /** Workflow ID */
  workflowId: Scalars['String']['input'];
  /** Workflow report data */
  workflowReport?: InputMaybe<Scalars['AccreditationJSONObject']['input']>;
};

export type AccreditationUpdateAuthorisedPersonnelInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Authorised personnel */
  individuals: Array<AccreditationCreateIndividualInput>;
};

export type AccreditationUpdateDocumentStatusInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Document status updates */
  documents: Array<AccreditationDocumentStatusUpdateInput>;
};

export type AccreditationUpdatePaymentDetailsInput = {
  /** Account branch name */
  accountBranch?: InputMaybe<Scalars['String']['input']>;
  /** Account BSB */
  accountBsb: Scalars['String']['input'];
  /** Account financial institution name */
  accountFinancialInstitution?: InputMaybe<Scalars['String']['input']>;
  /** Account name */
  accountName: Scalars['String']['input'];
  /** Account number */
  accountNumber: Scalars['String']['input'];
  /** Application ID */
  applicationId: Scalars['String']['input'];
};

export type AccreditationUpdateProductAndServiceInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Energy tech seller status */
  energyTechSeller?: InputMaybe<Scalars['Boolean']['input']>;
  /** Finance providers */
  financeProviders?: InputMaybe<Scalars['String']['input']>;
  /** Types of finance interested in offering */
  financeTypes: Array<AccreditationFinanceType>;
  /** Installer engagement type */
  installerEngagement?: InputMaybe<AccreditationInstallerEngagement>;
  /** Installers accredited by SAA */
  installersAccreditedSaa?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is finance provider */
  isFinanceProvider: Scalars['Boolean']['input'];
  /** Product offerings (multiselect) */
  productOfferings: Array<Scalars['String']['input']>;
  /** Scope of service area (dropdown) */
  scopeOfServiceArea: AccreditationCoverageArea;
  /** Target markets for business operations (multiselect) */
  targetMarket: Array<Scalars['String']['input']>;
};

export type AccreditationUpdateTeamAndPipelineInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Average deal size */
  avgDealSize: Scalars['Float']['input'];
  /** How did the user generate Leads */
  leadGenMethod: Array<AccreditationLeadGenMethod>;
  /** Number of contractors */
  numberOfContractors: AccreditationNumberOfEmployees;
  /** Number of employees */
  numberOfEmployees: AccreditationNumberOfEmployees;
  /** Number of Installation */
  numberOfInstallation: AccreditationNumberOfPipeline;
  /** Number of Lead */
  numberOfLead: AccreditationNumberOfPipeline;
  /** Number of Quote */
  numberOfQuote: AccreditationNumberOfPipeline;
  /** Number of sale agents */
  numberOfSaleAgents: AccreditationNumberOfEmployees;
};

export type AccreditationVerifyPasswordlessCodeInput = {
  /** Verification code received via email */
  code: Scalars['String']['input'];
  /** User email address */
  email: Scalars['String']['input'];
};

export type AccreditationVerifyPasswordlessCodeResponse = {
  __typename?: 'AccreditationVerifyPasswordlessCodeResponse';
  /** Access token for API authentication */
  accessToken: Scalars['String']['output'];
  /** Expires in */
  expiresIn: Scalars['Float']['output'];
  /** ID token */
  idToken: Scalars['String']['output'];
  /** Refresh token */
  refreshToken: Scalars['String']['output'];
  /** Token type */
  tokenType: Scalars['String']['output'];
};

export type AccreditationViewDocumentInput = {
  /** Application ID */
  applicationId: Scalars['String']['input'];
  /** Document ID */
  documentId: Scalars['String']['input'];
};

/** Workflow progress tracking */
export type AccreditationWorkflowProgress = {
  __typename?: 'AccreditationWorkflowProgress';
  /** Progress description */
  description?: Maybe<Scalars['String']['output']>;
  /** Progress label */
  label?: Maybe<Scalars['String']['output']>;
  /** Progress indicator (e.g., "Step 2 of 5") */
  progress?: Maybe<Scalars['String']['output']>;
};

/** Workflow progress input */
export type AccreditationWorkflowProgressInput = {
  /** Progress description */
  description: Scalars['String']['input'];
  /** Progress label */
  label: Scalars['String']['input'];
  /** Progress indicator (e.g., "Step 2 of 5") */
  progress: Scalars['String']['input'];
};

export type ActivateVendorUserInput = {
  id: Scalars['String']['input'];
};

export enum ActivationStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Pending = 'PENDING',
}

export enum ActivityLogAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Lock = 'LOCK',
  Unlock = 'UNLOCK',
  Update = 'UPDATE',
}

export enum ActorRole {
  Admin = 'ADMIN',
  AdminOperations = 'ADMIN_OPERATIONS',
  Manager = 'MANAGER',
  Service = 'SERVICE',
  Superadmin = 'SUPERADMIN',
  Team = 'TEAM',
  Vendor = 'VENDOR',
}

export type AddVendorUserInput = {
  /** Vendor public ids to make the user the authority contact for (subset of vendorsToAdd). */
  authorityContactsToSet?: InputMaybe<Array<Scalars['String']['input']>>;
  /** User's email — must not already exist; used to create a new user profile in the Users service. */
  email: Scalars['String']['input'];
  /** User's first name. */
  firstName: Scalars['String']['input'];
  /** User's last name. */
  lastName: Scalars['String']['input'];
  /** User's Australian mobile number. */
  mobile: Scalars['String']['input'];
  /** Role to create the user with. Only VENDOR and TEAM are valid for a vendor user. */
  role: VendorUserRoleName;
  /** Vendor public ids to link the user to (at least one), for example E81. */
  vendorsToAdd: Array<Scalars['String']['input']>;
};

export type AddVendorUserIssueNoteInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  resolution?: InputMaybe<Scalars['Float']['input']>;
  userIssueId: Scalars['Float']['input'];
};

export type AddVendorUserResult = {
  __typename?: 'AddVendorUserResult';
  memberships: Array<VendorUserVendorLink>;
  userId: Scalars['ID']['output'];
};

export type AdditionalIncome = {
  __typename?: 'AdditionalIncome';
  amount: Scalars['Float']['output'];
  bankStatementToken?: Maybe<Scalars['String']['output']>;
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  period: Period;
};

export type AdditionalIncomeInput = {
  amount: Scalars['Float']['input'];
  bankStatementToken?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: Period;
};

export type Address = {
  __typename?: 'Address';
  postcode: Scalars['String']['output'];
  state: AddressState;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  postcode: Scalars['String']['input'];
  state: AddressState;
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum AddressState {
  Act = 'ACT',
  Nsw = 'NSW',
  Nt = 'NT',
  Qld = 'QLD',
  Sa = 'SA',
  Tas = 'TAS',
  Vic = 'VIC',
  Wa = 'WA',
}

export type AddressSuggestionsInput = {
  query: Scalars['String']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type AddressSuggestionsResult = {
  __typename?: 'AddressSuggestionsResult';
  formattedAddress?: Maybe<Scalars['String']['output']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  postcode: Scalars['String']['output'];
  state: AddressState;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export enum AddressValidationStatus {
  Mismatch = 'MISMATCH',
  NotFound = 'NOT_FOUND',
  Validated = 'VALIDATED',
}

export type AddressesInput = {
  query: Scalars['String']['input'];
};

export type AddressesResult = {
  __typename?: 'AddressesResult';
  country?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type Agent = {
  __typename?: 'Agent';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type AggregatedIncomeResult = {
  __typename?: 'AggregatedIncomeResult';
  analysisMetadata: AnalysisMetadata;
  incomeClusters: Array<IncomeClusterResult>;
  openBankingConsentId?: Maybe<Scalars['String']['output']>;
  totalMonthlyIncome: Scalars['Float']['output'];
};

export type AnalysisMetadata = {
  __typename?: 'AnalysisMetadata';
  dateRange: DateRange;
  overallConfidence: Scalars['Float']['output'];
  totalTransactions: Scalars['Int']['output'];
};

export type Applicant = {
  __typename?: 'Applicant';
  address?: Maybe<Address>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dependents?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  estimatedInstallationPeriod?: Maybe<Scalars['String']['output']>;
  expense?: Maybe<Expense>;
  firstName: Scalars['String']['output'];
  hesdClaimed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  identification?: Maybe<Identification>;
  income?: Maybe<Income>;
  /** @deprecated This field is going to be removed in the future. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  isConcessionCardHolder?: Maybe<Scalars['Boolean']['output']>;
  isCurrentAddress?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  maritalStatus?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nathersAssessment?: Maybe<Scalars['Boolean']['output']>;
  nonHomeOwnerCheck?: Maybe<Scalars['Boolean']['output']>;
  nswSafeguardClaimed?: Maybe<Scalars['Boolean']['output']>;
  openBankingConsentId?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['String']['output']>;
  ownProperty?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  previousAddress?: Maybe<Address>;
  replacesExistingEquipment?: Maybe<Scalars['Boolean']['output']>;
  secureCode?: Maybe<Scalars['String']['output']>;
  sresClaimed?: Maybe<Scalars['Boolean']['output']>;
  status: ApplicantStatus;
  termsAndConditions?: Maybe<TermsAndConditions>;
  type: ApplicantType;
  unsolicitedSaleOptions?: Maybe<Scalars['String']['output']>;
  usingOpenBanking?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicantInput = {
  address?: InputMaybe<AddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  dependents?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employment?: InputMaybe<EmploymentInput>;
  estimatedInstallationPeriod?: InputMaybe<Scalars['String']['input']>;
  expense?: InputMaybe<ExpenseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hesdClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identification?: InputMaybe<IdentificationInput>;
  income?: InputMaybe<IncomeInput>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isConcessionCardHolder?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentAddress?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nathersAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  nonHomeOwnerCheck?: InputMaybe<Scalars['Boolean']['input']>;
  nswSafeguardClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  openBankingConsentId?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  previousAddress?: InputMaybe<AddressInput>;
  replacesExistingEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  secureCode?: InputMaybe<Scalars['String']['input']>;
  sresClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ApplicantStatus>;
  termsAndConditions?: InputMaybe<TermsAndConditionsInput>;
  type: ApplicantType;
  unsolicitedSaleOptions?: InputMaybe<Scalars['String']['input']>;
  usingOpenBanking?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ApplicantStatus {
  Accepted = 'Accepted',
  Approved = 'Approved',
  Declined = 'Declined',
  Draft = 'Draft',
  Specified = 'Specified',
  Submitted = 'Submitted',
}

export enum ApplicantType {
  Joint = 'Joint',
  Primary = 'Primary',
}

export type Application = {
  __typename?: 'Application';
  address?: Maybe<InstallationAddress>;
  approved?: Maybe<Scalars['DateTime']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  documentRequests: Array<DocumentRequest>;
  documents: Array<ApplicationDocument>;
  enterprise?: Maybe<Enterprise>;
  financedAmount: Scalars['Float']['output'];
  financialProduct?: Maybe<FinancialProduct>;
  hasJointApplicant?: Maybe<Scalars['Boolean']['output']>;
  hasVulnerableApplicant?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  jointApplicant?: Maybe<Applicant>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<PaymentDetails>;
  primaryApplicant: Applicant;
  primarySignatoryEmail?: Maybe<Scalars['String']['output']>;
  primarySignatoryName?: Maybe<Scalars['String']['output']>;
  productConfiguration?: Maybe<ProductConfiguration>;
  promotionDiscount?: Maybe<Scalars['Float']['output']>;
  purchaseAmount?: Maybe<Scalars['Float']['output']>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount?: Maybe<Scalars['Float']['output']>;
  repaymentTerm?: Maybe<RepaymentTerm>;
  secondarySignatoryEmail?: Maybe<Scalars['String']['output']>;
  secondarySignatoryName?: Maybe<Scalars['String']['output']>;
  status: ApplicationFormStatus;
  subStatus?: Maybe<Scalars['String']['output']>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  withdrawReason?: Maybe<Scalars['String']['output']>;
  withdrawn?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicationDocument = {
  __typename?: 'ApplicationDocument';
  applicationId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  entityType: ApplicationEntityType;
  fileSize: Scalars['Float']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: DocumentStatus;
  type: ApplicationDocumentType;
  updated: Scalars['DateTime']['output'];
};

export type ApplicationDocumentInput = {
  applicationId: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  entityType: ApplicationEntityType;
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  id: Scalars['String']['input'];
  status: DocumentStatus;
  type: ApplicationDocumentType;
  updated: Scalars['DateTime']['input'];
};

export type ApplicationDocumentOperationInput = {
  applicationId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export enum ApplicationDocumentType {
  Identification = 'Identification',
  IncomeVerification = 'IncomeVerification',
  Others = 'Others',
}

export enum ApplicationEntityType {
  Application = 'Application',
  Joint = 'Joint',
  Primary = 'Primary',
}

export enum ApplicationFormStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Draft = 'Draft',
  Submitted = 'Submitted',
  Withdrawn = 'Withdrawn',
}

export type ApplicationQuote = {
  __typename?: 'ApplicationQuote';
  categorySlug: Scalars['String']['output'];
  depositAmount: Scalars['Float']['output'];
  expiryDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  parentQuotes: Array<QuotePackage>;
  promotionDiscount: Scalars['Float']['output'];
  quotePackages: Array<QuotePackage>;
  rebate: Scalars['Float']['output'];
  rebateDiscount: Scalars['Float']['output'];
  totalPurchaseAmount: Scalars['Float']['output'];
};

export type ApplicationStatus = {
  email: Scalars['String']['input'];
  statusGroups: Array<Scalars['String']['input']>;
};

export enum ApplicationStep {
  AddJointApplicant = 'AddJointApplicant',
  BeneficialOwner = 'BeneficialOwner',
  BusinessDetails = 'BusinessDetails',
  CreateApplication = 'CreateApplication',
  GuarantorDetails = 'GuarantorDetails',
  HouseholdDetails = 'HouseholdDetails',
  Identification = 'Identification',
  IncomeVerification = 'IncomeVerification',
  JointEligibility = 'JointEligibility',
  OwnershipDetails = 'OwnershipDetails',
  PaymentDetails = 'PaymentDetails',
  SubmitApplication = 'SubmitApplication',
}

export type Article = Entity &
  Node & {
    __typename?: 'Article';
    author?: Maybe<ArticleAuthor>;
    /** For SEO, this tells Google which Category the content belongs to. */
    category?: Maybe<HubCategory>;
    /** This is the old singular content block. */
    content?: Maybe<ArticleContentRichText>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<Article>;
    footnote?: Maybe<RichText>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of Article versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    image?: Maybe<Asset>;
    /** Displayed in the hero section alongside the article heading. */
    intro?: Maybe<Scalars['String']['output']>;
    meta?: Maybe<Meta>;
    /** Main content section. Stack components together to create richer content. */
    modularContent: Array<ArticlemodularContentUnion>;
    /** This preview text is displayed alongside the heading and image on links leading to this article. */
    previewOFF?: Maybe<Scalars['String']['output']>;
    publishDate?: Maybe<Scalars['DateTime']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    tags: Array<BlogArticleBlogCategories>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
    /** URL of the video to display in the hero section. This replaces the Hero Image if set. */
    video?: Maybe<Scalars['String']['output']>;
    /** Setting this article as unlisted will hide it from blog feeds and article lists. */
    visibility?: Maybe<Visibility>;
  };

export type ArticleAuthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ArticleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ArticleImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ArticleMetaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleModularContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticlePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ArticleTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleAuthor = Entity &
  Node & {
    __typename?: 'ArticleAuthor';
    bio?: Maybe<Scalars['String']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<ArticleAuthor>;
    /** List of ArticleAuthor versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    image?: Maybe<Asset>;
    name?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type ArticleAuthorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleAuthorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ArticleAuthorHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ArticleAuthorImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ArticleAuthorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleAuthorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ArticleAuthorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum ArticleAuthorOrderByInput {
  BioAsc = 'bio_ASC',
  BioDesc = 'bio_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** This contains a set of filters that can be used to compare values internally */
export type ArticleAuthorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ArticleAuthorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bio_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleAuthorWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleAuthorWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleAuthorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleAuthorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleAuthorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleAuthorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleAuthorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleAuthorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export type ArticleContentRichText = {
  __typename?: 'ArticleContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<ArticleContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type ArticleContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleContentRichTextEmbeddedTypes = Asset;

export type ArticleCuration = Entity &
  Node & {
    __typename?: 'ArticleCuration';
    article: Array<Article>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<ArticleCuration>;
    /** List of ArticleCuration versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Internal use only. Not displayed on the site. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type ArticleCurationArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleCurationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleCurationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ArticleCurationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ArticleCurationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleCurationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ArticleCurationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** References ArticleCuration record uniquely */
export type ArticleCurationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum ArticleOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IntroAsc = 'intro_ASC',
  IntroDesc = 'intro_DESC',
  PreviewOffAsc = 'previewOFF_ASC',
  PreviewOffDesc = 'previewOFF_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VideoAsc = 'video_ASC',
  VideoDesc = 'video_DESC',
  VisibilityAsc = 'visibility_ASC',
  VisibilityDesc = 'visibility_DESC',
}

export type ArticleTag = Entity &
  Node & {
    __typename?: 'ArticleTag';
    articles: Array<Article>;
    blogTag?: Maybe<Scalars['Boolean']['output']>;
    careersTag?: Maybe<Scalars['Boolean']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<ArticleTag>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of ArticleTag versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    mediaTag?: Maybe<Scalars['Boolean']['output']>;
    /** Primary tags are displayed in the blog navigation. Whereas non-primary tags are only included as hashtags on articles to group similar content. */
    primaryTag?: Maybe<Scalars['Boolean']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    solarTag?: Maybe<Scalars['Boolean']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type ArticleTagArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleTagCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleTagDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ArticleTagHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ArticleTagPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleTagScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ArticleTagUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** This contains a set of filters that can be used to compare values internally */
export type ArticleTagWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ArticleTagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  blogTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  blogTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  careersTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  careersTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleTagWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleTagWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleTagWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mediaTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  mediaTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  primaryTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  primaryTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  solarTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  solarTag_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleTagWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleTagWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleTagWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleTagWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleTagWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** This contains a set of filters that can be used to compare values internally */
export type ArticleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ArticleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<ArticleAuthorWhereInput>;
  category?: InputMaybe<HubCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<MetaWhereInput>;
  /** All values in which the union is empty. */
  modularContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modularContent_some?: InputMaybe<ArticlemodularContentUnionWhereInput>;
  previewOFF?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  previewOFF_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  previewOFF_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  previewOFF_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  previewOFF_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  previewOFF_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  previewOFF_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  previewOFF_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  previewOFF_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  previewOFF_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  tags_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  tags_some?: InputMaybe<BlogArticleBlogCategoriesWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Visibility>;
  /** All values that are contained in given list. */
  visibility_in?: InputMaybe<Array<InputMaybe<Visibility>>>;
  /** Any other value that exists and is not equal to the given value. */
  visibility_not?: InputMaybe<Visibility>;
  /** All values that are not contained in given list. */
  visibility_not_in?: InputMaybe<Array<InputMaybe<Visibility>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export type ArticlemodularContentUnion =
  | AccordionGroup
  | Button
  | Content
  | Footnote
  | HtmlBlock
  | HeadingNumber
  | HyGraphImage
  | VideoVimeo
  | VideoYouTube;

export type ArticlemodularContentUnionWhereInput = {
  AccordionGroup?: InputMaybe<AccordionGroupWhereInput>;
  Button?: InputMaybe<ButtonWhereInput>;
  Content?: InputMaybe<ContentWhereInput>;
  Footnote?: InputMaybe<FootnoteWhereInput>;
  HTMLBlock?: InputMaybe<HtmlBlockWhereInput>;
  HeadingNumber?: InputMaybe<HeadingNumberWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  VideoVimeo?: InputMaybe<VideoVimeoWhereInput>;
  VideoYouTube?: InputMaybe<VideoYouTubeWhereInput>;
};

/** Asset system model */
export type Asset = Entity &
  Node & {
    __typename?: 'Asset';
    /** Describes the image - https://www.w3.org/WAI/tutorials/images/decision-tree/ */
    alt?: Maybe<Scalars['String']['output']>;
    /** Optional - displayed below the image */
    caption?: Maybe<Scalars['String']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    detailImageProductCategory: Array<ProductCategory>;
    /** Get the document in other stages */
    documentInStages: Array<Asset>;
    /** The file name */
    fileName: Scalars['String']['output'];
    /** The file handle */
    handle: Scalars['String']['output'];
    /** The height of the file */
    height?: Maybe<Scalars['Float']['output']>;
    heroImageProductCategory: Array<ProductCategory>;
    /** List of Asset versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    imageArticle: Array<Article>;
    imageArticleAuthor: Array<ArticleAuthor>;
    imageHubCategory: Array<HubCategory>;
    /** System Locale field */
    locale: Locale;
    /** Get the other localizations for this document */
    localizations: Array<Asset>;
    /** The mime type of the file */
    mimeType?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    sharingImageProductCategory: Array<ProductCategory>;
    /** The file size */
    size?: Maybe<Scalars['Float']['output']>;
    /** System stage field */
    stage: Stage;
    tags: Array<ImageTags>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
    /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
    upload?: Maybe<AssetUpload>;
    /** Get the url for the asset with provided transformations applied. */
    url: Scalars['String']['output'];
    /** The file width */
    width?: Maybe<Scalars['Float']['output']>;
  };

/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetDetailImageProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Asset system model */
export type AssetHeroImageProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

/** Asset system model */
export type AssetImageArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

/** Asset system model */
export type AssetImageArticleAuthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleAuthorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleAuthorWhereInput>;
};

/** Asset system model */
export type AssetImageHubCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};

/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Asset system model */
export type AssetSharingImageProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  AssetCreatePending = 'ASSET_CREATE_PENDING',
  AssetErrorUpload = 'ASSET_ERROR_UPLOAD',
  AssetUpdatePending = 'ASSET_UPDATE_PENDING',
  AssetUploadComplete = 'ASSET_UPLOAD_COMPLETE',
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  alt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  alt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  alt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  alt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  alt_starts_with?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  detailImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  detailImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  detailImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  heroImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  heroImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  heroImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageArticleAuthor_every?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticleAuthor_none?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticleAuthor_some?: InputMaybe<ArticleAuthorWhereInput>;
  imageArticle_every?: InputMaybe<ArticleWhereInput>;
  imageArticle_none?: InputMaybe<ArticleWhereInput>;
  imageArticle_some?: InputMaybe<ArticleWhereInput>;
  imageHubCategory_every?: InputMaybe<HubCategoryWhereInput>;
  imageHubCategory_none?: InputMaybe<HubCategoryWhereInput>;
  imageHubCategory_some?: InputMaybe<HubCategoryWhereInput>;
  imageMobilePromotion_every?: InputMaybe<PromotionWhereInput>;
  imageMobilePromotion_none?: InputMaybe<PromotionWhereInput>;
  imageMobilePromotion_some?: InputMaybe<PromotionWhereInput>;
  imagePromotion_every?: InputMaybe<PromotionWhereInput>;
  imagePromotion_none?: InputMaybe<PromotionWhereInput>;
  imagePromotion_some?: InputMaybe<PromotionWhereInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sharingImageProductCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  sharingImageProductCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  sharingImageProductCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  tags?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array contains *all* items provided to the filter */
  tags_contains_all?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  tags_contains_none?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array contains at least one item provided to the filter */
  tags_contains_some?: InputMaybe<Array<ImageTags>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  tags_not?: InputMaybe<Array<ImageTags>>;
  termsDocumentPromotion_every?: InputMaybe<PromotionWhereInput>;
  termsDocumentPromotion_none?: InputMaybe<PromotionWhereInput>;
  termsDocumentPromotion_some?: InputMaybe<PromotionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export type AssignVendorLeadsInput = {
  agentId: Scalars['String']['input'];
  leadIds: Array<Scalars['Float']['input']>;
  vendorId: Scalars['String']['input'];
};

export type Association = {
  __typename?: 'Association';
  chairman: Array<EnterpriseIdentityWithIdentification>;
  secretary: Array<EnterpriseIdentityWithIdentification>;
  treasurer: Array<EnterpriseIdentityWithIdentification>;
};

export type AssociationInput = {
  chairman: Array<EnterpriseIdentityWithIdentificationInput>;
  secretary: Array<EnterpriseIdentityWithIdentificationInput>;
  treasurer: Array<EnterpriseIdentityWithIdentificationInput>;
};

export type AuthenticatePasswordlessUserByEmailInput = {
  /** audience */
  audience: Scalars['String']['input'];
  /** code */
  code: Scalars['String']['input'];
  /** email */
  email: Scalars['String']['input'];
  /** scope */
  scope: Scalars['String']['input'];
};

export type AuthenticatePasswordlessUserBySmsInput = {
  /** audience */
  audience: Scalars['String']['input'];
  /** code */
  code: Scalars['String']['input'];
  /** mobile number */
  mobile: Scalars['String']['input'];
  /** scope */
  scope: Scalars['String']['input'];
};

export type AuthenticatePasswordlessUserResponse = {
  __typename?: 'AuthenticatePasswordlessUserResponse';
  /** Access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Expiry time */
  expiresIn?: Maybe<Scalars['Int']['output']>;
  /** Id token */
  idToken?: Maybe<Scalars['String']['output']>;
  /** Refresh token */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** Scope */
  scope?: Maybe<Scalars['String']['output']>;
  /** Token type */
  tokenType?: Maybe<Scalars['String']['output']>;
};

/** Authentication FLow Type */
export enum AuthenticationFlowType {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export type AuthorityContact = {
  __typename?: 'AuthorityContact';
  activeFrom: Scalars['DateTime']['output'];
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<VendorPublicUser>;
  userId: Scalars['ID']['output'];
};

export type BackfillAuthorityContactsResult = {
  __typename?: 'BackfillAuthorityContactsResult';
  results: Array<BackfillRowResult>;
};

export type BackfillExistingAuthorityContactRow = {
  /** Historical authority-contact start date (backdated activeFrom + event appliedAt). */
  activeFrom: Scalars['DateTime']['input'];
  /** Existing U-prefixed user public id, for example U142173. */
  userId: Scalars['String']['input'];
  /** Vendor public id to link + set the authority contact on, for example E81. */
  vendorId: Scalars['String']['input'];
};

export type BackfillExistingAuthorityContactsInput = {
  /** Operator-supplied run/chunk label echoed into every server log line (Datadog correlation). */
  batchRef: Scalars['String']['input'];
  /** Rows to backfill (1–50); the array length is the chunk size. */
  rows: Array<BackfillExistingAuthorityContactRow>;
};

export type BackfillNewAuthorityContactRow = {
  /** Historical authority-contact start date (backdated activeFrom + event appliedAt). */
  activeFrom: Scalars['DateTime']['input'];
  /** New user's email — must be unique within the batch and not already exist. */
  email: Scalars['String']['input'];
  /** New user's first name. */
  firstName: Scalars['String']['input'];
  /** New user's last name. */
  lastName: Scalars['String']['input'];
  /** New user's Australian mobile number. */
  mobile: Scalars['String']['input'];
  /** Vendor public id to link + set the authority contact on, for example E81. */
  vendorId: Scalars['String']['input'];
};

export type BackfillNewAuthorityContactsInput = {
  /** Operator-supplied run/chunk label echoed into every server log line (Datadog correlation). */
  batchRef: Scalars['String']['input'];
  /** Rows to backfill (1–50); the array length is the chunk size. */
  rows: Array<BackfillNewAuthorityContactRow>;
};

export type BackfillRowResult = {
  __typename?: 'BackfillRowResult';
  error?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  status: BackfillRowStatus;
  vendorId: Scalars['String']['output'];
};

export enum BackfillRowStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Skipped = 'SKIPPED',
}

export type BankStatementIframe = {
  __typename?: 'BankStatementIframe';
  expired: Scalars['String']['output'];
  expiry: Scalars['String']['output'];
  id: Scalars['String']['output'];
  iframeLink: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type BaseIdentity = {
  __typename?: 'BaseIdentity';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
};

export type BaseIncome = {
  __typename?: 'BaseIncome';
  amount: Scalars['Float']['output'];
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  period: Period;
};

export type BaseIncomeInput = {
  amount: Scalars['Float']['input'];
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: Period;
};

export type BaseVendor = {
  __typename?: 'BaseVendor';
  id: Scalars['String']['output'];
  /** @deprecated Use id instead */
  legacyId: Scalars['Float']['output'];
  manager?: Maybe<VendorManager>;
  name: Scalars['String']['output'];
};

export type BlogArticleBlogCategories = ArticleTag;

export type BlogArticleBlogCategoriesWhereInput = {
  ArticleTag?: InputMaybe<ArticleTagWhereInput>;
};

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Brand = {
  __typename?: 'Brand';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  type: BrandType;
};

export enum BrandType {
  /** Manufacturer */
  Manufacturer = 'Manufacturer',
  /** Referrer */
  Referrer = 'Referrer',
}

export type BrandsFilter = {
  type?: InputMaybe<StringFilter>;
};

export type BrandsSort = {
  name?: InputMaybe<SortDir>;
};

export type BusinessCustomer = {
  __typename?: 'BusinessCustomer';
  acn?: Maybe<Scalars['String']['output']>;
  applicantEmail?: Maybe<Scalars['String']['output']>;
  applicantFirstName?: Maybe<Scalars['String']['output']>;
  applicantLastName?: Maybe<Scalars['String']['output']>;
  applicantMobile?: Maybe<Scalars['String']['output']>;
  associationNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  structure?: Maybe<Scalars['String']['output']>;
};

export type Button = Entity & {
  __typename?: 'Button';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  theme?: Maybe<Theme>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

/** Identifies documents */
export type ButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type CsvExportJobResponse = {
  __typename?: 'CSVExportJobResponse';
  downloadUrl: Scalars['String']['output'];
};

export type CsvExportRequestInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CallerIdentity = {
  __typename?: 'CallerIdentity';
  id: Scalars['String']['output'];
};

export type CancelOpenbankingConsentDto = {
  __typename?: 'CancelOpenbankingConsentDto';
  success: Scalars['Boolean']['output'];
};

export type CancelQuoteInput = {
  id: Scalars['Int']['input'];
};

export type CancelQuoteResponse = {
  __typename?: 'CancelQuoteResponse';
  abn?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  account?: Maybe<Account>;
  /** @deprecated Legacy numeric identifier retained for deep-links to the legacy admin portal. Use `account.id` for new integrations. */
  accountLegacyId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<QuoteAddressType>;
  agent: Employee;
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  category: Category;
  categoryComponents: CategoryComponent;
  concessionType?: Maybe<ConcessionType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: QuoteCustomer;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  /** @deprecated Energy bundle is no longer offered */
  energyBundle?: Maybe<Scalars['Boolean']['output']>;
  enterprisePartner?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  evChargerManufacturer?: Maybe<Manufacturer>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  insulationType?: Maybe<InsulationType>;
  /** @deprecated Use `productConfiguration` instead */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  introducerFee: Scalars['Float']['output'];
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  nationalMeterIdentifier?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nonProfit?: Maybe<Scalars['Boolean']['output']>;
  /** Required scopes: read:finance-quotes */
  oauthClientId?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  /** @deprecated Use `opportunity` instead */
  opportunityCategories?: Maybe<Array<OpportunityCategory>>;
  /** @deprecated Use `opportunity` instead */
  opportunityId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Payment stages are no longer offered */
  paymentStages?: Maybe<Array<Scalars['Float']['output']>>;
  /** @deprecated replaced with concessionType */
  pensionerType?: Maybe<ConcessionType>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productConfigVersion: Scalars['Float']['output'];
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  promotionDiscount: Scalars['Float']['output'];
  proposals?: Maybe<Array<Proposal>>;
  /** @deprecated Use `categoryComponents` instead */
  purchaseItems: Array<PurchaseItem>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  quote: Quote;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  recipient?: Maybe<BaseIdentity>;
  referenceNumber: Scalars['String']['output'];
  relatedQuotes?: Maybe<Array<RelatedQuote>>;
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  repaymentTerm?: Maybe<Scalars['Int']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  resendDate?: Maybe<Scalars['DateTime']['output']>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  stoveType?: Maybe<StoveType>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalPurchaseAmount: Scalars['Float']['output'];
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export type CancelReferralInput = {
  id: Scalars['ID']['input'];
};

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  cardExpiry?: Maybe<Scalars['String']['output']>;
  cardHolder?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type: PaymentType;
};

export type CashPaymentInput = {
  isCashApplication?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoriesFilter = {
  group?: InputMaybe<CategoryGroup>;
  isActive?: InputMaybe<BooleanFilter>;
  isParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<BooleanFilter>;
  marketplaceVisible?: InputMaybe<BooleanFilter>;
  search?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CategoriesSort = {
  displayOrder?: InputMaybe<SortDir>;
  group?: InputMaybe<SortDir>;
  icon?: InputMaybe<SortDir>;
  id?: InputMaybe<SortDir>;
  name?: InputMaybe<SortDir>;
  slug?: InputMaybe<SortDir>;
};

export type Category = {
  __typename?: 'Category';
  /** Required scopes: update:categories */
  accessFields?: Maybe<CategoryAccessFields>;
  financialProducts?: Maybe<Array<FinancialProduct>>;
  group?: Maybe<CategoryGroup>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  indicativePrice?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether this product category is compatible with the Origin virtual power plant (VPP) pilot. */
  isVirtualPowerPlantCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<Category>;
  slug: Scalars['String']['output'];
  subFields?: Maybe<Array<CategorySubFields>>;
  tags?: Maybe<Array<Tag>>;
};

export type CategoryAccessFields = {
  __typename?: 'CategoryAccessFields';
  isActive: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  marketplaceVisible: Scalars['Boolean']['output'];
};

export type CategoryComponent = {
  __typename?: 'CategoryComponent';
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturerName?: Maybe<Scalars['String']['output']>;
  batteryManufacturerSlug?: Maybe<Scalars['String']['output']>;
  batteryModelNumber?: Maybe<Scalars['String']['output']>;
  ceiling?: Maybe<Scalars['Boolean']['output']>;
  doubleGlazingWindowsManufacturerSlug?: Maybe<Scalars['String']['output']>;
  doubleGlazingWindowsModelNumber?: Maybe<Scalars['String']['output']>;
  doubleGlazingWindowsUValue?: Maybe<Scalars['Float']['output']>;
  electricCargoBikeManufacturerName?: Maybe<Scalars['String']['output']>;
  electricCargoBikeModelNumber?: Maybe<Scalars['String']['output']>;
  electricHeatingCoolingManufacturerSlug?: Maybe<Scalars['String']['output']>;
  electricHeatingCoolingModelNumber?: Maybe<Scalars['String']['output']>;
  evChargerManufacturerSlug?: Maybe<Scalars['String']['output']>;
  evChargerModelNumber?: Maybe<Scalars['String']['output']>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Boolean']['output']>;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<Scalars['String']['output']>;
  hotWaterHeatPumpManufacturerSlug?: Maybe<Scalars['String']['output']>;
  hotWaterHeatPumpModelNumber?: Maybe<Scalars['String']['output']>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  inductionCooktopManufacturerName?: Maybe<Scalars['String']['output']>;
  inductionCooktopModelNumber?: Maybe<Scalars['String']['output']>;
  inductionCooktopPermanentInstallAgreement?: Maybe<Scalars['Boolean']['output']>;
  insulationType?: Maybe<Scalars['String']['output']>;
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturerName?: Maybe<Scalars['String']['output']>;
  inverterManufacturerSlug?: Maybe<Scalars['String']['output']>;
  inverterModelNumber?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  panelModelNumber?: Maybe<Scalars['String']['output']>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturerName?: Maybe<Scalars['String']['output']>;
  pvPanelManufacturerSlug?: Maybe<Scalars['String']['output']>;
  solarHotWaterManufacturerSlug?: Maybe<Scalars['String']['output']>;
  solarHotWaterModelNumber?: Maybe<Scalars['String']['output']>;
  stoveType?: Maybe<Scalars['String']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  walls?: Maybe<Scalars['Boolean']['output']>;
};

/** Determines if vendors must match ALL categories or just SOME of the requested categories in marketplace filters */
export enum CategoryFilterMode {
  All = 'ALL',
  Some = 'SOME',
}

export enum CategoryGroup {
  Green = 'Green',
  HomeImprovement = 'HomeImprovement',
  Lifestyle = 'Lifestyle',
}

export type CategoryPromotion = {
  __typename?: 'CategoryPromotion';
  category: Category;
  categorySlug: Scalars['String']['output'];
};

export type CategorySubFields = {
  __typename?: 'CategorySubFields';
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type CcaConfirmationResultDto = {
  __typename?: 'CcaConfirmationResultDto';
  confirmed: Scalars['Boolean']['output'];
};

export type CcaMetadata = {
  location?: InputMaybe<Location>;
};

export type Company = {
  __typename?: 'Company';
  beneficialOwners?: Maybe<Array<EnterpriseIdentityWithIdentification>>;
  directors?: Maybe<Array<EnterpriseBaseIdentity>>;
  ownershipType: OwnershipType;
};

export type CompanyInput = {
  beneficialOwners?: InputMaybe<Array<EnterpriseIdentityWithIdentificationInput>>;
  directors?: InputMaybe<Array<EnterpriseBaseIdentityInput>>;
  ownershipType: OwnershipType;
};

export type CompleteEnrollmentForUserInput = {
  completed?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum ConcessionType {
  HealthCareCard = 'HEALTH_CARE_CARD',
  PensionerConcessionCard = 'PENSIONER_CONCESSION_CARD',
  VeteransGoldCard = 'VETERANS_GOLD_CARD',
}

export type ConsumerEnergyResourcesComponent = {
  __typename?: 'ConsumerEnergyResourcesComponent';
  manufacturer: Scalars['String']['output'];
  modelNumber: Scalars['String']['output'];
  type: ConsumerEnergyResourcesComponentType;
};

/** The type of component (panel, battery, inverter, ev-charging, hot-water-heat-pump, or electric-heating-and-cooling) */
export enum ConsumerEnergyResourcesComponentType {
  Battery = 'BATTERY',
  ElectricHeatingAndCooling = 'ELECTRIC_HEATING_AND_COOLING',
  EvCharging = 'EV_CHARGING',
  HotWaterHeatPump = 'HOT_WATER_HEAT_PUMP',
  Inverter = 'INVERTER',
  Panel = 'PANEL',
}

export type ConsumerEnergyResourcesComponentsFilter = {
  manufacturer: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  type: ConsumerEnergyResourcesComponentType;
};

export type ContactFormConfig = {
  __typename?: 'ContactFormConfig';
  /** Fields this channel adds to the contact form, in render order. Empty = no channel-specific fields. Replaces the deprecated partner-level `customerIdRequirement`, which only ever described one field. */
  fields: Array<ContactFormFieldConfig>;
};

export type ContactFormFieldConfig = {
  __typename?: 'ContactFormFieldConfig';
  /** Helper text shown under the input, e.g. "This is your 16-digit membership number". */
  description?: Maybe<Scalars['String']['output']>;
  /** Leading icon asset name, resolved by consumers against their partner asset base as "<name>.svg", e.g. "racq-membership". Null/omitted = no icon. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Why this channel is asking for the field, where `description` says what to put in it. Shown alongside `description` rather than replacing it. One entry per paragraph — consumers space them apart rather than joining them. Null/omitted = nothing extra. */
  infoMessage?: Maybe<Array<Scalars['String']['output']>>;
  /** Field label, e.g. "RACQ membership number". */
  label?: Maybe<Scalars['String']['output']>;
  /** Input mask, where "0" = digit, "A" = letter, "*" = alphanumeric and any other character is a literal separator, e.g. "0000 0000 0000 0000". Consumers also show it as the input placeholder, so it does not need repeating. Null/omitted = unmasked free text. */
  mask?: Maybe<Scalars['String']['output']>;
  /** Contact-form field this entry configures, e.g. "partnerCustomerId". Consumers ignore names they do not recognise. */
  name: Scalars['String']['output'];
  /** Whether the field must be filled in. Null/omitted = false (the field is optional). */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Checks to run against the value, in order — the first failure wins. Consumers show a message built from `label`. Null/omitted = the field is accepted as typed. */
  validation?: Maybe<Array<ContactFormValidation>>;
};

export type ContactFormValidation = {
  __typename?: 'ContactFormValidation';
  /** For type "pattern": regex flags, e.g. "i" for a case-insensitive match. Null/omitted = none. JavaScript has no inline flag syntax, so a pattern that must ignore case has to say so here. */
  flags?: Maybe<Scalars['String']['output']>;
  /** For type "pattern": anchored regex source the value must match, e.g. "^\\d{16}$". Mask separators are stripped before matching. */
  pattern?: Maybe<Scalars['String']['output']>;
  /** For type "remote": selects the consumer-side validator that calls the partner API, e.g. "racq". Remote checks need credentials, so only the selector lives in config. */
  provider?: Maybe<Scalars['String']['output']>;
  /** How to check the value: "pattern" (client-side regex) | "remote" (server-side lookup). Consumers ignore types they do not implement. */
  type: Scalars['String']['output'];
};

export type Content = Entity & {
  __typename?: 'Content';
  content?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Identifies documents */
export type ContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type Course = {
  __typename?: 'Course';
  bannerDescription?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  enrollments?: Maybe<Array<Maybe<Enrollment>>>;
  externalId: Scalars['String']['output'];
  financialProductIds?: Maybe<Array<Scalars['String']['output']>>;
  financialProducts: Array<TrainingFinancialProduct>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  roles: Array<RoleName>;
  startDate?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type CourseEnrollmentResponse = {
  __typename?: 'CourseEnrollmentResponse';
  message: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  status: EnrollmentStatus;
};

export type CourseFilter = {
  financialProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<RoleName>>>;
};

export type CreateApplicantInput = {
  estimatedInstallationPeriod?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  /** Home Energy Saver Discount */
  hesdClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentAddress?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** NatHERS Assessment */
  nathersAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  nonHomeOwnerCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** NSW Safeguard incentives */
  nswSafeguardClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>;
  previousAddress?: InputMaybe<AddressInput>;
  /** Replaces existing equipment */
  replacesExistingEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Small-scale Technology Certificates */
  sresClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions?: InputMaybe<TermsAndConditionsInput>;
  type: ApplicantType;
  unsolicitedSaleOptions?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationDocumentInput = {
  applicationId: Scalars['String']['input'];
  declaredDocumentType?: InputMaybe<RequestedDocumentType>;
  documentRequestId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<ApplicationEntityType>;
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  type?: InputMaybe<ApplicationDocumentType>;
};

export type CreateApplicationDocumentResult = {
  __typename?: 'CreateApplicationDocumentResult';
  document: ApplicationDocument;
  fieldsJson?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicationFromQuoteInput = {
  address: AddressInput;
  applicant: CreateApplicantInput;
  customerType: CustomerType;
  financialProductId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  payment?: InputMaybe<CashPaymentInput>;
  relatedQuotesInput?: InputMaybe<Array<RelatedQuotesInput>>;
  repaymentTerm?: InputMaybe<RepaymentTermInput>;
  status: ApplicationFormStatus;
  step: ApplicationStep;
};

export type CreateCategoryDataInput = {
  accessFields: AccessFields;
  financialProductSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  group: CategoryGroup;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentCategorySlug?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCategoryResponse = {
  __typename?: 'CreateCategoryResponse';
  category: Category;
};

export type CreateCourseInput = {
  bannerDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  financialProducts: Array<TrainingFinancialProductInput>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  roles: Array<RoleName>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDocumentInputDto = {
  accountId: Scalars['String']['input'];
  documentType: CustomerDocumentTypes;
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
};

export type CreateDocumentResultDto = {
  __typename?: 'CreateDocumentResultDto';
  document: Document;
  fieldsJson?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateEnrollmentInput = {
  courseId: Scalars['String']['input'];
};

export type CreateEnrollmentResponse = {
  __typename?: 'CreateEnrollmentResponse';
  completed?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Course>;
  courseId: Scalars['String']['output'];
  created?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  status: EnrollmentStatus;
  updated?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type CreateJointApplicantInput = {
  applicationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  step: ApplicationStep;
};

export type CreateManufacturerInput = {
  battery: Scalars['Boolean']['input'];
  batteryPremium?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  electricHeatingAndCooling: Scalars['Boolean']['input'];
  electricHeatingAndCoolingPremium?: InputMaybe<Scalars['Boolean']['input']>;
  evCharging: Scalars['Boolean']['input'];
  evChargingPremium?: InputMaybe<Scalars['Boolean']['input']>;
  glazingWindow: Scalars['Boolean']['input'];
  glazingWindowPremium?: InputMaybe<Scalars['Boolean']['input']>;
  hotWaterHeatPump: Scalars['Boolean']['input'];
  hotWaterHeatPumpPremium?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  inverter: Scalars['Boolean']['input'];
  inverterPremium?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pvPanel: Scalars['Boolean']['input'];
  pvPanelPremium?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  solarHotWater: Scalars['Boolean']['input'];
  solarHotWaterPremium?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrFindUserInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile: Scalars['String']['input'];
  role: Scalars['String']['input'];
  searchOptions?: InputMaybe<CreateOrFindUserSearchOptions>;
};

export type CreateOrFindUserSearchOptions = {
  condition?: InputMaybe<UserSearchCondition>;
  includeSuspended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePasswordlessUserByIdInput = {
  userId: Scalars['String']['input'];
};

export type CreatePasswordlessUserByIdResponse = {
  __typename?: 'CreatePasswordlessUserByIdResponse';
  firstName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
};

/** Input type */
export type CreatePasswordlessUserInput = {
  /** email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** financial product */
  financialProduct?: InputMaybe<Scalars['String']['input']>;
  /** mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** decide if user starts authentication flow by email or phone */
  type: AuthenticationFlowType;
};

export type CreatePasswordlessUserResponse = {
  __typename?: 'CreatePasswordlessUserResponse';
  /** User id */
  userId?: Maybe<Scalars['String']['output']>;
};

export type CreateProposalInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  vendorId: Scalars['String']['input'];
};

export type CreateProposalResponse = {
  __typename?: 'CreateProposalResponse';
  fieldsJson: Scalars['String']['output'];
  proposalId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateQuoteInput = {
  address?: InputMaybe<QuoteAddressInput>;
  agentId: Scalars['String']['input'];
  businessDetails?: InputMaybe<QuoteBusinessDetailsInput>;
  concessionType?: InputMaybe<ConcessionType>;
  customer: QuoteCustomerInput;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  existingInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  expires?: InputMaybe<Scalars['DateTime']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  financialProductSlug?: InputMaybe<FinancialProductSlugs>;
  insulationType?: InputMaybe<InsulationType>;
  /** Indicates whether the customer is interested in the Origin virtual power plant pilot. Do not include this field if the customer has not been asked. */
  interestedInVirtualPowerPlant?: InputMaybe<Scalars['Boolean']['input']>;
  /** When supplied, links this quote to the specified lead at creation time. The lead must be assigned to the requesting vendor. Currently only honoured for single-item quotes; multi-item is descoped and ignored. */
  leadId?: InputMaybe<Scalars['Int']['input']>;
  newInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  paymentStages?: InputMaybe<Array<Scalars['Float']['input']>>;
  productCategoryDetails?: InputMaybe<QuoteProductCategoryDetailsInput>;
  proposalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  quoteItems?: InputMaybe<Array<QuoteItem>>;
  repaymentSummary?: InputMaybe<Scalars['String']['input']>;
  repaymentTerm?: InputMaybe<RepaymentTermMonths>;
  replacedProduct?: InputMaybe<Scalars['String']['input']>;
  totalInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateQuoteResponse = {
  __typename?: 'CreateQuoteResponse';
  abn?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  account?: Maybe<Account>;
  /** @deprecated Legacy numeric identifier retained for deep-links to the legacy admin portal. Use `account.id` for new integrations. */
  accountLegacyId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<QuoteAddressType>;
  agent: Employee;
  applicationUrl: Scalars['String']['output'];
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  category: Category;
  categoryComponents: CategoryComponent;
  concessionType?: Maybe<ConcessionType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: QuoteCustomer;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  /** @deprecated Energy bundle is no longer offered */
  energyBundle?: Maybe<Scalars['Boolean']['output']>;
  enterprisePartner?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  evChargerManufacturer?: Maybe<Manufacturer>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  insulationType?: Maybe<InsulationType>;
  /** @deprecated Use `productConfiguration` instead */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  introducerFee: Scalars['Float']['output'];
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  nationalMeterIdentifier?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nonProfit?: Maybe<Scalars['Boolean']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Payment stages are no longer offered */
  paymentStages?: Maybe<Array<Scalars['Float']['output']>>;
  /** @deprecated replaced with concessionType */
  pensionerType?: Maybe<ConcessionType>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productConfigVersion: Scalars['Float']['output'];
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  promotionDiscount: Scalars['Float']['output'];
  proposals?: Maybe<Array<Proposal>>;
  /** @deprecated Use `categoryComponents` instead */
  purchaseItems: Array<PurchaseItem>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  quote: Quote;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  recipient?: Maybe<BaseIdentity>;
  referenceNumber: Scalars['String']['output'];
  relatedQuotes?: Maybe<Array<RelatedQuote>>;
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  repaymentTerm?: Maybe<Scalars['Int']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  resendDate?: Maybe<Scalars['DateTime']['output']>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  stoveType?: Maybe<StoveType>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalPurchaseAmount: Scalars['Float']['output'];
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export type CreateReferralInput = {
  address: QuoteAddressInput;
  agentId: Scalars['String']['input'];
  businessDetails?: InputMaybe<ReferralBusinessDetails>;
  concessionType?: InputMaybe<ConcessionType>;
  customer: QuoteCustomerInput;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['DateTime']['input']>;
  financialProductId: Scalars['String']['input'];
  /** When supplied, links this referral to the specified lead at creation time. The lead must be assigned to the requesting vendor. Currently only honoured for single-item referrals; multi-item is descoped and ignored. */
  leadId?: InputMaybe<Scalars['Int']['input']>;
  nationalMeterIdentifier?: InputMaybe<Scalars['String']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  proposalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseItems: Array<QuoteItem>;
  repaymentTerm?: InputMaybe<RepaymentTermMonths>;
  vendorDeclarationStatements?: InputMaybe<VendorDeclarationStatementsInput>;
  vendorId: Scalars['String']['input'];
  vendorProgramEligibilityAcknowledgementStatement?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReferralResponse = {
  __typename?: 'CreateReferralResponse';
  applicationUrl: Scalars['String']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  referral: Referral;
  relatedReferrals?: Maybe<Array<RelatedReferral>>;
};

export type CreateTitleOwnerDocumentInput = {
  applicationId: Scalars['ID']['input'];
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  titleSearchOwnerId: Scalars['ID']['input'];
};

export type CreateUserInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile: Scalars['String']['input'];
  roleName: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateUserProfileInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type CreateVendorEnrolledFinancialProductInput = {
  /** Vendor-side toggle of the enrolled financial product */
  activationStatus: ActivationStatus;
  /** Admin approval of the enrolled financial product */
  approved: Scalars['Boolean']['input'];
  /** Slug of the FinancialProduct (owned by the finance service) to enrol the vendor in */
  financialProductSlug: Scalars['String']['input'];
  /** Public ID of the vendor to enrol */
  vendorId: Scalars['String']['input'];
};

export type CreateVendorFlagInput = {
  bdmCanToggle: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  financialProductSlug?: InputMaybe<Scalars['String']['input']>;
  flagType?: InputMaybe<FlagType>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentName?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateVendorFlagsResponse = {
  __typename?: 'CreateVendorFlagsResponse';
  flag: VendorFlagDefinition;
};

export type CreateVendorLicenseInput = {
  details: Scalars['JSON']['input'];
  licenseNumber: Scalars['String']['input'];
  type: LicenseType;
  vendorId: Scalars['String']['input'];
};

export type CreateVendorRebateInput = {
  dollar?: InputMaybe<Scalars['Float']['input']>;
  endActiveRebate?: InputMaybe<Scalars['Boolean']['input']>;
  finishDate: Scalars['DateTime']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  rebateType: VendorRebateType;
  startDate: Scalars['DateTime']['input'];
  vendorPublicId: Scalars['String']['input'];
};

export type CreateVendorUserIssueInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreatedPaymentMethod = {
  __typename?: 'CreatedPaymentMethod';
  id: Scalars['String']['output'];
};

export type Credit = {
  __typename?: 'Credit';
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  limit: Scalars['Float']['output'];
};

export type CreditCardUrl = {
  __typename?: 'CreditCardUrl';
  url: Scalars['String']['output'];
};

export type CreditInput = {
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Float']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<AddressType>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jointApplicant: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated Use `publicId` instead */
  legacyId: Scalars['Int']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
};

export type CustomerConfirmationDetails = {
  __typename?: 'CustomerConfirmationDetails';
  acknowledgements?: Maybe<Array<Scalars['String']['output']>>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  contactInformation?: Maybe<Scalars['String']['output']>;
  financialProductId?: Maybe<Scalars['String']['output']>;
  primaryCustomer?: Maybe<CustomerDetails>;
  secondaryCustomer?: Maybe<CustomerDetails>;
};

export type CustomerDetails = {
  __typename?: 'CustomerDetails';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export enum CustomerDocumentStatus {
  Deleted = 'DELETED',
  New = 'NEW',
  Submitted = 'SUBMITTED',
  Uploaded = 'UPLOADED',
}

export enum CustomerDocumentTypes {
  Cca = 'CCA',
  CertificateOfCompliancePlumbing = 'CERTIFICATE_OF_COMPLIANCE_PLUMBING',
  CertificateOfElectricalWorks = 'CERTIFICATE_OF_ELECTRICAL_WORKS',
  CertificateOfOccupancyAndUse = 'CERTIFICATE_OF_OCCUPANCY_AND_USE',
  Ces = 'CES',
  ElectricalSafetyReport = 'ELECTRICAL_SAFETY_REPORT',
  GasSupplyCertificateOfCompliance = 'GAS_SUPPLY_CERTIFICATE_OF_COMPLIANCE',
  Invoice = 'INVOICE',
  Proposal = 'PROPOSAL',
  Stc = 'STC',
}

export type CustomerStatus = {
  __typename?: 'CustomerStatus';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  labelTone?: Maybe<Scalars['String']['output']>;
};

export enum CustomerType {
  Business = 'Business',
  Residential = 'Residential',
}

export type DmsMutationResponse = {
  __typename?: 'DMSMutationResponse';
  count: Scalars['Int']['output'];
};

export type DateFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type DateTimeFilter = {
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<DateTimeFilter>;
};

export type DebitPaymentMethod = {
  __typename?: 'DebitPaymentMethod';
  accountBsb?: Maybe<Scalars['String']['output']>;
  accountLast4?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type: PaymentType;
};

export type DeclaredIncomeInput = {
  amount: Scalars['Float']['input'];
  period: Period;
};

export type DeleteApplicationDocumentResult = {
  __typename?: 'DeleteApplicationDocumentResult';
  document: ApplicationDocument;
};

export type DeleteDocumentResultDto = {
  __typename?: 'DeleteDocumentResultDto';
  document: Document;
  fileStatus: FileStatus;
};

export type DeleteUserInput = {
  id: Scalars['String']['input'];
};

export type DeleteVendorFlagInput = {
  flagName: Scalars['String']['input'];
};

export type DeleteVendorFlagsResponse = {
  __typename?: 'DeleteVendorFlagsResponse';
  ok: Scalars['Boolean']['output'];
};

export type DeleteVendorLogoResponse = {
  __typename?: 'DeleteVendorLogoResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteVendorRebateInput = {
  id: Scalars['Float']['input'];
};

export type DeleteVendorRebateResponse = {
  __typename?: 'DeleteVendorRebateResponse';
  ok: Scalars['Boolean']['output'];
};

export type Detail = Entity & {
  __typename?: 'Detail';
  content?: Maybe<RichText>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum DetailOrderByInput {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Identifies documents */
export type DetailWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type Document = {
  __typename?: 'Document';
  created: Scalars['DateTime']['output'];
  documentType?: Maybe<CustomerDocumentTypes>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  status?: Maybe<CustomerDocumentStatus>;
  typeValidation?: Maybe<DocumentTypeValidation>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AutoImage = 'autoImage',
  Avif = 'avif',
  Bmp = 'bmp',
  Gif = 'gif',
  Heic = 'heic',
  Jpg = 'jpg',
  Png = 'png',
  Svg = 'svg',
  Tiff = 'tiff',
  Webp = 'webp',
}

export type DocumentList = Entity &
  Node & {
    __typename?: 'DocumentList';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<DocumentList>;
    /** List of DocumentList versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    lists: Array<DownloadGroup>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Internal use only. Not displayed on the site. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type DocumentListCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DocumentListDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type DocumentListHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type DocumentListListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DownloadGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadGroupWhereInput>;
};

export type DocumentListPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DocumentListScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type DocumentListUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   */
  format?: InputMaybe<DocumentFileTypes>;
};

export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  applicantId: Scalars['String']['output'];
  applicantType: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  documents: Array<UploadedDocument>;
  id: Scalars['Int']['output'];
  notes: Scalars['String']['output'];
  requestedBy?: Maybe<Scalars['String']['output']>;
  requestedDocumentType?: Maybe<RequestedDocumentType>;
  status: Scalars['String']['output'];
  type: DocumentRequestType;
};

export type DocumentRequestInput = {
  applicationId: Scalars['String']['input'];
};

export type DocumentRequestItem = {
  __typename?: 'DocumentRequestItem';
  id: Scalars['Int']['output'];
  notes: Scalars['String']['output'];
  requestedDocumentType?: Maybe<RequestedDocumentType>;
  status: Scalars['String']['output'];
  type: DocumentRequestType;
};

export type DocumentRequestItemInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  requestedDocumentType?: InputMaybe<RequestedDocumentType>;
  type: DocumentRequestType;
};

export enum DocumentRequestStatus {
  Expired = 'Expired',
  New = 'New',
  Submitted = 'Submitted',
}

export type DocumentRequestSubmissionInput = {
  documentIds: Array<Scalars['String']['input']>;
  documentRequestId: Scalars['Int']['input'];
};

export enum DocumentRequestType {
  AdditionalIncome = 'AdditionalIncome',
  Others = 'Others',
  PrimaryIncome = 'PrimaryIncome',
}

export type DocumentRequestWithType = {
  __typename?: 'DocumentRequestWithType';
  applicantId: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  documentType: ApplicationDocumentType;
  message?: Maybe<Scalars['String']['output']>;
  notes: Scalars['String']['output'];
};

export type DocumentRequestsInput = {
  applicationId: Scalars['String']['input'];
  status?: InputMaybe<DocumentRequestStatus>;
};

export enum DocumentStatus {
  Deleted = 'Deleted',
  New = 'New',
  Submitted = 'Submitted',
  Uploaded = 'Uploaded',
}

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export enum DocumentType {
  LeadAttachment = 'LEAD_ATTACHMENT',
  LeadImport = 'LEAD_IMPORT',
}

export type DocumentTypeValidation = {
  __typename?: 'DocumentTypeValidation';
  detectedDocumentType?: Maybe<DocumentTypeValidationDetectedType>;
  reasonCode?: Maybe<DocumentTypeValidationReasonCode>;
  status: DocumentTypeValidationStatus;
  verdict?: Maybe<DocumentTypeValidationVerdict>;
};

export enum DocumentTypeValidationDetectedType {
  BankStatement = 'BANK_STATEMENT',
  Cca = 'CCA',
  CertificateOfCompliancePlumbing = 'CERTIFICATE_OF_COMPLIANCE_PLUMBING',
  CertificateOfElectricalWorks = 'CERTIFICATE_OF_ELECTRICAL_WORKS',
  CertificateOfOccupancyAndUse = 'CERTIFICATE_OF_OCCUPANCY_AND_USE',
  Ces = 'CES',
  ElectricalSafetyReport = 'ELECTRICAL_SAFETY_REPORT',
  GasSupplyCertificateOfCompliance = 'GAS_SUPPLY_CERTIFICATE_OF_COMPLIANCE',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  Payslip = 'PAYSLIP',
  Proposal = 'PROPOSAL',
  Stc = 'STC',
}

export enum DocumentTypeValidationReasonCode {
  AmbiguousDocumentType = 'AMBIGUOUS_DOCUMENT_TYPE',
  IncompleteDocument = 'INCOMPLETE_DOCUMENT',
  InsufficientEvidence = 'INSUFFICIENT_EVIDENCE',
  Unreadable = 'UNREADABLE',
  UnsupportedDocumentType = 'UNSUPPORTED_DOCUMENT_TYPE',
  ValidationDocumentTooLarge = 'VALIDATION_DOCUMENT_TOO_LARGE',
  ValidationDocumentUnavailable = 'VALIDATION_DOCUMENT_UNAVAILABLE',
  ValidationEnqueueFailed = 'VALIDATION_ENQUEUE_FAILED',
  ValidationFailed = 'VALIDATION_FAILED',
  ValidationGuardrailBlocked = 'VALIDATION_GUARDRAIL_BLOCKED',
  ValidationInvalidResponse = 'VALIDATION_INVALID_RESPONSE',
  ValidationTimeout = 'VALIDATION_TIMEOUT',
  ValidationUnsupportedFormat = 'VALIDATION_UNSUPPORTED_FORMAT',
  WrongDocumentType = 'WRONG_DOCUMENT_TYPE',
}

export enum DocumentTypeValidationStatus {
  Checking = 'CHECKING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

export enum DocumentTypeValidationVerdict {
  Inconclusive = 'INCONCLUSIVE',
  Match = 'MATCH',
  Mismatch = 'MISMATCH',
}

export type Download = Entity & {
  __typename?: 'Download';
  date?: Maybe<Scalars['Date']['output']>;
  file?: Maybe<Asset>;
  filters: Array<DownloadFilter>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DownloadFileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export enum DownloadFilter {
  HideIntroducer = 'hideIntroducer',
  HideNonIntroducer = 'hideNonIntroducer',
}

export type DownloadGroup = Entity & {
  __typename?: 'DownloadGroup';
  downloads: Array<Download>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DownloadGroupDownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DownloadOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadWhereInput>;
};

export enum DownloadGroupOrderByInput {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Identifies documents */
export type DownloadGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  downloads_every?: InputMaybe<DownloadWhereInput>;
  downloads_none?: InputMaybe<DownloadWhereInput>;
  downloads_some?: InputMaybe<DownloadWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum DownloadOrderByInput {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FiltersAsc = 'filters_ASC',
  FiltersDesc = 'filters_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Identifies documents */
export type DownloadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  file?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  filters?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array contains *all* items provided to the filter */
  filters_contains_all?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  filters_contains_none?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array contains at least one item provided to the filter */
  filters_contains_some?: InputMaybe<Array<DownloadFilter>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  filters_not?: InputMaybe<Array<DownloadFilter>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type DriversLicenceInput = {
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  dateOfExpiry?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
};

export type DrivingLicense = {
  __typename?: 'DrivingLicense';
  cardNumber: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  number: Scalars['String']['output'];
  state: AddressState;
};

export type DrivingLicenseInput = {
  cardNumber: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: AddressState;
};

export type DwellingType = {
  __typename?: 'DwellingType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** @deprecated No longer 1:1 With dwelling type */
  uvLimit: Scalars['Float']['output'];
};

export enum ElectricityBillPeriod {
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY',
}

export type Employed = {
  __typename?: 'Employed';
  code?: Maybe<Scalars['String']['output']>;
  employerBusinessName: Scalars['String']['output'];
  employerPhoneNumber?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
};

export type EmployedInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  employerBusinessName: Scalars['String']['input'];
  employerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
};

export type Employee = {
  __typename?: 'Employee';
  courseEnrollment: EnrollmentResponse;
  email?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated Use `publicId` instead */
  legacyId: Scalars['Int']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeCourseEnrollmentArgs = {
  courseId: Scalars['ID']['input'];
};

export type Employment = {
  __typename?: 'Employment';
  employed?: Maybe<Employed>;
  other?: Maybe<Other>;
  pensioner?: Maybe<Pensioner>;
  selfEmployed?: Maybe<SelfEmployed>;
  type: EmploymentType;
};

export type EmploymentInput = {
  employed?: InputMaybe<EmployedInput>;
  other?: InputMaybe<OtherInput>;
  pensioner?: InputMaybe<PensionerInput>;
  selfEmployed?: InputMaybe<SelfEmployedInput>;
  type: EmploymentType;
};

export enum EmploymentType {
  Employed = 'EMPLOYED',
  Other = 'OTHER',
  Pensioner = 'PENSIONER',
  SelfEmployed = 'SELF_EMPLOYED',
}

export type EnrollVendorsFromFlagsResult = {
  __typename?: 'EnrollVendorsFromFlagsResult';
  enrollmentsCreated: Scalars['Int']['output'];
  enrollmentsDisenrolled: Scalars['Int']['output'];
  enrollmentsRestored: Scalars['Int']['output'];
  enrollmentsSkipped: Scalars['Int']['output'];
  vendorsMatched: Scalars['Int']['output'];
};

export type EnrolledFinancialProduct = {
  __typename?: 'EnrolledFinancialProduct';
  activationStatus: ActivationStatus;
  approved: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  disenrolled?: Maybe<Scalars['DateTime']['output']>;
  financialProductSlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  vendorId: Scalars['String']['output'];
};

export type EnrolledFinancialProductActivationStatusFilter = {
  equals?: InputMaybe<ActivationStatus>;
  in?: InputMaybe<Array<ActivationStatus>>;
};

export type EnrolledFinancialProductSettings = {
  __typename?: 'EnrolledFinancialProductSettings';
  activationStatus: ActivationStatus;
  approved: Scalars['Boolean']['output'];
  financialProductSlug: Scalars['String']['output'];
  /** The vendor's visible PRODUCT_FEATURE flags for this product */
  flags: Array<Scalars['String']['output']>;
  /** Enrolment row id */
  id: Scalars['ID']['output'];
  /** Vendor-level maximum repayment term in months */
  maxTerm?: Maybe<Scalars['Int']['output']>;
  /** The vendor's repayment terms in months (vendor-level, shared across all products) */
  terms: Array<Scalars['Int']['output']>;
  vendorId: Scalars['String']['output'];
};

export type Enrollment = {
  __typename?: 'Enrollment';
  completed?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Course>;
  courseId: Scalars['String']['output'];
  created?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  status: EnrollmentStatus;
  updated?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type EnrollmentFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentPending = {
  __typename?: 'EnrollmentPending';
  courseId: Scalars['String']['output'];
  status: EnrollmentStatus;
  userId: Scalars['String']['output'];
};

export type EnrollmentResponse = Enrollment | EnrollmentPending;

export enum EnrollmentStatus {
  Completed = 'COMPLETED',
  Enrolled = 'ENROLLED',
  PendingEnrollment = 'PENDING_ENROLLMENT',
}

export type Enterprise = {
  __typename?: 'Enterprise';
  abn?: Maybe<Scalars['String']['output']>;
  acnNumber?: Maybe<Scalars['String']['output']>;
  associationNumber?: Maybe<Scalars['String']['output']>;
  billingContact?: Maybe<EnterpriseContact>;
  billingContactSameAsPrimary?: Maybe<Scalars['Boolean']['output']>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  businessWebsite?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  incorporatedAssociation?: Maybe<Association>;
  industryCategory?: Maybe<Scalars['String']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['String']['output']>;
  other?: Maybe<SoleTraderDetail>;
  partnership?: Maybe<PartnershipDetail>;
  primaryContact?: Maybe<EnterpriseContact>;
  principalBusinessAddress?: Maybe<Address>;
  propertyStatus?: Maybe<Scalars['String']['output']>;
  proprietaryLimitedCompany?: Maybe<ProprietaryLimitedCompanyDetail>;
  registeredAddress?: Maybe<Address>;
  soleTrader?: Maybe<SoleTraderDetail>;
  structure: EnterpriseStructure;
  tradingName?: Maybe<Scalars['String']['output']>;
  trust?: Maybe<TrustDetail>;
  trustDeedDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  trustDeedDocumentNames?: Maybe<Array<Scalars['String']['output']>>;
  unincorporatedAssociation?: Maybe<Association>;
  yearsInTrading?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseApplication = {
  __typename?: 'EnterpriseApplication';
  approved?: Maybe<Scalars['DateTimeISO']['output']>;
  cancellable: Scalars['Boolean']['output'];
  created: Scalars['DateTimeISO']['output'];
  currentApplication: Scalars['Boolean']['output'];
  financedAmount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  leadId: Scalars['String']['output'];
  modified?: Maybe<Scalars['DateTimeISO']['output']>;
  orderId: Scalars['String']['output'];
  partnerFinanceProduct?: Maybe<Scalars['String']['output']>;
  partnerId: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  status: EnterpriseApplicationStatus;
  url: Scalars['String']['output'];
};

export enum EnterpriseApplicationStatus {
  Approved = 'APPROVED',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Funded = 'FUNDED',
  Funding = 'FUNDING',
  InProgress = 'IN_PROGRESS',
  Quote = 'QUOTE',
  Withdrawn = 'WITHDRAWN',
}

export type EnterpriseBaseIdentity = {
  __typename?: 'EnterpriseBaseIdentity';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  privacyAndCreditStatement?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseBaseIdentityInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  privacyAndCreditStatement?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseContact = {
  __typename?: 'EnterpriseContact';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  residentialAddress: Address;
};

export type EnterpriseContactInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  residentialAddress: AddressInput;
};

export type EnterpriseDocument = {
  __typename?: 'EnterpriseDocument';
  created: Scalars['DateTimeISO']['output'];
  deleted?: Maybe<Scalars['DateTimeISO']['output']>;
  documentType: DocumentType;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
  rawImportLog?: Maybe<RawImportLog>;
  s3Url: Scalars['String']['output'];
};

export type EnterpriseDocumentFilter = {
  documentType?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseIdentityWithIdentification = {
  __typename?: 'EnterpriseIdentityWithIdentification';
  address: Address;
  dateOfBirth: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  identification: Identification;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  ownershipPercentage?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  privacyAndCreditStatement?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseIdentityWithIdentificationInput = {
  address: AddressInput;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  identification: IdentificationInput;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  ownershipPercentage?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  privacyAndCreditStatement?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  acnNumber?: InputMaybe<Scalars['String']['input']>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  billingContact?: InputMaybe<EnterpriseContactInput>;
  billingContactSameAsPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessWebsite?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  incorporatedAssociation?: InputMaybe<AssociationInput>;
  industryCategory?: InputMaybe<Scalars['String']['input']>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<SoleTraderDetailInput>;
  partnership?: InputMaybe<PartnershipDetailInput>;
  primaryContact?: InputMaybe<EnterpriseContactInput>;
  principalBusinessAddress?: InputMaybe<AddressInput>;
  propertyStatus?: InputMaybe<Scalars['String']['input']>;
  proprietaryLimitedCompany?: InputMaybe<ProprietaryLimitedCompanyDetailInput>;
  registeredAddress?: InputMaybe<AddressInput>;
  soleTrader?: InputMaybe<SoleTraderDetailInput>;
  structure: EnterpriseStructure;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  trust?: InputMaybe<TrustDetailInput>;
  trustDeedDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  trustDeedDocumentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  unincorporatedAssociation?: InputMaybe<AssociationInput>;
  yearsInTrading?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseLead = {
  __typename?: 'EnterpriseLead';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressValidationStatus?: Maybe<AddressValidationStatus>;
  applications: Array<EnterpriseApplication>;
  australianBusinessNumber?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  callTimePreference?: Maybe<Scalars['String']['output']>;
  categories: Array<EnterpriseLeadCategory>;
  channel?: Maybe<PartnerConfigChannel>;
  city?: Maybe<Scalars['String']['output']>;
  contact: EnterpriseLeadContact;
  contactId: Scalars['String']['output'];
  created: Scalars['DateTimeISO']['output'];
  crmOpportunityId?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId: Scalars['String']['output'];
  financialProductId?: Maybe<Scalars['String']['output']>;
  fpAccountId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<EnterprisePartner>;
  houseType?: Maybe<Scalars['String']['output']>;
  householdIncome?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  installTimeframe?: Maybe<Scalars['String']['output']>;
  intakeCompleted?: Maybe<Scalars['DateTimeISO']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  interestedInFinance?: Maybe<Ternary>;
  latitude?: Maybe<Scalars['Float']['output']>;
  leadType: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  partnerCustomerId?: Maybe<Scalars['String']['output']>;
  partnerMarketingConsent?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Boolean']['output']>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  purchasePriority?: Maybe<Scalars['String']['output']>;
  quotes: Array<EnterpriseQuote>;
  rawAddress?: Maybe<Scalars['String']['output']>;
  rawImportLogId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceReference?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: Status;
  submitted: Scalars['DateTimeISO']['output'];
  updated: Scalars['DateTimeISO']['output'];
  vendors: Array<EnterpriseLeadVendor>;
  wallType?: Maybe<Scalars['String']['output']>;
  warm?: Maybe<Scalars['Boolean']['output']>;
  willDonateSubsidy?: Maybe<Ternary>;
};

export type EnterpriseLeadCategory = {
  __typename?: 'EnterpriseLeadCategory';
  acceptedQuote?: Maybe<EnterpriseQuote>;
  category: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  lead: EnterpriseLead;
  leadId: Scalars['String']['output'];
  paymentType?: Maybe<EnterprisePaymentType>;
  pipelineStage?: Maybe<PipelineStage>;
  pipelineStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  purchaseAmount?: Maybe<Scalars['Float']['output']>;
  quotes: Array<EnterpriseQuote>;
  stageHistory: Array<EnterpriseLeadCategoryStage>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EnterpriseLeadCategoryStage = {
  __typename?: 'EnterpriseLeadCategoryStage';
  category: Scalars['String']['output'];
  leadId: Scalars['String']['output'];
  pipelineStage?: Maybe<PipelineStage>;
  time: Scalars['DateTimeISO']['output'];
};

export type EnterpriseLeadContact = {
  __typename?: 'EnterpriseLeadContact';
  created: Scalars['DateTimeISO']['output'];
  crmContactId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  phoneVerified: Scalars['Boolean']['output'];
};

export type EnterpriseLeadFilter = {
  OR?: InputMaybe<Array<EnterpriseLeadFilterFields>>;
  category?: InputMaybe<StringFilter>;
  pipelineStage?: InputMaybe<PipelineStageFilter>;
  pipelineStartedAt?: InputMaybe<DateTimeFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseLeadFilterFields = {
  enterprisePartnerId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type EnterpriseLeadStatus = {
  __typename?: 'EnterpriseLeadStatus';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EnterpriseLeadVendor = {
  __typename?: 'EnterpriseLeadVendor';
  acknowledged?: Maybe<Scalars['DateTimeISO']['output']>;
  vendor: Vendor;
};

export type EnterpriseLeadsResponse = {
  __typename?: 'EnterpriseLeadsResponse';
  count: Scalars['Int']['output'];
  leads: Array<EnterpriseLead>;
};

export type EnterprisePartner = {
  __typename?: 'EnterprisePartner';
  configuration?: Maybe<EnterprisePartnerConfiguration>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  referralConfiguration?: Maybe<EnterprisePartnerReferralConfiguration>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EnterprisePartnerConfiguration = {
  __typename?: 'EnterprisePartnerConfiguration';
  /** Whether the pre-marketplace flow can create new leads */
  allowLeadCreation?: Maybe<Scalars['Boolean']['output']>;
  /** Page background colour hex, e.g. "#F1F4FF" */
  backgroundColour?: Maybe<Scalars['String']['output']>;
  /** Slug for "brighte.com.au/{slug}" links */
  brighteSiteSlug?: Maybe<Scalars['String']['output']>;
  /** Dedicated Brighte-site subdomain, e.g. "commbank" for commbank.brighte.com.au. Only set for partners with a genuinely provisioned subdomain; takes priority over brighteSiteSlug when both are set. */
  brighteSiteSubdomain?: Maybe<Scalars['String']['output']>;
  /** Border radius for cards, e.g. "large" or "none" */
  cardBorderRadius?: Maybe<Scalars['String']['output']>;
  /** A partner can have multiple channels (e.g. ACT has: act, act-community, act-sfa, act-hesp). */
  channels?: Maybe<Array<PartnerConfigChannel>>;
  /** Partner support phone number shown in customer-connect */
  contactNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Customer ID field requirement: null | "required" | "optional"
   * @deprecated Use channels[].contactForm.fields instead (INT-1410) — partner level cannot express per-channel fields. Retained until every consumer reads the channel-level config.
   */
  customerIdRequirement?: Maybe<Scalars['String']['output']>;
  /** Vendor slugs pinned to the top of this partner's marketplace listing, highest priority first. Applied after whichever sort is in effect, so the featured vendor leads and the rest follow the sort. */
  featuredVendorSlugs?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether to filter vendors by partnerId in marketplace query */
  filterVendorByPartner?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the partner has a co-branded Brighte × Partner logo asset. Consumers derive the logo URL from the partner ID. */
  hasCoBrandedLogo?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the partner has a dedicated asset folder. Consumers derive the asset URL from the partner ID. */
  hasCustomAssetPath?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show a marketing opt-in checkbox */
  hasMarketingOptIn?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this partner has Hygraph-managed promotion content. When null (default), promotion content queries are skipped entirely. */
  hasPromotionContent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the partner supports the intake flow */
  intake?: Maybe<Scalars['Boolean']['output']>;
  /** Per-lead price shown in vendor-portal lead-price modal. null/omitted = hide the partner from the modal; positive = display the amount. */
  leadPricing?: Maybe<Scalars['Int']['output']>;
  /** Custom logo width in pixels. Falls back to default if not set. */
  logoWidth?: Maybe<Scalars['Int']['output']>;
  /** Vendor flag name from portal DB migration (enables marketplace vendor filtering for the partner) */
  marketplaceFlag?: Maybe<Scalars['String']['output']>;
  /** Whether a vendor can cover only some categories (true) or must cover all selected categories (false) */
  multiVendor?: Maybe<Scalars['Boolean']['output']>;
  /** Vendor slugs that ARE this partner (e.g. "racq-solar" for RACQ), used to withhold the partner-approved badge from the partner's own vendor. Separate from featuredVendorSlugs so featuring a different vendor does not move the badge. */
  ownVendorSlugs?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether customers use the customer package (compare quotes) flow. Drives: customer-connect routing, finance event enrichment, and EB rule matching. */
  packageEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Controls proposal placement logic in the referral form.
   * @deprecated Use referralConfiguration.packageSupportsMultipleVendors instead.
   */
  packageSupportsMultipleVendors?: Maybe<Scalars['Boolean']['output']>;
  /** Partner website URL, e.g. "https://racq.com.au" */
  partnerWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the pending-vendor follow-up reminder is enabled for this partner. */
  pendingVendorFollowupEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to only show vendors under their lead allocation limit */
  premiumLeads?: Maybe<Scalars['Boolean']['output']>;
  /** If true, redirect to /success after vendor selection instead of /status/auto-login */
  redirectToSuccessPage?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether a referral can span multiple categories (true = checkboxes, false = single category)
   * @deprecated Use referralConfiguration.referralSupportsMultipleCategories instead.
   */
  referralSupportsMultipleCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a lead must exist before accessing the marketplace */
  requireLead?: Maybe<Scalars['Boolean']['output']>;
  /** Spark Web theme name. Adding a new theme requires Spark Web support (Tier 2). */
  sparkThemeName?: Maybe<Scalars['String']['output']>;
  /** External success URL to redirect to after vendor selection (e.g. ACT partner). Falls back to internal /success if not set. */
  successUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the full vendor browse page and "Request more quotes" CTA are accessible */
  vendorBrowsingEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type EnterprisePartnerConfigurationFilter = {
  packageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnterprisePartnerFilter = {
  configuration?: InputMaybe<EnterprisePartnerConfigurationFilter>;
};

export type EnterprisePartnerPromotion = {
  __typename?: 'EnterprisePartnerPromotion';
  enterprisePartnerId: Scalars['String']['output'];
};

export type EnterprisePartnerReferralConfiguration = {
  __typename?: 'EnterprisePartnerReferralConfiguration';
  /** Controls proposal placement logic in the referral form. */
  packageSupportsMultipleVendors?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a referral can span multiple categories (true = checkboxes, false = single category) */
  referralSupportsMultipleCategories?: Maybe<Scalars['Boolean']['output']>;
};

export enum EnterprisePaymentType {
  Cash = 'CASH',
  Finance = 'FINANCE',
}

export type EnterprisePipelineStage = {
  __typename?: 'EnterprisePipelineStage';
  count: Scalars['Int']['output'];
  householdCount: Scalars['Int']['output'];
  leads: Array<EnterpriseLeadCategory>;
  name: PipelineLeadStage;
};

export type EnterprisePipelineStageFilter = {
  AND?: InputMaybe<Array<EnterprisePipelineStageFilter>>;
  NOT?: InputMaybe<Array<EnterprisePipelineStageFilter>>;
  OR?: InputMaybe<Array<EnterprisePipelineStageFilter>>;
  category?: InputMaybe<StringFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  paymentType?: InputMaybe<StringFilter>;
  pipelineStage?: InputMaybe<PipelineLeadStage>;
  pipelineStartedAt?: InputMaybe<DateTimeFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EnterpriseQuote = {
  __typename?: 'EnterpriseQuote';
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  category: Scalars['String']['output'];
  created: Scalars['DateTimeISO']['output'];
  declinedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  expiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
  financialProductId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  leadId: Scalars['String']['output'];
  productDetails?: Maybe<Scalars['JSON']['output']>;
  purchaseAmount?: Maybe<Scalars['Float']['output']>;
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export enum EnterpriseStructure {
  Company = 'Company',
  IncorporatedAssociation = 'IncorporatedAssociation',
  Other = 'Other',
  Partnership = 'Partnership',
  ProprietaryLimitedCompany = 'ProprietaryLimitedCompany',
  SoleTrader = 'SoleTrader',
  Trust = 'Trust',
  UnincorporatedAssociation = 'UnincorporatedAssociation',
}

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

export type Expense = {
  __typename?: 'Expense';
  creditCards?: Maybe<Credit>;
  household?: Maybe<RecurringExpense>;
  investmentProperties?: Maybe<RecurringExpenseCheck>;
  mortgage?: Maybe<RecurringExpenseCheck>;
  otherLoans?: Maybe<RecurringExpenseCheck>;
  rent?: Maybe<RecurringExpenseCheck>;
};

export type ExpenseInput = {
  creditCards?: InputMaybe<CreditInput>;
  household?: InputMaybe<RecurringExpenseInput>;
  investmentProperties?: InputMaybe<RecurringExpenseCheckInput>;
  mortgage?: InputMaybe<RecurringExpenseCheckInput>;
  otherLoans?: InputMaybe<RecurringExpenseCheckInput>;
  rent?: InputMaybe<RecurringExpenseCheckInput>;
};

export type ExternalCourse = {
  __typename?: 'ExternalCourse';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Faq = Entity &
  Node & {
    __typename?: 'Faq';
    accordions: Array<Accordion>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<Faq>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of Faq versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Internal use only. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type FaqAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionWhereInput>;
};

export type FaqCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type FaqHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type FaqPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type FaqUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum FileStatus {
  Deleted = 'DELETED',
  Exists = 'EXISTS',
}

export type FileUploadInput = {
  file: Scalars['Upload']['input'];
};

export enum FinanceDocumentType {
  Lsft = 'LSFT',
  Payout = 'PAYOUT',
}

export type FinanceVendorFlag = {
  __typename?: 'FinanceVendorFlag';
  description: Scalars['String']['output'];
  financialProductSlug?: Maybe<Scalars['String']['output']>;
  flagType: FlagType;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type FinancialInstitution = {
  __typename?: 'FinancialInstitution';
  bsbNumber: Scalars['String']['output'];
  financialInstitutionId: Scalars['String']['output'];
};

export type FinancialInstitutionLookupInput = {
  FiMnemonic?: InputMaybe<Scalars['String']['input']>;
  FiName?: InputMaybe<Scalars['String']['input']>;
  Postcode?: InputMaybe<Scalars['String']['input']>;
  State?: InputMaybe<Scalars['String']['input']>;
  StreamCode?: InputMaybe<Scalars['String']['input']>;
  Suburb?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  bicint?: InputMaybe<Scalars['String']['input']>;
  bsbcode?: InputMaybe<Scalars['String']['input']>;
  changedate?: InputMaybe<Scalars['String']['input']>;
  repair?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialInstitutionLookupResponse = {
  __typename?: 'FinancialInstitutionLookupResponse';
  data: Array<FinancialInstitutionLookupResult>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type FinancialInstitutionLookupResult = {
  __typename?: 'FinancialInstitutionLookupResult';
  address: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  bicInt: Scalars['String']['output'];
  bsbCode: Scalars['String']['output'];
  bsbName: Scalars['String']['output'];
  fiMnemonic: Scalars['String']['output'];
  fiName: Scalars['String']['output'];
  lastModified: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  repair: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streamCode: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type FinancialProduct = {
  __typename?: 'FinancialProduct';
  categories: Array<Category>;
  categoryGroup?: Maybe<CategoryGroup>;
  configuration: FinancialProductConfiguration;
  customerType: CustomerType;
  externalLender: Scalars['Boolean']['output'];
  fpAccountType: Scalars['String']['output'];
  fpBranch: Scalars['String']['output'];
  id: Scalars['String']['output'];
  loanTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  promotions: Array<Promotion>;
  requirements?: Maybe<Scalars['String']['output']>;
  /** @deprecated Products will be dynamic. Use ID instead */
  slug: FinancialProductSlugs;
  type: ProductType;
};

export type FinancialProductCategoriesArgs = {
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialProductConfigurationArgs = {
  promotionCode?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialProductPromotionsArgs = {
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialProductConfiguration = {
  __typename?: 'FinancialProductConfiguration';
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  annualFee: Scalars['Float']['output'];
  applicationFee: Scalars['Float']['output'];
  cashPaymentEnabled: Scalars['Boolean']['output'];
  comparisonRate?: Maybe<Scalars['Float']['output']>;
  defaultPaymentCycle: Scalars['String']['output'];
  enableExpressSettlement: Scalars['Boolean']['output'];
  establishmentFee: Scalars['Float']['output'];
  firstPaymentDelayDays: Scalars['Int']['output'];
  forceCcaProcess: Scalars['Boolean']['output'];
  interestRate: Scalars['Float']['output'];
  introducerFee: Scalars['Float']['output'];
  invoiceRequired: Scalars['Boolean']['output'];
  latePaymentFee: Scalars['Float']['output'];
  lifetimePropertyFinanceCap?: Maybe<Scalars['Float']['output']>;
  manualSettlementRequired: Scalars['Boolean']['output'];
  maxEstablishmentFee: Scalars['Float']['output'];
  maxFinanceAmount?: Maybe<Scalars['Float']['output']>;
  maxRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  minEstablishmentFee: Scalars['Float']['output'];
  minFinanceAmount?: Maybe<Scalars['Float']['output']>;
  minRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  preventApplicationsAfterEndDate: Scalars['Boolean']['output'];
  riskBasedPricing: Scalars['Boolean']['output'];
  supportMultipleCategories: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  weeklyAccountFee: Scalars['Float']['output'];
};

export type FinancialProductConfigurationRecord = {
  __typename?: 'FinancialProductConfigurationRecord';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  annualFee: Scalars['Float']['output'];
  applicationFee: Scalars['Float']['output'];
  cashPaymentEnabled: Scalars['Boolean']['output'];
  comparisonRate?: Maybe<Scalars['Float']['output']>;
  defaultPaymentCycle: Scalars['String']['output'];
  enableExpressSettlement: Scalars['Boolean']['output'];
  establishmentFee: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  financialProductSlug: Scalars['String']['output'];
  firstPaymentDelayDays: Scalars['Int']['output'];
  forceCcaProcess: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  interestRate: Scalars['Float']['output'];
  introducerFee: Scalars['Float']['output'];
  invoiceRequired: Scalars['Boolean']['output'];
  latePaymentFee: Scalars['Float']['output'];
  lifetimePropertyFinanceCap?: Maybe<Scalars['Float']['output']>;
  manualSettlementRequired: Scalars['Boolean']['output'];
  maxEstablishmentFee: Scalars['Float']['output'];
  maxFinanceAmount?: Maybe<Scalars['Float']['output']>;
  maxRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  minEstablishmentFee: Scalars['Float']['output'];
  minFinanceAmount?: Maybe<Scalars['Float']['output']>;
  minRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  preventApplicationsAfterEndDate: Scalars['Boolean']['output'];
  riskBasedPricing: Scalars['Boolean']['output'];
  supportMultipleCategories: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  weeklyAccountFee: Scalars['Float']['output'];
};

export type FinancialProductConfigurationRecordCreateInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  annualFee?: InputMaybe<Scalars['Float']['input']>;
  applicationFee?: InputMaybe<Scalars['Float']['input']>;
  cashPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  comparisonRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPaymentCycle: Scalars['String']['input'];
  enableExpressSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  endPreviousVersionOnStartTime: Scalars['Boolean']['input'];
  establishmentFee?: InputMaybe<Scalars['Float']['input']>;
  financialProductSlug: Scalars['String']['input'];
  firstPaymentDelayDays?: InputMaybe<Scalars['Int']['input']>;
  forceCcaProcess?: InputMaybe<Scalars['Boolean']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  introducerFee?: InputMaybe<Scalars['Float']['input']>;
  invoiceRequired: Scalars['Boolean']['input'];
  latePaymentFee?: InputMaybe<Scalars['Float']['input']>;
  lifetimePropertyFinanceCap?: InputMaybe<Scalars['Float']['input']>;
  manualSettlementRequired: Scalars['Boolean']['input'];
  maxFinanceAmount: Scalars['Float']['input'];
  maxRepaymentMonth: Scalars['Int']['input'];
  minFinanceAmount: Scalars['Float']['input'];
  minRepaymentMonth: Scalars['Int']['input'];
  preventApplicationsAfterEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  riskBasedPricing: Scalars['Boolean']['input'];
  supportMultipleCategories?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  weeklyAccountFee?: InputMaybe<Scalars['Float']['input']>;
};

export type FinancialProductConfigurationRecordUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  annualFee?: InputMaybe<Scalars['Float']['input']>;
  applicationFee?: InputMaybe<Scalars['Float']['input']>;
  cashPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  comparisonRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPaymentCycle?: InputMaybe<Scalars['String']['input']>;
  enableExpressSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  endPreviousVersionOnStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  establishmentFee?: InputMaybe<Scalars['Float']['input']>;
  firstPaymentDelayDays?: InputMaybe<Scalars['Int']['input']>;
  forceCcaProcess?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  introducerFee?: InputMaybe<Scalars['Float']['input']>;
  invoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  latePaymentFee?: InputMaybe<Scalars['Float']['input']>;
  lifetimePropertyFinanceCap?: InputMaybe<Scalars['Float']['input']>;
  manualSettlementRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxFinanceAmount?: InputMaybe<Scalars['Float']['input']>;
  maxRepaymentMonth?: InputMaybe<Scalars['Int']['input']>;
  minFinanceAmount?: InputMaybe<Scalars['Float']['input']>;
  minRepaymentMonth?: InputMaybe<Scalars['Int']['input']>;
  preventApplicationsAfterEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  riskBasedPricing?: InputMaybe<Scalars['Boolean']['input']>;
  supportMultipleCategories?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyAccountFee?: InputMaybe<Scalars['Float']['input']>;
};

export type FinancialProductConfigurationsResult = {
  __typename?: 'FinancialProductConfigurationsResult';
  count: Scalars['Int']['output'];
  financialProductConfigurations: Array<FinancialProductConfigurationRecord>;
};

export enum FinancialProductSlugs {
  ActCommunityLoan = 'ActCommunityLoan',
  ActShsLoan = 'ActShsLoan',
  ActSlipLoan = 'ActSlipLoan',
  ActSolarForApartmentsLoan = 'ActSolarForApartmentsLoan',
  BrighteBusiness = 'BrighteBusiness',
  BrighteFlex = 'BrighteFlex',
  BrightePay = 'BrightePay',
  CommbankResidential = 'CommbankResidential',
  Electrify2515 = 'Electrify2515',
  EnergyLoan = 'EnergyLoan',
  GreenLoan = 'GreenLoan',
  HeufGreenLoan = 'HeufGreenLoan',
  HomeEnergySaverLoan = 'HomeEnergySaverLoan',
  Milestone = 'Milestone',
  NswRebateSwap = 'NswRebateSwap',
  PersonalLoan = 'PersonalLoan',
  TasEslsLoan = 'TasEslsLoan',
  TasEslsSmeLoan = 'TasEslsSmeLoan',
}

export type FinancialProductUpdateInput = {
  categoryGroup?: InputMaybe<CategoryGroup>;
  customerType?: InputMaybe<CustomerType>;
  externalLender?: InputMaybe<Scalars['Boolean']['input']>;
  fpAccountType?: InputMaybe<Scalars['String']['input']>;
  fpBranch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  loanTypeId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductType>;
};

export type FinancialProductsFilter = {
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type Flag = {
  __typename?: 'Flag';
  childNames: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  financialProductSlug?: Maybe<Scalars['String']['output']>;
  flagType: FlagType;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};

export enum FlagType {
  FinancialProduct = 'FINANCIAL_PRODUCT',
  General = 'GENERAL',
  Marketplace = 'MARKETPLACE',
  Notification = 'NOTIFICATION',
  ProductFeature = 'PRODUCT_FEATURE',
}

export type FlagsFilter = {
  name: StringFilter;
};

export type Footnote = Entity & {
  __typename?: 'Footnote';
  content?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Identifies documents */
export type FootnoteWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FootnoteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type GasProductSummary = Entity & {
  __typename?: 'GasProductSummary';
  articles: Array<Article>;
  description?: Maybe<RichText>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  proofPoints?: Maybe<RichText>;
  sources?: Maybe<RichText>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GasProductSummaryArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type GasProductSummaryImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/** Identifies documents */
export type GasProductSummaryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GasProductSummaryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type GetPropertyTitleOwnerInput = {
  trackingId: Scalars['ID']['input'];
};

export type GetPropertyTitleOwnerOutput = {
  __typename?: 'GetPropertyTitleOwnerOutput';
  failureCode?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  owners: Array<PropertyTitleOwnerOutput>;
  ownershipDisputed: Scalars['Boolean']['output'];
  searchStatus: Scalars['String']['output'];
  trackingId: Scalars['ID']['output'];
};

export type GetTitleOwnerDocumentVerificationInput = {
  applicationId: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
  titleSearchOwnerId: Scalars['ID']['input'];
};

export type GetTitleSearchOwnerInput = {
  applicationId: Scalars['ID']['input'];
};

export enum GreenOrPersonal {
  Bgl = 'BGL',
  Bpl = 'BPL',
}

export type HtmlBlock = Entity & {
  __typename?: 'HTMLBlock';
  code?: Maybe<Scalars['String']['output']>;
  /** Optional heading to display above the content */
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Identifies documents */
export type HtmlBlockWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HtmlBlockWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HtmlBlockWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HtmlBlockWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  code_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  code_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  code_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  code_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  code_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  code_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  code_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  code_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  code_starts_with?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type HeadingNumber = Entity & {
  __typename?: 'HeadingNumber';
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This is the step number, list number for a listicle, etc. */
  number?: Maybe<Scalars['Float']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Identifies documents */
export type HeadingNumberWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeadingNumberWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum HeatingCoolingSystemType {
  DuctedSystem = 'DUCTED_SYSTEM',
  SplitSystem = 'SPLIT_SYSTEM',
}

export type Hub = Entity &
  Node & {
    __typename?: 'Hub';
    categories: Array<HubCategory>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<Hub>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of Hub versions */
    history: Array<Version>;
    hub?: Maybe<HubhubUnion>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    meta?: Maybe<Meta>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Links to this page will use this straight-forward title, e.g. Bathroom, Kitchen, etc. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type HubCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

export type HubCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type HubHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type HubHubArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubMetaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type HubUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCareer = Entity & {
  __typename?: 'HubCareer';
  articles: Array<Article>;
  articlesHeading?: Maybe<Scalars['String']['output']>;
  /** This is the H1 */
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This is displayed below the H1 */
  intro?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  statsImageDesktop?: Maybe<Asset>;
  statsImageMobile?: Maybe<Asset>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HubCareerArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubCareerStatsImageDesktopArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type HubCareerStatsImageMobileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/** Identifies documents */
export type HubCareerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubCareerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  articlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  articlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  articlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  articlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  articlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  articlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  articlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  articlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  articlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  intro_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  intro_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  intro_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  intro_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  intro_starts_with?: InputMaybe<Scalars['String']['input']>;
  statsImageDesktop?: InputMaybe<AssetWhereInput>;
  statsImageMobile?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type HubCategory = Entity &
  Node & {
    __typename?: 'HubCategory';
    articles: Array<Article>;
    categories: Array<HubCategory>;
    category?: Maybe<HubCategory>;
    content?: Maybe<HubCategorycontentUnion>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<HubCategory>;
    /** Displayed on the page as the main visual heading. */
    heading?: Maybe<Scalars['String']['output']>;
    /** List of HubCategory versions */
    history: Array<Version>;
    hub?: Maybe<Hub>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Displayed on rich links into this page */
    image?: Maybe<Asset>;
    meta?: Maybe<Meta>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** Links to this page will use this straight-forward title, e.g. Bathroom, Kitchen, etc. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type HubCategoryArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubCategoryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

export type HubCategoryCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type HubCategoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type HubCategoryHubArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type HubCategoryMetaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type HubCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum HubCategoryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** This contains a set of filters that can be used to compare values internally */
export type HubCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HubCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  categories_every?: InputMaybe<HubCategoryWhereInput>;
  categories_none?: InputMaybe<HubCategoryWhereInput>;
  categories_some?: InputMaybe<HubCategoryWhereInput>;
  category?: InputMaybe<HubCategoryWhereInput>;
  /** All values in which the modular component is connected to the given models */
  content?: InputMaybe<HubCategorycontentUnionWhereInput>;
  /** All values in which the union is empty. */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HubCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<HubCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<HubCategoryWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<HubWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  meta?: InputMaybe<MetaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HubCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HubCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export type HubCategorycontentUnion = HubRoom;

export type HubCategorycontentUnionWhereInput = {
  HubRoom?: InputMaybe<HubRoomWhereInput>;
};

export type HubRoom = Entity & {
  __typename?: 'HubRoom';
  articles: Array<Article>;
  articlesHeading?: Maybe<Scalars['String']['output']>;
  featuredArticle?: Maybe<Article>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This is the <H1> */
  introHeading?: Maybe<Scalars['String']['output']>;
  introParagraph?: Maybe<RichText>;
  relatedArticles: Array<Article>;
  relatedCategories: Array<HubCategory>;
  relatedHeading?: Maybe<Scalars['String']['output']>;
  relatedParagraph?: Maybe<RichText>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HubRoomArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubRoomFeaturedArticleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HubRoomRelatedArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubRoomRelatedCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

/** Identifies documents */
export type HubRoomWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubRoomWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  articlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  articlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  articlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  articlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  articlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  articlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  articlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  articlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  articlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  featuredArticle?: InputMaybe<ArticleWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  relatedArticles_every?: InputMaybe<ArticleWhereInput>;
  relatedArticles_none?: InputMaybe<ArticleWhereInput>;
  relatedArticles_some?: InputMaybe<ArticleWhereInput>;
  relatedCategories_every?: InputMaybe<HubCategoryWhereInput>;
  relatedCategories_none?: InputMaybe<HubCategoryWhereInput>;
  relatedCategories_some?: InputMaybe<HubCategoryWhereInput>;
  relatedHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  relatedHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  relatedHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  relatedHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  relatedHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  relatedHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  relatedHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  relatedHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  relatedHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  relatedHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type HubSustainableHome = Entity & {
  __typename?: 'HubSustainableHome';
  additionalArticles: Array<Article>;
  additionalArticlesHeading?: Maybe<Scalars['String']['output']>;
  explainer?: Maybe<RichText>;
  explainerHeading?: Maybe<Scalars['String']['output']>;
  explainerProof1?: Maybe<Scalars['String']['output']>;
  explainerProof2?: Maybe<Scalars['String']['output']>;
  explainerProof3?: Maybe<Scalars['String']['output']>;
  featuredArticles: Array<Article>;
  featuredHeading?: Maybe<Scalars['String']['output']>;
  /** Displays in the hero below the Hero Heading */
  heroContent?: Maybe<RichText>;
  /** This is the H1 */
  heroHeading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  rooms: Array<HubCategory>;
  roomsHeading?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HubSustainableHomeAdditionalArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubSustainableHomeFeaturedArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type HubSustainableHomeRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HubCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HubCategoryWhereInput>;
};

/** Identifies documents */
export type HubSustainableHomeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubSustainableHomeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  additionalArticlesHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  additionalArticlesHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  additionalArticlesHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  additionalArticlesHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  additionalArticlesHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  additionalArticlesHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  additionalArticlesHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  additionalArticlesHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  additionalArticlesHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  additionalArticlesHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  additionalArticles_every?: InputMaybe<ArticleWhereInput>;
  additionalArticles_none?: InputMaybe<ArticleWhereInput>;
  additionalArticles_some?: InputMaybe<ArticleWhereInput>;
  explainerHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof1?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof1_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof1_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof1_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof1_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof1_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof2?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof2_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof2_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof2_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof2_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof2_starts_with?: InputMaybe<Scalars['String']['input']>;
  explainerProof3?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  explainerProof3_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  explainerProof3_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  explainerProof3_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  explainerProof3_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  explainerProof3_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  explainerProof3_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  explainerProof3_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  explainerProof3_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  explainerProof3_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuredArticles_every?: InputMaybe<ArticleWhereInput>;
  featuredArticles_none?: InputMaybe<ArticleWhereInput>;
  featuredArticles_some?: InputMaybe<ArticleWhereInput>;
  featuredHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  featuredHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  featuredHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  featuredHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  featuredHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  featuredHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  featuredHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  featuredHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  featuredHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  featuredHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  roomsHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  roomsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  roomsHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  roomsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  roomsHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  roomsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  roomsHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  roomsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  roomsHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  roomsHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  rooms_every?: InputMaybe<HubCategoryWhereInput>;
  rooms_none?: InputMaybe<HubCategoryWhereInput>;
  rooms_some?: InputMaybe<HubCategoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** This contains a set of filters that can be used to compare values internally */
export type HubWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HubWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categories_every?: InputMaybe<HubCategoryWhereInput>;
  categories_none?: InputMaybe<HubCategoryWhereInput>;
  categories_some?: InputMaybe<HubCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HubWhereStageInput>;
  documentInStages_none?: InputMaybe<HubWhereStageInput>;
  documentInStages_some?: InputMaybe<HubWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  hub?: InputMaybe<HubhubUnionWhereInput>;
  /** All values in which the union is empty. */
  hub_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<MetaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HubWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HubWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HubWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HubWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HubWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export type HubhubUnion = HubCareer | HubSustainableHome;

export type HubhubUnionWhereInput = {
  HubCareer?: InputMaybe<HubCareerWhereInput>;
  HubSustainableHome?: InputMaybe<HubSustainableHomeWhereInput>;
};

export type HyGraphImage = Entity & {
  __typename?: 'HyGraphImage';
  caption?: Maybe<Scalars['String']['output']>;
  displayMode?: Maybe<ImageMode>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  theme?: Maybe<Theme>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HyGraphImageImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/** User system model */
export type HyGraphUser = Entity &
  Node & {
    __typename?: 'HyGraphUser';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** Get the document in other stages */
    documentInStages: Array<HyGraphUser>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Flag to determine if user is active or not */
    isActive: Scalars['Boolean']['output'];
    /** User Kind. Can be either MEMBER, PAT or PUBLIC */
    kind: UserKind;
    /** The username */
    name: Scalars['String']['output'];
    /** Profile Picture url */
    picture?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
  };

/** User system model */
export type HyGraphUserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Identification = {
  __typename?: 'Identification';
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  drivingLicense?: Maybe<DrivingLicense>;
  isSkipDocuments?: Maybe<Scalars['Boolean']['output']>;
  medicare?: Maybe<Medicare>;
  passport?: Maybe<Passport>;
  photoId?: Maybe<PhotoId>;
  type: IdentificationType;
};

export type IdentificationInput = {
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  drivingLicense?: InputMaybe<DrivingLicenseInput>;
  isSkipDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  medicare?: InputMaybe<MedicareInput>;
  passport?: InputMaybe<PassportInput>;
  photoId?: InputMaybe<PhotoIdInput>;
  type: IdentificationType;
};

export enum IdentificationType {
  DrivingLicense = 'DRIVING_LICENSE',
  Medicare = 'MEDICARE',
  Passport = 'PASSPORT',
  PhotoId = 'PHOTO_ID',
}

/** Type of identity document to verify */
export enum IdentityVerificationDocumentType {
  DriversLicence = 'DRIVERS_LICENCE',
  Medicare = 'MEDICARE',
  Passport = 'PASSPORT',
}

/** Medicare card colour code */
export enum IdentityVerificationMedicareCardColour {
  Blue = 'BLUE',
  Green = 'GREEN',
  Yellow = 'YELLOW',
}

/** Overall outcome of an identity verification */
export enum IdentityVerificationOverallOutcome {
  Accept = 'ACCEPT',
  Error = 'ERROR',
  Reject = 'REJECT',
  Timeout = 'TIMEOUT',
}

export type IdentityVerificationSearchResultOutput = {
  __typename?: 'IdentityVerificationSearchResultOutput';
  matchIndicator: Scalars['String']['output'];
  matchScore?: Maybe<Scalars['String']['output']>;
  searchName: Scalars['String']['output'];
  validationErrors: Array<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  created: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  Crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  Max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  Scale = 'scale',
}

export enum ImageMode {
  Contain = 'Contain',
  Cover = 'Cover',
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

export enum ImageTags {
  Home = 'Home',
  Legacy = 'Legacy',
  Solar = 'Solar',
}

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

/** Identifies documents */
export type ImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  displayMode?: InputMaybe<ImageMode>;
  /** All values that are contained in given list. */
  displayMode_in?: InputMaybe<Array<InputMaybe<ImageMode>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayMode_not?: InputMaybe<ImageMode>;
  /** All values that are not contained in given list. */
  displayMode_not_in?: InputMaybe<Array<InputMaybe<ImageMode>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  theme?: InputMaybe<Theme>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Theme>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Theme>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ImportStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type Income = {
  __typename?: 'Income';
  additional?: Maybe<AdditionalIncome>;
  householdIncome?: Maybe<BaseIncome>;
  incomeVerification?: Maybe<IncomeVerificationStatus>;
  isAdditionalIncome?: Maybe<Scalars['Boolean']['output']>;
  isSkipAdditionalIncome?: Maybe<Scalars['Boolean']['output']>;
  isSkipPrimaryIncome?: Maybe<Scalars['Boolean']['output']>;
  partnerIncome?: Maybe<PartnerIncome>;
  primary?: Maybe<PrimaryIncome>;
};

export type IncomeClusterResult = {
  __typename?: 'IncomeClusterResult';
  category: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  frequency: Scalars['String']['output'];
  monthlyAmount: Scalars['Float']['output'];
  sampleSize: Scalars['Int']['output'];
};

export enum IncomeDocumentType {
  BankStatement = 'BankStatement',
  CentrelinkStatement = 'CentrelinkStatement',
  NotReadable = 'NotReadable',
  NoticeOfAssessment = 'NoticeOfAssessment',
  Others = 'Others',
  Payslip = 'Payslip',
  PensionStatement = 'PensionStatement',
  SuperannuationStatement = 'SuperannuationStatement',
  TaxAssessment = 'TaxAssessment',
}

export type IncomeInput = {
  additional?: InputMaybe<AdditionalIncomeInput>;
  householdIncome?: InputMaybe<BaseIncomeInput>;
  incomeVerification?: InputMaybe<IncomeVerificationStatus>;
  isAdditionalIncome?: InputMaybe<Scalars['Boolean']['input']>;
  isSkipAdditionalIncome?: InputMaybe<Scalars['Boolean']['input']>;
  isSkipPrimaryIncome?: InputMaybe<Scalars['Boolean']['input']>;
  partnerIncome?: InputMaybe<PartnerIncomeInput>;
  primary?: InputMaybe<PrimaryIncomeInput>;
};

export type IncomeSource = {
  __typename?: 'IncomeSource';
  accountId: Scalars['String']['output'];
  incomeClusters: Array<IncomeClusterResult>;
  institutionId: Scalars['String']['output'];
  institutionLogoUrl: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  maskedAccountNumber: Scalars['String']['output'];
  status?: Maybe<OpenBankingAccountVerifyStatus>;
  statusReason?: Maybe<OpenBankingAccountStatusReason>;
  totalMonthlyIncome?: Maybe<Scalars['Float']['output']>;
};

export enum IncomeVerificationInput {
  Failed = 'Failed',
}

export enum IncomeVerificationStatus {
  Failed = 'Failed',
  Passed = 'Passed',
  Pending = 'Pending',
}

export type InstallationAddress = {
  __typename?: 'InstallationAddress';
  dwellingType?: Maybe<Scalars['String']['output']>;
  occupancyStatus?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  state: AddressState;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  unimprovedValue?: Maybe<Scalars['Float']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type InstallationAddressInput = {
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  occupancyStatus?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: AddressState;
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unimprovedValue?: InputMaybe<Scalars['Float']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum InsulationType {
  Batt = 'BATT',
  LooseFill = 'LOOSE_FILL',
  LooseFit = 'LOOSE_FIT',
}

export type IssueUser = {
  __typename?: 'IssueUser';
  deleted?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated Legacy PHP admin portal id. Only use this for linking to the old admin portal until it is decommissioned. Use `id` (UUID) for all other purposes. */
  legacyId: Scalars['Int']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
};

export type IssueVendor = {
  __typename?: 'IssueVendor';
  id: Scalars['ID']['output'];
  legalName: Scalars['String']['output'];
  locked?: Maybe<Scalars['DateTime']['output']>;
  manager?: Maybe<BaseIdentity>;
  tradingName: Scalars['String']['output'];
};

export type Lead = {
  __typename?: 'Lead';
  address?: Maybe<AddressType>;
  category?: Maybe<Category>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: LeadCustomer;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  id: Scalars['Int']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  quotes?: Maybe<Array<Quote>>;
  status: Scalars['String']['output'];
  vendors?: Maybe<Array<Vendor>>;
};

export type LeadAttachment = {
  __typename?: 'LeadAttachment';
  documentId: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type LeadCustomer = {
  __typename?: 'LeadCustomer';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerified: Scalars['Boolean']['output'];
};

export type LeadEnterprisePartnerConfigurationFilter = {
  /** When set, restricts results to leads whose enterprise-partner configuration.packageEnabled matches this value. Resolved at query time via the enterprise service. */
  packageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LeadEnterprisePartnerFilter = {
  configuration?: InputMaybe<LeadEnterprisePartnerConfigurationFilter>;
};

export enum LeadIntent {
  Buy = 'buy',
  Interest = 'interest',
  Quote = 'quote',
}

export type LeadIntentOption = {
  __typename?: 'LeadIntentOption';
  label: Scalars['String']['output'];
  type: LeadIntent;
};

export type LeadsFilter = {
  OR?: InputMaybe<Array<LeadsFilterFields>>;
  agent?: InputMaybe<LeadsFilterAgentFields>;
  categorySlug?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  intent?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  vendor?: InputMaybe<LeadsFilterVendorFields>;
};

export type LeadsFilterAgentFields = {
  id?: InputMaybe<StringFilter>;
};

export type LeadsFilterFields = {
  agent?: InputMaybe<LeadsFilterAgentFields>;
  categorySlug?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  intent?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  vendor?: InputMaybe<LeadsFilterVendorFields>;
};

export type LeadsFilterVendorFields = {
  id?: InputMaybe<StringFilter>;
};

export type LeadsSort = {
  created?: InputMaybe<SortDir>;
  status?: InputMaybe<SortDir>;
};

export type License = {
  __typename?: 'License';
  created: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  status: LicenseStatus;
  type: LicenseType;
  updated: Scalars['DateTime']['output'];
  vendorId: Scalars['String']['output'];
};

export enum LicenseStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  NotVerified = 'NOT_VERIFIED',
}

export enum LicenseType {
  Netcc = 'NETCC',
  NswTrades = 'NSW_TRADES',
}

export type LinkSubmittedJointApplicantToAccountInput = {
  accountId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  customer: PrimaryCustomer;
  id: Scalars['String']['output'];
  legacyId: Scalars['Float']['output'];
};

export type Loan = Entity &
  Node & {
    __typename?: 'Loan';
    accountKeepingFee?: Maybe<Scalars['Float']['output']>;
    approvalTimeframe?: Maybe<Scalars['String']['output']>;
    comparison?: Maybe<Scalars['Float']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** The correct as at date, e.g. Oct 2022 */
    date?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<Loan>;
    establishment?: Maybe<Scalars['Float']['output']>;
    fixed?: Maybe<Scalars['Float']['output']>;
    /** List of Loan versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    key: Scalars['String']['output'];
    latePayment?: Maybe<Scalars['Float']['output']>;
    latePaymentCap?: Maybe<Scalars['Float']['output']>;
    maxAmount?: Maybe<Scalars['Float']['output']>;
    minAmount?: Maybe<Scalars['Float']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    repaymentTerms?: Maybe<Scalars['String']['output']>;
    /** Additional note (e.g. Up to 15 years for batteries) */
    repaymentTermsAdditional?: Maybe<Scalars['String']['output']>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type LoanCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LoanDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type LoanHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type LoanPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LoanScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type LoanUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  En = 'en',
}

export type Location = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LockVendorResponse = {
  __typename?: 'LockVendorResponse';
  success: Scalars['Boolean']['output'];
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ManufacturerPromotion = {
  __typename?: 'ManufacturerPromotion';
  categorySlug: Scalars['String']['output'];
  manufacturer: Manufacturer;
  manufacturerSlug: Scalars['String']['output'];
};

export type ManufacturersFilter = {
  battery?: InputMaybe<Scalars['Boolean']['input']>;
  electricHeatingAndCooling?: InputMaybe<Scalars['Boolean']['input']>;
  evCharging?: InputMaybe<Scalars['Boolean']['input']>;
  glazingWindow?: InputMaybe<Scalars['Boolean']['input']>;
  hotWaterHeatPump?: InputMaybe<Scalars['Boolean']['input']>;
  inverter?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilter>;
  pvPanel?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  solarHotWater?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManufacturersResponse = {
  __typename?: 'ManufacturersResponse';
  battery: Scalars['Boolean']['output'];
  batteryPremium?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  electricHeatingAndCooling: Scalars['Boolean']['output'];
  electricHeatingAndCoolingPremium?: Maybe<Scalars['Boolean']['output']>;
  evCharging: Scalars['Boolean']['output'];
  evChargingPremium?: Maybe<Scalars['Boolean']['output']>;
  glazingWindow: Scalars['Boolean']['output'];
  glazingWindowPremium?: Maybe<Scalars['Boolean']['output']>;
  hotWaterHeatPump: Scalars['Boolean']['output'];
  hotWaterHeatPumpPremium?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  inverter: Scalars['Boolean']['output'];
  inverterPremium?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  pvPanel: Scalars['Boolean']['output'];
  pvPanelPremium?: Maybe<Scalars['Boolean']['output']>;
  recentlyUsedByBattery?: Maybe<Scalars['Boolean']['output']>;
  recentlyUsedByInverter?: Maybe<Scalars['Boolean']['output']>;
  recentlyUsedByPvPanel?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  solarHotWater: Scalars['Boolean']['output'];
  solarHotWaterPremium?: Maybe<Scalars['Boolean']['output']>;
};

export type ManufacturersSort = {
  id?: InputMaybe<SortDir>;
  name?: InputMaybe<SortDir>;
  slug?: InputMaybe<SortDir>;
};

export type MarketplaceCategoriesFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  mode?: InputMaybe<CategoryFilterMode>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketplaceHttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE',
}

export type MarketplacePagination = {
  __typename?: 'MarketplacePagination';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MarketplacePromotionsFilter = {
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  promotionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MarketplaceSettings = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPricing?: InputMaybe<Array<VendorCategoryPricingInput>>;
  details?: InputMaybe<UpdateVendorDetailInput>;
  leadsAgentId?: InputMaybe<Scalars['String']['input']>;
  leadsLimit?: InputMaybe<Scalars['Float']['input']>;
  marketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  openingHours?: InputMaybe<Array<VendorOpeningHoursInput>>;
  serviceAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  unlimitedLeads?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketplaceVendor = {
  __typename?: 'MarketplaceVendor';
  approvedFinancialProducts?: Maybe<Array<FinancialProduct>>;
  categories?: Maybe<Array<Category>>;
  details: Array<VendorDetail>;
  id: Scalars['ID']['output'];
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketplacePromotions: Array<Promotion>;
  publicId: Scalars['String']['output'];
  rating?: Maybe<RatingResponse>;
  slug: Scalars['String']['output'];
  tradingName: Scalars['String']['output'];
};

export type MarketplaceVendorMarketplacePromotionsArgs = {
  filter?: InputMaybe<MarketplacePromotionsFilter>;
};

export type MarketplaceVendorScoreDetails = {
  __typename?: 'MarketplaceVendorScoreDetails';
  avgTimeToSettlement?: Maybe<Scalars['Float']['output']>;
  baseScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  lackOfRecentLeads?: Maybe<Scalars['Float']['output']>;
  latestDealMonthsAgo?: Maybe<Scalars['Int']['output']>;
  latestDealRecency?: Maybe<Scalars['Float']['output']>;
  /** Vendor's percentile rank (0–100) relative to all vendors' most recent base scores. Null for records ingested before percentile tracking was introduced — the value is populated on the next ingest event for that vendor. */
  percentile?: Maybe<Scalars['Int']['output']>;
  recentLeadsCount?: Maybe<Scalars['Int']['output']>;
  speedToSettle?: Maybe<Scalars['Float']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  tierScore?: Maybe<Scalars['Float']['output']>;
  vendorId: Scalars['String']['output'];
};

export type MarketplaceVendorScoreHistory = {
  __typename?: 'MarketplaceVendorScoreHistory';
  data: Array<Maybe<MarketplaceVendorScoreDetails>>;
  pagination: MarketplacePagination;
};

export type MarketplaceVendorsFilter = {
  brands?: InputMaybe<StringFilter>;
  categories?: InputMaybe<MarketplaceCategoriesFilter>;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  /** Kebab-case financial product slug (e.g. "commbank-residential"). Matches FinancialProduct.slug. */
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  leadsLimitReached?: InputMaybe<Scalars['Boolean']['input']>;
  onlyLocal?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCode?: InputMaybe<StringFilter>;
  publicId?: InputMaybe<StringFilter>;
};

export type MarketplaceVendorsResponse = {
  __typename?: 'MarketplaceVendorsResponse';
  count: Scalars['Int']['output'];
  vendors: Array<MarketplaceVendor>;
};

export type MarketplaceVendorsSort = {
  categoryPrice?: InputMaybe<MarketplaceVendorsSortCategoryPrice>;
  distance?: InputMaybe<SortDir>;
  random?: InputMaybe<MarketplaceVendorsSortRandom>;
};

export type MarketplaceVendorsSortCategoryPrice = {
  categorySlug: Scalars['String']['input'];
  sortDirection: SortDir;
};

export type MarketplaceVendorsSortRandom = {
  /** Optional seed for consistent randomization */
  seed?: InputMaybe<Scalars['String']['input']>;
};

export type Me = {
  __typename?: 'Me';
  dateOfBirth?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fpSynced?: Maybe<Scalars['DateTimeISO']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type Medicare = {
  __typename?: 'Medicare';
  color: MedicareCardColour;
  expiryDate: Scalars['String']['output'];
  number: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export enum MedicareCardColour {
  Blue = 'Blue',
  Green = 'Green',
  Yellow = 'Yellow',
}

export type MedicareDocInput = {
  cardColour: IdentityVerificationMedicareCardColour;
  /** YYYY-MM for Green, YYYY-MM-DD for Blue/Yellow */
  dateOfExpiry: Scalars['String']['input'];
  /** Middle name as it appears on the Medicare card */
  middleNameOnCard?: InputMaybe<Scalars['String']['input']>;
  /** 10-digit medicare number */
  number: Scalars['String']['input'];
  /** Individual reference number (1-9) */
  reference: Scalars['String']['input'];
};

export type MedicareInput = {
  color: MedicareCardColour;
  expiryDate: Scalars['String']['input'];
  number: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

export type MergeUsersInput = {
  mainUserId: Scalars['String']['input'];
  secondaryUserId: Scalars['String']['input'];
};

export type MergeUsersResponse = {
  __typename?: 'MergeUsersResponse';
  id: Scalars['String']['output'];
  mergedUserId: Scalars['String']['output'];
};

export type Meta = Entity & {
  __typename?: 'Meta';
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Should this be indexed by Google? */
  index?: Maybe<Scalars['Boolean']['output']>;
  sharingDescription?: Maybe<Scalars['String']['output']>;
  sharingImage?: Maybe<Asset>;
  sharingTitle?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MetaSharingImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/** Identifies documents */
export type MetaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Boolean']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetWhereInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type Metadata = {
  __typename?: 'Metadata';
  viewedTourGuide: Array<Scalars['String']['output']>;
};

export type MetadataInput = {
  viewedTourGuide: Array<Scalars['String']['input']>;
};

export enum Method {
  /** Credit card payment method */
  CreditCard = 'CREDIT_CARD',
  /** Direct debit payment method */
  DirectDebit = 'DIRECT_DEBIT',
}

export type Metric = Entity &
  Node & {
    __typename?: 'Metric';
    actualEmissionsPrevented?: Maybe<Scalars['Int']['output']>;
    actualEnergyGenerated?: Maybe<Scalars['Int']['output']>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    customers?: Maybe<Scalars['Int']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<Metric>;
    financeApplied?: Maybe<Scalars['Int']['output']>;
    financeApproved?: Maybe<Scalars['Int']['output']>;
    financeSettled?: Maybe<Scalars['Int']['output']>;
    /** List of Metric versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    installations?: Maybe<Scalars['Int']['output']>;
    potentialEmissionsPrevented?: Maybe<Scalars['Int']['output']>;
    potentialEnergyGenerated?: Maybe<Scalars['Int']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    solarInstallations?: Maybe<Scalars['Int']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
    vendors?: Maybe<Scalars['Int']['output']>;
  };

export type MetricCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MetricDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type MetricHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type MetricPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MetricScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type MetricUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptApplicationContract: MutationResponse;
  /** Add a key person to an application */
  accreditationAddIndividual: AccreditationApplication;
  /** Create new document(s) and get presigned URL for upload */
  accreditationCreateDocument: Array<AccreditationCreatedDocument>;
  /** Delete a document from an application */
  accreditationDeleteDocument: Scalars['Boolean']['output'];
  /** Remove a key person from an application */
  accreditationRemoveIndividual: AccreditationApplication;
  /** Trigger a workflow for an application */
  accreditationTriggerWorkflow: AccreditationApplication;
  /** Update document status after successful S3 upload */
  accreditationUpdateDocumentStatus: Scalars['Boolean']['output'];
  /** Required scopes: acknowledge:vendor-leads */
  acknowledgeVendorLead: VendorLead;
  activatePackage: Package;
  activateVendorUser: Scalars['Boolean']['output'];
  addJointApplicant: MutationResponse;
  addOpenBankingFeedBack: OpenBankingConsentFeedBack;
  addVendorUserIssueNote: Note;
  /** Required scopes: assign:vendor-leads */
  assignVendorLeads: Array<VendorLead>;
  /** Authenticate user by email otp */
  authenticatePasswordlessUserByEmail: AuthenticatePasswordlessUserResponse;
  /** Authenticate user by sms otp */
  authenticatePasswordlessUserBySMS: AuthenticatePasswordlessUserResponse;
  cancelOpenBankingConsent: CancelOpenbankingConsentDto;
  /**
   * Required scopes: update:finance-quotes
   * @deprecated Use `cancelReferral` mutation instead.
   */
  cancelQuote: CancelQuoteResponse;
  /** Required scopes: cancel:finance-referrals */
  cancelReferral: Referral;
  /** Required scopes: close:vendor-leads */
  closeVendorLeads: Array<VendorLead>;
  completeEnrollmentForUser: Enrollment;
  confirmCustomerAcknowledgement: CcaConfirmationResultDto;
  /** Create the contract with application values, adds smart-tags and sends it for signing */
  createAndSendContract: AccreditationApplication;
  /** Create app feedback */
  createAppFeedback: VendorBffCreateAppFeedbackResponse;
  /** Create initial application with email, or return existing one if applicationId is given. */
  createApplication: AccreditationCreatedApplication;
  createApplicationDocument: CreateApplicationDocumentResult;
  createApplicationFromQuote: MutationResponse;
  createBankStatementIframe: BankStatementIframe;
  createEnrollment: CreateEnrollmentResponse;
  /** Required scopes: update:finance-accounts */
  createFinanceAccountDocument: CreateDocumentResultDto;
  /** Create a log note for an application */
  createLog: AccreditationLogNote;
  createOrFindUser: User;
  /** Create passwordless user to start authentication flow by email or phone */
  createPasswordlessUser?: Maybe<Scalars['Void']['output']>;
  createPasswordlessUserById: CreatePasswordlessUserByIdResponse;
  /** Create passwordless user to start authentication flow by email or phone and return user id */
  createPasswordlessUserWithDetails?: Maybe<CreatePasswordlessUserResponse>;
  createPaymentMethod: CreatedPaymentMethod;
  /** Required scopes: create:finance-quotes */
  createProposal: CreateProposalResponse;
  /**
   * Required scopes: create:finance-quotes
   * @deprecated Use `createReferral` mutation instead (requires `create:finance-referrals` scope). Note: returns a CreateReferralResponse, not CreateQuoteResponse.
   */
  createQuote: CreateQuoteResponse;
  /** Required scopes: create:finance-referrals */
  createReferral: CreateReferralResponse;
  /** Create new support ticket */
  createSupportTicket: VendorBffCreateSupportTicketResponse;
  /** Reserve an ApplicationDocument row bound to a PropertyTitleOwner and return a presigned S3 POST. Pre-application — the document FK on applicationId is intentionally absent at DB level. */
  createTitleOwnerDocument: CreateApplicationDocumentResult;
  /** @deprecated Use createUserProfile (identity only) + vendor linking via the vendors service. This single-vendor create path is retained only for existing callers. */
  createUser: User;
  createUserProfile: User;
  createVendorUserIssue: VendorUserIssue;
  deleteApplicationDocument: DeleteApplicationDocumentResult;
  /** Required scopes: update:finance-accounts */
  deleteFinanceAccountDocument: DeleteDocumentResultDto;
  deleteJointApplicantFromApplication: Application;
  deletePaymentMethod: PaymentsResponse;
  /** Soft-delete a title-owner document. Best-effort removes the S3 object (if Uploaded) and marks the row Deleted. */
  deleteTitleOwnerDocument: DeleteApplicationDocumentResult;
  deleteUser: User;
  deleteVendorLogo?: Maybe<DeleteVendorLogoResponse>;
  handlePostApplicationLogin: Scalars['Boolean']['output'];
  /** Required scopes: read:leads */
  leadMarkRead: VendorLead;
  /** Required scopes: update:finance-accounts */
  linkSubmittedJointApplicantToAccount: Array<Customer>;
  makePayment: PaymentsResponse;
  markQuoteStarted: Scalars['Boolean']['output'];
  mergeUsers: MergeUsersResponse;
  /** request accreditation identity verification for an individual */
  requestAccreditationIdentityVerification: AccreditationIdentityVerificationResponse;
  requestAdditionalUserLimit?: Maybe<RequestAdditionalUserResponse>;
  requestApplicationDocument: Scalars['Boolean']['output'];
  requestApplicationDocuments: RequestApplicationDocumentsResult;
  requestCSVExport: CsvExportJobResponse;
  /** Request company credit check for an application */
  requestCompanyCreditCheck: AccreditationApplication;
  /** Required scopes: update:finance-accounts */
  requestFinanceAccountPayment: Account;
  /** Request individuals credit check for an application */
  requestIndividualsCreditCheck: AccreditationApplication;
  requestPasswordReset: Scalars['Boolean']['output'];
  /** Start title-owner document verification in the background. Returns a request id immediately; use getTitleOwnerDocumentVerification to read the result. */
  requestTitleOwnerDocumentVerification: TitleOwnerDocumentVerificationOutput;
  requestUserIssuesCSVExport: CsvExportJobResponse;
  requestVendorExport: VendorExportJobResponse;
  /**
   * Required scopes: update:finance-quotes
   * @deprecated Use `resendReferral` mutation instead.
   */
  resendQuote: Quote;
  /** Required scopes: resend:finance-referrals */
  resendReferral: Referral;
  resendSubmittedApplicationEvent: MutationResponse;
  restoreUser: User;
  revokeOpenBankingConsent: RevokeOpenBankingConsentDto;
  selectQuoteForOpportunity: SelectQuoteForOpportunityResponse;
  sendEmailVerification: SendEmailVerificationResponse;
  sendSmsVerification: SendSmsVerificationResponse;
  softDeleteUser: User;
  startPasswordlessAuth: AccreditationStartPasswordlessAuthResponse;
  /** Start a NSW property title search via Equifax. Returns immediately with searchStatus=ORDERED; owners arrive asynchronously via the notify-event callback. */
  startPropertyTitleSearch: StartPropertyTitleSearchOutput;
  /** Update agreement consent step */
  submitApplication: AccreditationApplication;
  submitApplicationDocuments: Scalars['Boolean']['output'];
  submitDocumentRequests: SubmitDocumentRequestsResult;
  submitEnrollment: Enrollment;
  /** Submit declared income for every PropertyTitleOwner in one call. Per-owner: isIncomeVerified = |declared − aiIncomeCalculated|/aiIncomeCalculated ≤ 0.10. */
  submitTitleOwnerIncome: SubmitTitleOwnerIncomeOutput;
  /** CT-3015. Finalize title-owner income. declaredIncome optional (reused from step 1); validates pensioner idMatrixReference against the persisted ACCEPT. */
  submitTitleSearchOwner: SubmitTitleSearchOwnerOutput;
  /** Required scopes: update:finance-accounts */
  triggerAccountExpiry: Scalars['Boolean']['output'];
  /** Required scopes: unclose:vendor-leads */
  uncloseVendorLeads: Array<VendorLead>;
  /** Update an application applicant */
  updateAccreditationApplicant: AccreditationApplication;
  /** Update an application */
  updateAccreditationApplication: AccreditationApplication;
  /** Update an application individual */
  updateAccreditationIndividual: AccreditationApplication;
  /** Required scopes: update:finance-accounts */
  updateAmounts: Account;
  updateApplicant: Applicant;
  updateApplication: MutationResponse;
  updateApplicationDocumentStatusUpdated: UpdateApplicationDocumentUploadedResult;
  updateApplicationTerm: MutationResponse;
  /** Create a workflow report for an application */
  updateApplicationWorkflowExecution: AccreditationApplicationWorkflowExecution;
  /** Update authorised personnel step */
  updateAuthorisedPersonnel: AccreditationApplication;
  updateEnrollmentProgress: Enrollment;
  updateEnterpriseLeadCategoryInternalNotes: EnterpriseLead;
  /** Required scopes: update:finance-accounts */
  updateFinanceAccountDocumentUploaded: UpdateDocumentUploadedResultDto;
  /** Required scopes: update:finance-accounts-payment-method */
  updateFinanceAccountPaymentMethod: Account;
  updateMe: Me;
  updateMyEnterpriseLeadCategories: EnterpriseLead;
  updateMyEnterpriseLeadCategoryContent: EnterpriseLead;
  updateMyEnterpriseLeadContact: EnterpriseLead;
  /** Update payment details application step */
  updatePaymentDetails: AccreditationApplication;
  updatePaymentMethod: PaymentsResponse;
  /** Update product and service details for an existing application */
  updateProductAndService: AccreditationApplication;
  /** update user's profile */
  updateProfile: VendorBffUserProfile;
  /** @deprecated Use `updateReferral` mutation instead. */
  updateQuote: Quote;
  /** Required scopes: update:finance-accounts */
  updateReferenceNumber: Account;
  /** Required scopes: update:finance-referrals */
  updateReferral: Referral;
  /** Update team and pipeline step */
  updateTeamAndPipeline: AccreditationApplication;
  /** Mark a title-owner document as Uploaded after the FE confirms the S3 POST returned 2xx. Verifies the S3 object exists before flipping status. */
  updateTitleOwnerDocumentStatus: UpdateApplicationDocumentUploadedResult;
  /** CT-3015. Persist declaredIncome + incomeType per owner (idempotent). Sets verificationStatus=PENDING. */
  updateTitleSearchOwner: UpdateTitleSearchOwnerOutput;
  updateUser: User;
  updateUsers: Array<User>;
  /** Required scopes: update:vendor-lead-notes */
  updateVendorLeadNotes: VendorLead;
  updateVendorLogo: UpdateVendorLogoResponse;
  /** Required scopes: update:vendor-settings */
  updateVendorMarketplaceSettings: Vendor;
  /** Required scopes: update:vendor-settings */
  updateVendorNotificationSettings: Vendor;
  /** Required scopes: update:vendor-settings */
  updateVendorProductSettings: Vendor;
  updateVendorsForUser: UpdateVendorsForUserResponse;
  validateDocumentRequestDocument: ValidateDocumentRequestDocumentResult;
  /** Adds a vendor user: creates a brand-new user identity, links them to the given vendors, and optionally marks them as authority contact per vendor (VENDOR role only). Rejects an existing email. Returns the U-prefixed user id. */
  vendorAddUser: AddVendorUserResult;
  /** Vendor self-service update of an owned vendor's product settings for an EXISTING, currently-enrolled product (an unenrolled product is rejected, and one disenrolled by the VT-1139 flag bridge counts as unenrolled): `activationStatus` updates the enrolment; `terms` is portal-owned and written via the finance service. Omitted fields are untouched. Returns the post-update settings view. */
  vendorUpdateMyEnrolledProductSettings: EnrolledFinancialProductSettings;
  /** Updates a vendor user via explicit deltas. A vendor may edit details (name/email/mobile/role) of its own users and remove (vendorsToRemove) them from vendors it owns, but cannot add a link or change authority-contact status — adds and authority-contact changes are Brighte-admin only. Always publishes vendors.vendorUser.updated. */
  vendorUpdateUser: UpdateVendorUserResult;
  /**
   * Verify an identity document (Driver Licence, Passport, or Medicare) via Equifax IDMatrix DVS
   * @deprecated Identity verification now runs automatically on updateApplication for the Identification step (Equifax IDMatrix). This mutation is retained temporarily for backward compatibility.
   */
  verifyIdentity: VerifyIdentityOutput;
  verifyIncomeDocumentUpload: VerifyIncomeDocumentUploadResult;
  verifyPasswordlessCode: AccreditationVerifyPasswordlessCodeResponse;
  /** Verify uploaded documents for one owner. verificationMethod=NOA runs the NOA path; SUPERANNUATION passes only classifier-recognised superannuation statements. */
  verifyTitleOwnerDocuments: VerifyIncomeDocumentUploadResult;
  /** Classify the uploaded NOAs for one PropertyTitleOwner via Bedrock, persist the documentClassification on each doc, and persist aiIncomeCalculated on the owner. NOA only — previous AU FY or the one before it. */
  verifyTitleOwnerIncomeDocuments: VerifyIncomeDocumentUploadResult;
  /** CT-3015. Verify a Pensioner Concession Card via Equifax IDMatrix CENTRELINK. Stores the idMatrixReference; ACCEPT => VERIFIED, else FAILED. */
  verifyTitleSearchOwnerPensioner: VerifyTitleSearchOwnerPensionerOutput;
  verifyUpdatedUserEmail: VerifyUpdatedUserEmailResponse;
  verifyUpdatedUserEmailByAdmin: VerifyUpdatedUserEmailResponse;
  verifyUpdatedUserMobile: VerifyUpdatedUserMobileResponse;
  verifyUpdatedUserMobileByAdmin: VerifyUpdatedUserMobileResponse;
  /** Required scopes: update:finance-accounts */
  withdrawApplication: Account;
  withdrawCustomerApplication: Application;
};

export type MutationAcceptApplicationContractArgs = {
  acceptApplicationContractInput: AcceptApplicationContractInput;
};

export type MutationAccreditationAddIndividualArgs = {
  input: AccreditationAddAccreditationIndividualInput;
};

export type MutationAccreditationCreateDocumentArgs = {
  input: AccreditationCreateDocumentInput;
};

export type MutationAccreditationDeleteDocumentArgs = {
  input: AccreditationDeleteDocumentInput;
};

export type MutationAccreditationRemoveIndividualArgs = {
  input: AccreditationRemoveIndividualInput;
};

export type MutationAccreditationTriggerWorkflowArgs = {
  input: AccreditationTriggerWorkflowInput;
};

export type MutationAccreditationUpdateDocumentStatusArgs = {
  input: AccreditationUpdateDocumentStatusInput;
};

export type MutationAcknowledgeVendorLeadArgs = {
  leadId: Scalars['Float']['input'];
  vendorId: Scalars['String']['input'];
};

export type MutationActivatePackageArgs = {
  packageId: Scalars['String']['input'];
};

export type MutationActivateVendorUserArgs = {
  input: ActivateVendorUserInput;
};

export type MutationAddJointApplicantArgs = {
  addJointApplicantInput: CreateJointApplicantInput;
};

export type MutationAddOpenBankingFeedBackArgs = {
  feedback: Array<OpenBankingFeedBack>;
};

export type MutationAddVendorUserIssueNoteArgs = {
  input: AddVendorUserIssueNoteInput;
};

export type MutationAssignVendorLeadsArgs = {
  input: AssignVendorLeadsInput;
};

export type MutationAuthenticatePasswordlessUserByEmailArgs = {
  input: AuthenticatePasswordlessUserByEmailInput;
};

export type MutationAuthenticatePasswordlessUserBySmsArgs = {
  input: AuthenticatePasswordlessUserBySmsInput;
};

export type MutationCancelOpenBankingConsentArgs = {
  applicationId: Scalars['String']['input'];
};

export type MutationCancelQuoteArgs = {
  input: CancelQuoteInput;
};

export type MutationCancelReferralArgs = {
  input: CancelReferralInput;
};

export type MutationCloseVendorLeadsArgs = {
  input: VendorLeadsBulkInput;
};

export type MutationCompleteEnrollmentForUserArgs = {
  input: CompleteEnrollmentForUserInput;
};

export type MutationConfirmCustomerAcknowledgementArgs = {
  accountId: Scalars['String']['input'];
  acknowledgements: Array<Scalars['String']['input']>;
  confirmed: Scalars['Boolean']['input'];
  metadata: CcaMetadata;
  tokenPlain: Scalars['String']['input'];
};

export type MutationCreateAndSendContractArgs = {
  input: AccreditationCreateAndSendContractInput;
};

export type MutationCreateAppFeedbackArgs = {
  input: VendorBffCreateAppFeedbackInput;
};

export type MutationCreateApplicationArgs = {
  input: AccreditationCreateApplicationInput;
};

export type MutationCreateApplicationDocumentArgs = {
  CreateApplicationDocumentInput: CreateApplicationDocumentInput;
};

export type MutationCreateApplicationFromQuoteArgs = {
  createApplicationFromQuoteInput: CreateApplicationFromQuoteInput;
};

export type MutationCreateEnrollmentArgs = {
  input: CreateEnrollmentInput;
};

export type MutationCreateFinanceAccountDocumentArgs = {
  input: CreateDocumentInputDto;
};

export type MutationCreateLogArgs = {
  input: AccreditationCreateLogNoteInput;
};

export type MutationCreateOrFindUserArgs = {
  input: CreateOrFindUserInput;
};

export type MutationCreatePasswordlessUserArgs = {
  input: CreatePasswordlessUserInput;
};

export type MutationCreatePasswordlessUserByIdArgs = {
  input: CreatePasswordlessUserByIdInput;
};

export type MutationCreatePasswordlessUserWithDetailsArgs = {
  input: CreatePasswordlessUserInput;
};

export type MutationCreatePaymentMethodArgs = {
  paymentMethod: PaymentMethodInput;
};

export type MutationCreateProposalArgs = {
  input: CreateProposalInput;
};

export type MutationCreateQuoteArgs = {
  input: CreateQuoteInput;
};

export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};

export type MutationCreateSupportTicketArgs = {
  input: VendorBffCreateSupportTicketInput;
};

export type MutationCreateTitleOwnerDocumentArgs = {
  input: CreateTitleOwnerDocumentInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateUserProfileArgs = {
  input: CreateUserProfileInput;
};

export type MutationCreateVendorUserIssueArgs = {
  input: CreateVendorUserIssueInput;
};

export type MutationDeleteApplicationDocumentArgs = {
  DeleteApplicationDocumentInput: ApplicationDocumentOperationInput;
};

export type MutationDeleteFinanceAccountDocumentArgs = {
  accountId: Scalars['String']['input'];
  documentId: Scalars['Int']['input'];
};

export type MutationDeleteJointApplicantFromApplicationArgs = {
  applicationId: Scalars['String']['input'];
};

export type MutationDeletePaymentMethodArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MutationDeleteTitleOwnerDocumentArgs = {
  input: TitleOwnerDocumentOperationInput;
};

export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};

export type MutationDeleteVendorLogoArgs = {
  vendorId: Scalars['String']['input'];
};

export type MutationHandlePostApplicationLoginArgs = {
  postLoginInput: PostLoginInput;
};

export type MutationLeadMarkReadArgs = {
  leadId: Scalars['Float']['input'];
  readDate?: InputMaybe<Scalars['DateTime']['input']>;
  vendorId: Scalars['String']['input'];
};

export type MutationLinkSubmittedJointApplicantToAccountArgs = {
  input: LinkSubmittedJointApplicantToAccountInput;
};

export type MutationMakePaymentArgs = {
  payment: PaymentInput;
};

export type MutationMarkQuoteStartedArgs = {
  input: QuoteStartedInput;
};

export type MutationMergeUsersArgs = {
  input: MergeUsersInput;
};

export type MutationRequestAccreditationIdentityVerificationArgs = {
  input: AccreditationRequestIdentityVerificationInput;
};

export type MutationRequestAdditionalUserLimitArgs = {
  requestNumber: Scalars['Int']['input'];
  vendorId: Scalars['String']['input'];
};

export type MutationRequestApplicationDocumentArgs = {
  RequestApplicationDocumentInput: RequestApplicationDocumentInput;
};

export type MutationRequestApplicationDocumentsArgs = {
  RequestApplicationDocumentsInput: RequestApplicationDocumentsInput;
};

export type MutationRequestCsvExportArgs = {
  input: CsvExportRequestInput;
};

export type MutationRequestCompanyCreditCheckArgs = {
  input: AccreditationCreateCompanyCheckInput;
};

export type MutationRequestFinanceAccountPaymentArgs = {
  input: RequestFinanceAccountPaymentDto;
};

export type MutationRequestIndividualsCreditCheckArgs = {
  input: AccreditationCreateIndividualCheckInput;
};

export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};

export type MutationRequestTitleOwnerDocumentVerificationArgs = {
  input: VerifyTitleOwnerDocumentsInput;
};

export type MutationRequestVendorExportArgs = {
  input: VendorExportRequestInput;
};

export type MutationResendQuoteArgs = {
  input: ResendQuoteInput;
};

export type MutationResendReferralArgs = {
  input: ResendReferralInput;
};

export type MutationResendSubmittedApplicationEventArgs = {
  incomeVerification?: InputMaybe<IncomeVerificationInput>;
  joint?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId: Scalars['String']['input'];
};

export type MutationRestoreUserArgs = {
  input: RestoreUserInput;
};

export type MutationRevokeOpenBankingConsentArgs = {
  consentId: Scalars['String']['input'];
};

export type MutationSelectQuoteForOpportunityArgs = {
  input: SelectQuoteForOpportunityInput;
};

export type MutationSendEmailVerificationArgs = {
  email: Scalars['String']['input'];
};

export type MutationSendSmsVerificationArgs = {
  mobile: Scalars['String']['input'];
};

export type MutationSoftDeleteUserArgs = {
  input: SoftDeleteUserInput;
};

export type MutationStartPasswordlessAuthArgs = {
  input: AccreditationStartPasswordlessAuthInput;
};

export type MutationStartPropertyTitleSearchArgs = {
  input: StartPropertyTitleSearchInput;
};

export type MutationSubmitApplicationArgs = {
  input: AccreditationSubmitApplicationInput;
};

export type MutationSubmitApplicationDocumentsArgs = {
  SubmitApplicationDocumentsInput: SubmitApplicationDocumentsInput;
};

export type MutationSubmitDocumentRequestsArgs = {
  SubmitDocumentRequestsInput: SubmitDocumentRequestsInput;
};

export type MutationSubmitEnrollmentArgs = {
  input: SubmitEnrollmentInput;
};

export type MutationSubmitTitleOwnerIncomeArgs = {
  input: SubmitTitleOwnerIncomeInput;
};

export type MutationSubmitTitleSearchOwnerArgs = {
  input: SubmitTitleSearchOwnerInput;
};

export type MutationUncloseVendorLeadsArgs = {
  input: VendorLeadsBulkInput;
};

export type MutationUpdateAccreditationApplicantArgs = {
  input: AccreditationUpdateAccreditationApplicantInput;
};

export type MutationUpdateAccreditationApplicationArgs = {
  input: AccreditationUpdateAccreditationApplicationInput;
};

export type MutationUpdateAccreditationIndividualArgs = {
  input: AccreditationUpdateAccreditationIndividualInput;
};

export type MutationUpdateAmountsArgs = {
  input: UpdateAccountAmounts;
};

export type MutationUpdateApplicantArgs = {
  input: UpdateApplicantInputForAdmin;
};

export type MutationUpdateApplicationArgs = {
  updateApplicationInput: UpdateApplicationInput;
};

export type MutationUpdateApplicationDocumentStatusUpdatedArgs = {
  UpdateApplicationDocumentStatusUpdatedInput: ApplicationDocumentOperationInput;
};

export type MutationUpdateApplicationTermArgs = {
  updateApplicationTermInput: UpdateApplicationTermInput;
};

export type MutationUpdateApplicationWorkflowExecutionArgs = {
  input: AccreditationUpdateApplicationWorkflowExecutionInput;
};

export type MutationUpdateAuthorisedPersonnelArgs = {
  input: AccreditationUpdateAuthorisedPersonnelInput;
};

export type MutationUpdateEnrollmentProgressArgs = {
  input: UpdateEnrollmentProgressInput;
};

export type MutationUpdateEnterpriseLeadCategoryInternalNotesArgs = {
  input: UpdateEnterpriseLeadCategoryInternalNotesInput;
};

export type MutationUpdateFinanceAccountDocumentUploadedArgs = {
  accountId: Scalars['String']['input'];
  documentId: Scalars['Int']['input'];
};

export type MutationUpdateFinanceAccountPaymentMethodArgs = {
  input: UpdateAccountPaymentMethod;
};

export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};

export type MutationUpdateMyEnterpriseLeadCategoriesArgs = {
  categorySlugs: Array<Scalars['String']['input']>;
};

export type MutationUpdateMyEnterpriseLeadCategoryContentArgs = {
  input: UpdateMyEnterpriseLeadCategoryContentInput;
};

export type MutationUpdateMyEnterpriseLeadContactArgs = {
  input: UpdateMyEnterpriseLeadContactInput;
};

export type MutationUpdatePaymentDetailsArgs = {
  input: AccreditationUpdatePaymentDetailsInput;
};

export type MutationUpdatePaymentMethodArgs = {
  cardExpiry: Scalars['String']['input'];
  id: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type MutationUpdateProductAndServiceArgs = {
  input: AccreditationUpdateProductAndServiceInput;
};

export type MutationUpdateProfileArgs = {
  input: VendorBffUpdateProfileInput;
};

export type MutationUpdateQuoteArgs = {
  input: UpdateQuoteInput;
};

export type MutationUpdateReferenceNumberArgs = {
  input: UpdateAccountReferenceNumber;
};

export type MutationUpdateReferralArgs = {
  input: UpdateReferralInput;
};

export type MutationUpdateTeamAndPipelineArgs = {
  input: AccreditationUpdateTeamAndPipelineInput;
};

export type MutationUpdateTitleOwnerDocumentStatusArgs = {
  input: TitleOwnerDocumentOperationInput;
};

export type MutationUpdateTitleSearchOwnerArgs = {
  input: UpdateTitleSearchOwnerInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateUsersArgs = {
  input: UpdateUsersInput;
};

export type MutationUpdateVendorLeadNotesArgs = {
  leadId: Scalars['Float']['input'];
  notes: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type MutationUpdateVendorLogoArgs = {
  input: UpdateVendorLogoInput;
};

export type MutationUpdateVendorMarketplaceSettingsArgs = {
  input: UpdateMarketplaceSettingsInput;
};

export type MutationUpdateVendorNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};

export type MutationUpdateVendorProductSettingsArgs = {
  input: UpdateProductSettingsInput;
};

export type MutationUpdateVendorsForUserArgs = {
  input: UpdateVendorsForUserInput;
};

export type MutationValidateDocumentRequestDocumentArgs = {
  ValidateDocumentRequestDocumentInput: ValidateDocumentRequestDocumentInput;
};

export type MutationVendorAddUserArgs = {
  input: AddVendorUserInput;
};

export type MutationVendorUpdateMyEnrolledProductSettingsArgs = {
  input: UpdateMyVendorEnrolledProductSettingsInput;
};

export type MutationVendorUpdateUserArgs = {
  input: UpdateVendorUserInput;
};

export type MutationVerifyIdentityArgs = {
  input: VerifyIdentityInput;
};

export type MutationVerifyIncomeDocumentUploadArgs = {
  VerifyIncomeDocumentUploadInput: VerifyIncomeDocumentUploadInput;
};

export type MutationVerifyPasswordlessCodeArgs = {
  input: AccreditationVerifyPasswordlessCodeInput;
};

export type MutationVerifyTitleOwnerDocumentsArgs = {
  input: VerifyTitleOwnerDocumentsInput;
};

export type MutationVerifyTitleOwnerIncomeDocumentsArgs = {
  input: VerifyTitleOwnerIncomeDocumentsInput;
};

export type MutationVerifyTitleSearchOwnerPensionerArgs = {
  input: VerifyTitleSearchOwnerPensionerInput;
};

export type MutationVerifyUpdatedUserEmailArgs = {
  authCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type MutationVerifyUpdatedUserEmailByAdminArgs = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationVerifyUpdatedUserMobileArgs = {
  authCode: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};

export type MutationVerifyUpdatedUserMobileByAdminArgs = {
  id: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};

export type MutationWithdrawApplicationArgs = {
  input: WithdrawApplication;
};

export type MutationWithdrawCustomerApplicationArgs = {
  withdrawnApplication: WithdrawApplicationInput;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  applicationId: Scalars['String']['output'];
  relatedApplicationIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

export type Note = {
  __typename?: 'Note';
  account?: Maybe<LinkedAccount>;
  content: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  reporter: BaseIdentity;
  resolution?: Maybe<Scalars['Int']['output']>;
};

export type Notice = Entity &
  Node & {
    __typename?: 'Notice';
    /** The content of the notice */
    content?: Maybe<RichText>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<Notice>;
    /** List of Notice versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** A list of URLs to include, e.g. /, /about, /homeowners */
    includes: Array<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** Not displayed on the site. This is used as an identifier in the CMS only. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type NoticeCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NoticeDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type NoticeHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type NoticePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NoticeScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type NoticeUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NotificationSettings = {
  applicationStatus?: InputMaybe<Array<ApplicationStatus>>;
  remittanceAdviceGroupUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NumberFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Occupation = {
  __typename?: 'Occupation';
  code: Scalars['String']['output'];
  incomeThreshold: Scalars['Float']['output'];
  jobTitle: Scalars['String']['output'];
};

export type OccupationAlternative = {
  __typename?: 'OccupationAlternative';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['Int']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type OccupationMatch = {
  __typename?: 'OccupationMatch';
  alternatives?: Maybe<Array<OccupationAlternative>>;
  bestMatch: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['Int']['output']>;
  confidenceLevel: Scalars['String']['output'];
  matchFound: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  potentialMatches?: Maybe<Array<OccupationAlternative>>;
  processingTimeMs: Scalars['Float']['output'];
  salary?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  userInput: Scalars['String']['output'];
};

export type OccupationMatchInput = {
  jobTitle: Scalars['String']['input'];
};

export type OccupationMatchResponse = {
  __typename?: 'OccupationMatchResponse';
  jobTitle: Scalars['String']['output'];
  matches: OccupationMatch;
  status: Scalars['String']['output'];
};

export type OpenBankingAccount = {
  __typename?: 'OpenBankingAccount';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  accountOwnership: Scalars['String']['output'];
  fiskilId: Scalars['String']['output'];
  maskedNumber: Scalars['String']['output'];
  openBankingConsentId: Scalars['String']['output'];
  status: OpenBankingAccountVerifyStatus;
  statusReason?: Maybe<OpenBankingAccountStatusReason>;
  synced?: Maybe<Scalars['DateTime']['output']>;
};

/** Reason why an account was rejected for income analysis. */
export enum OpenBankingAccountStatusReason {
  BusinessAccount = 'BUSINESS_ACCOUNT',
  ReplicatedPrimary = 'REPLICATED_PRIMARY',
}

/** The verification status of the Open Banking account. */
export enum OpenBankingAccountVerifyStatus {
  Failed = 'FAILED',
  Verified = 'VERIFIED',
}

export type OpenBankingCategory = {
  __typename?: 'OpenBankingCategory';
  confidence_level?: Maybe<Scalars['String']['output']>;
  primary_category?: Maybe<Scalars['String']['output']>;
  secondary_category?: Maybe<Scalars['String']['output']>;
};

export type OpenBankingCategoryInput = {
  confidence_level?: InputMaybe<Scalars['String']['input']>;
  primary_category?: InputMaybe<Scalars['String']['input']>;
  secondary_category?: InputMaybe<Scalars['String']['input']>;
};

export type OpenBankingConsent = {
  __typename?: 'OpenBankingConsent';
  accounts?: Maybe<Array<OpenBankingAccount>>;
  accountsSynced?: Maybe<Scalars['DateTime']['output']>;
  consentId?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  endUserId: Scalars['String']['output'];
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  institutionId?: Maybe<Scalars['String']['output']>;
  institutionLogoUrl?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  openBankingIncome?: Maybe<AggregatedIncomeResult>;
  provider: OpenBankingProvider;
  revoked?: Maybe<Scalars['DateTime']['output']>;
  updated: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type OpenBankingConsentFeedBack = {
  __typename?: 'OpenBankingConsentFeedBack';
  feedback: Array<OpenBankingFeedBack>;
  userId: Scalars['String']['output'];
};

export type OpenBankingConsentUrl = {
  __typename?: 'OpenBankingConsentUrl';
  authSessionId: Scalars['String']['output'];
  expiry: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type OpenBankingDataDto = {
  __typename?: 'OpenBankingDataDto';
  accounts: Array<OpenBankingAccount>;
  income?: Maybe<AggregatedIncomeResult>;
};

export type OpenBankingExtendedData = {
  __typename?: 'OpenBankingExtendedData';
  extension_u_type?: Maybe<Scalars['String']['output']>;
  payee?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  x2p101_payload?: Maybe<OpenBankingX2P101Payload>;
};

export type OpenBankingExtendedDataInput = {
  extension_u_type?: InputMaybe<Scalars['String']['input']>;
  payee?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  x2p101_payload?: InputMaybe<OpenBankingX2P101PayloadInput>;
};

export enum OpenBankingFeedBack {
  Other = 'OTHER',
  PreferManual = 'PREFER_MANUAL',
  ProblemLoggingIn = 'PROBLEM_LOGGING_IN',
  TooComplicated = 'TOO_COMPLICATED',
}

export type OpenBankingIncomeDto = {
  __typename?: 'OpenBankingIncomeDto';
  incomeSources: Array<IncomeSource>;
  totalMonthlyIncome?: Maybe<Scalars['Float']['output']>;
};

export type OpenBankingLinks = {
  __typename?: 'OpenBankingLinks';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

export type OpenBankingLinksInput = {
  next?: InputMaybe<Scalars['String']['input']>;
  prev?: InputMaybe<Scalars['String']['input']>;
};

/** The provider of the CDR data. */
export enum OpenBankingProvider {
  Fiskil = 'FISKIL',
}

export type OpenBankingTransaction = {
  __typename?: 'OpenBankingTransaction';
  account_id: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  apca_number?: Maybe<Scalars['String']['output']>;
  arrangement_id: Scalars['String']['output'];
  biller_code?: Maybe<Scalars['String']['output']>;
  biller_name?: Maybe<Scalars['String']['output']>;
  category?: Maybe<OpenBankingCategory>;
  crn?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  execution_date_time?: Maybe<Scalars['String']['output']>;
  extended_data: OpenBankingExtendedData;
  fiskil_id: Scalars['String']['output'];
  institution_id: Scalars['String']['output'];
  is_detail_available?: Maybe<Scalars['Boolean']['output']>;
  merchant_category_code?: Maybe<Scalars['String']['output']>;
  merchant_name?: Maybe<Scalars['String']['output']>;
  posting_date_time?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transaction_id?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value_date_time?: Maybe<Scalars['String']['output']>;
};

export type OpenBankingTransactionInput = {
  account_id: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  apca_number?: InputMaybe<Scalars['String']['input']>;
  arrangement_id: Scalars['String']['input'];
  biller_code?: InputMaybe<Scalars['String']['input']>;
  biller_name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<OpenBankingCategoryInput>;
  crn?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  execution_date_time?: InputMaybe<Scalars['String']['input']>;
  extended_data: OpenBankingExtendedDataInput;
  fiskil_id: Scalars['String']['input'];
  institution_id: Scalars['String']['input'];
  is_detail_available?: InputMaybe<Scalars['Boolean']['input']>;
  merchant_category_code?: InputMaybe<Scalars['String']['input']>;
  merchant_name?: InputMaybe<Scalars['String']['input']>;
  posting_date_time?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  status: Scalars['String']['input'];
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value_date_time?: InputMaybe<Scalars['String']['input']>;
};

export type OpenBankingTransactionsInput = {
  links: OpenBankingLinksInput;
  transactions: Array<OpenBankingTransactionInput>;
};

export type OpenBankingX2P101Payload = {
  __typename?: 'OpenBankingX2P101Payload';
  end_to_end_id?: Maybe<Scalars['String']['output']>;
  extended_description?: Maybe<Scalars['String']['output']>;
  purpose_code?: Maybe<Scalars['String']['output']>;
};

export type OpenBankingX2P101PayloadInput = {
  end_to_end_id?: InputMaybe<Scalars['String']['input']>;
  extended_description?: InputMaybe<Scalars['String']['input']>;
  purpose_code?: InputMaybe<Scalars['String']['input']>;
};

export type OpenDocumentRequestSummary = {
  __typename?: 'OpenDocumentRequestSummary';
  applicationId: Scalars['String']['output'];
  openRequestCount: Scalars['Int']['output'];
};

export type OpenDocumentRequestsInput = {
  applicationIds: Array<Scalars['String']['input']>;
};

export type OpportunityCategory = {
  __typename?: 'OpportunityCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type OpportunityPackageStatus = {
  __typename?: 'OpportunityPackageStatus';
  applicationStatus?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['ID']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export enum OpportunityStatus {
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  Quoted = 'QUOTED',
}

export type OrderStatusHistoryResponse = {
  __typename?: 'OrderStatusHistoryResponse';
  actor?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  expiryMessageWarning?: Maybe<Scalars['String']['output']>;
  stage: Scalars['String']['output'];
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusLabel: Scalars['String']['output'];
  withdrawnBy?: Maybe<Scalars['String']['output']>;
};

export type Other = {
  __typename?: 'Other';
  name: Scalars['String']['output'];
};

export type OtherInput = {
  name: Scalars['String']['input'];
};

export enum OwnershipType {
  Corporate = 'Corporate',
  Individual = 'Individual',
  Proprietary = 'Proprietary',
  Public = 'Public',
}

export type Package = {
  __typename?: 'Package';
  active: Scalars['Boolean']['output'];
  applicationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCashPayment: Scalars['Boolean']['output'];
  opportunityId: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
  quotes: Array<QuotePackage>;
  trackingIds: Array<Scalars['String']['output']>;
};

export type PackageDetails = {
  __typename?: 'PackageDetails';
  applicationUrl?: Maybe<Scalars['String']['output']>;
  isCashPayment: Scalars['Boolean']['output'];
  packageId: Scalars['ID']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type Page = Entity &
  Node & {
    __typename?: 'Page';
    content?: Maybe<PagecontentUnion>;
    contents?: Maybe<PageBgbl>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<Page>;
    /** List of Page versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    meta?: Maybe<Meta>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** This is internal use only. Not displayed on the website. */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type PageContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageContentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type PageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type PageMetaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type PageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageBgbl = Entity & {
  __typename?: 'PageBGBL';
  detailsHeading?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<AccordionGroup>;
  h1?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  intro?: Maybe<Scalars['String']['output']>;
  productDetails: Array<Detail>;
  proofs: Array<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  terms?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PageBgblFaqArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageBgblImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageBgblProductDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DetailWhereInput>;
};

export type PagePartnerMarketingHub = Entity & {
  __typename?: 'PagePartnerMarketingHub';
  documents?: Maybe<DocumentList>;
  groups: Array<DownloadGroup>;
  h1?: Maybe<Scalars['String']['output']>;
  helpContent?: Maybe<RichText>;
  helpHeading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  introHeading?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PagePartnerMarketingHubDocumentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PagePartnerMarketingHubGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DownloadGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadGroupWhereInput>;
};

export type PagecontentUnion = PageBgbl | PagePartnerMarketingHub;

export type ParentCategory = {
  __typename?: 'ParentCategory';
  /** Required scopes: update:categories */
  accessFields?: Maybe<CategoryAccessFields>;
  financialProducts?: Maybe<Array<FinancialProduct>>;
  group?: Maybe<CategoryGroup>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  indicativePrice?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether this product category is compatible with the Origin virtual power plant (VPP) pilot. */
  isVirtualPowerPlantCompatible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<Category>;
  slug: Scalars['String']['output'];
  subCategories?: Maybe<Array<Category>>;
  subFields?: Maybe<Array<CategorySubFields>>;
  tags?: Maybe<Array<Tag>>;
};

export type PartnerConfigChannel = {
  __typename?: 'PartnerConfigChannel';
  /** Hygraph content slug for channel-specific rich content (FAQs, guides) in customer-connect. When unset, consumers fall back to financial-product content. */
  cmsContentSlug?: Maybe<Scalars['String']['output']>;
  /** Channel-level contact-form field config. Null/omitted = consumers fall back to the deprecated partner-level `customerIdRequirement`. */
  contactForm?: Maybe<ContactFormConfig>;
  /** Financial product for this channel, e.g. "brighte-pay" */
  financialProductId?: Maybe<Scalars['String']['output']>;
  /** If set, restricts access to a specific postcode. null = no restriction. */
  fixedPostcode?: Maybe<Scalars['String']['output']>;
  /** If true, the channel has its own header logo asset. Consumers derive the logo URL from the channel slug and fall back to the partner logo when null/false. */
  hasChannelLogo?: Maybe<Scalars['Boolean']['output']>;
  /** Hero image name shown in customer-facing emails (e.g. the lead-received email), e.g. "racq-hero". Consumers resolve it to the email asset base and a ".png" extension. Null/omitted = consumers fall back to their default hero image. */
  heroImage?: Maybe<Scalars['String']['output']>;
  /** Override for lead card heading in vendor-portal (e.g. "Electrify 2515 Community Pilot") */
  leadLabel?: Maybe<Scalars['String']['output']>;
  /** Pre-marketplace flow config. Null = channel is not authorized for pre-marketplace; consumers must reject access. */
  preMarketplace?: Maybe<PreMarketplaceConfig>;
  /** Ordered "what happens next" steps shown on the customer success/progress screens. Null/omitted = consumers fall back to their default steps. */
  progressSteps?: Maybe<Array<ProgressStep>>;
  /** Minimum categories required for this channel (e.g. on the lead or as a selected quote) before a buyer can progress. Null/omitted = no category requirement. */
  requiredCategories?: Maybe<Array<RequiredCategory>>;
  /** If explicitly false, consumers must not render the channel/partner logo (or its separator) at all. Null/omitted/true = show as today. Opt-out, for partners whose branding rules disallow a lockup with the Brighte logo. Consumers should check `showChannelLogo !== false` rather than relying on truthiness, since null/omitted must still show the logo. */
  showChannelLogo?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the "Need help?" (speak-to-expert) panel is shown in the marketplace. Omitted/false = hidden (default). Opt-in per channel. */
  showNeedHelpPanel?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the title in the marketplace page */
  showTitleInMarketplace: Scalars['Boolean']['output'];
  /** URL-safe slug used in routes and channel lookup, e.g. "racq", "electrify-2515" */
  slug: Scalars['String']['output'];
  /** Optional channel-specific content for the marketplace Need Help panel. When omitted, consumers use their default support experience. */
  supportDetails?: Maybe<PartnerConfigSupportDetails>;
  /** Title displayed in the marketplace header */
  title?: Maybe<Scalars['String']['output']>;
  /** Channel-specific content for vendor-facing emails. */
  vendorEmail?: Maybe<VendorEmailConfig>;
  /** URL to vendor guidelines shown in vendor-portal lead card */
  vendorGuidelineUrl?: Maybe<Scalars['String']['output']>;
  /** Vendor sorting preference for recommended vendors: "RANDOM" | "DISTANCE" | "RANKING". Channel-level canonical field. */
  vendorSortingPreference?: Maybe<Scalars['String']['output']>;
};

export type PartnerConfigStepFlow = {
  __typename?: 'PartnerConfigStepFlow';
  id: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  /** When set, the step is shown only if this condition holds against the buyer's prior answers. When null/omitted, the step is always shown (default). Only references answers from steps that appear EARLIER in stepFlow. */
  visibleWhen?: Maybe<StepVisibilityCondition>;
};

export type PartnerConfigSupportDetails = {
  __typename?: 'PartnerConfigSupportDetails';
  /** Exact portion of the support message rendered as a link. */
  linkText: Scalars['String']['output'];
  /** Destination URL for the linked support message text. */
  linkUrl: Scalars['String']['output'];
  /** Support message displayed in the marketplace Need Help panel. */
  text: Scalars['String']['output'];
};

export type PartnerIncome = {
  __typename?: 'PartnerIncome';
  amount: Scalars['Float']['output'];
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  period: Period;
};

export type PartnerIncomeInput = {
  amount: Scalars['Float']['input'];
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  period: Period;
};

export type PartnershipDetail = {
  __typename?: 'PartnershipDetail';
  beneficialOwners?: Maybe<Array<EnterpriseIdentityWithIdentification>>;
  corporateEntities?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<SmeDirector>>;
  ownershipType: OwnershipType;
};

export type PartnershipDetailInput = {
  beneficialOwners?: InputMaybe<Array<EnterpriseIdentityWithIdentificationInput>>;
  corporateEntities?: InputMaybe<Scalars['String']['input']>;
  directors?: InputMaybe<Array<SmeDirectorInput>>;
  ownershipType: OwnershipType;
};

export type Passport = {
  __typename?: 'Passport';
  expiryDate: Scalars['String']['output'];
  issuingCountry: Scalars['String']['output'];
  number: Scalars['String']['output'];
};

export type PassportInput = {
  expiryDate: Scalars['String']['input'];
  issuingCountry: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  displayStatus?: Maybe<PaymentDisplayStatus>;
  modified: Scalars['DateTime']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentId: Scalars['String']['output'];
  reverseId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export enum PaymentCardType {
  Amex = 'AMEX',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Unknown = 'UNKNOWN',
  Visa = 'VISA',
}

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  isCashApplication?: Maybe<Scalars['Boolean']['output']>;
  methodId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<PaymentFunds>;
};

export type PaymentDetailsInput = {
  methodId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PaymentFunds>;
};

export enum PaymentDisplayStatus {
  Confirmed = 'Confirmed',
  Declined = 'Declined',
  Pending = 'Pending',
  Reversal = 'Reversal',
}

export enum PaymentFunds {
  CurrentSavings = 'CurrentSavings',
  FutureEarnings = 'FutureEarnings',
  MortgageRedraw = 'MortgageRedraw',
}

export type PaymentInput = {
  amount: Scalars['Float']['input'];
  loanId: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  source: PaymentSource;
  transactionReference?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  bankAccountName?: Maybe<Scalars['String']['output']>;
  bankBsb?: Maybe<Scalars['String']['output']>;
  creditCardExpiry?: Maybe<Scalars['String']['output']>;
  maskedBankAccountNumber?: Maybe<Scalars['String']['output']>;
  maskedCreditCardInfo?: Maybe<Scalars['String']['output']>;
  paymentMethod: Method;
};

export type PaymentMethodInput = {
  accountBsb?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  cardExpiry?: InputMaybe<Scalars['String']['input']>;
  cardHolder?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<PaymentCardType>;
  source: PaymentMethodSource;
  token?: InputMaybe<Scalars['String']['input']>;
  type: PaymentType;
  userId: Scalars['String']['input'];
};

export enum PaymentMethodSource {
  ConsumerApp = 'ConsumerApp',
  CustomerPortal = 'CustomerPortal',
  CustomerWebApplication = 'CustomerWebApplication',
  OneOffPayment = 'OneOffPayment',
  Portal = 'Portal',
  VendorApp = 'VendorApp',
}

export type PaymentMethodUnion = CardPaymentMethod | DebitPaymentMethod;

export enum PaymentSource {
  ConsumerApp = 'ConsumerApp',
  CustomerPortal = 'CustomerPortal',
  OneOffPayment = 'OneOffPayment',
}

export enum PaymentType {
  Card = 'CARD',
  Debit = 'DEBIT',
}

export type PaymentsFilter = {
  OR?: InputMaybe<Array<PaymentsFilterFields>>;
  amount?: InputMaybe<NumberFilter>;
  created?: InputMaybe<DateFilter>;
  paymentDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
};

export type PaymentsFilterFields = {
  amount?: InputMaybe<NumberFilter>;
  created?: InputMaybe<DateFilter>;
  paymentDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
};

export type PaymentsResponse = {
  __typename?: 'PaymentsResponse';
  status: Scalars['Int']['output'];
  statusText: Scalars['String']['output'];
};

export type PaymentsSort = {
  paymentDate?: InputMaybe<SortDir>;
};

export enum PensionType {
  CarersPension = 'CARERS_PENSION',
  Disability = 'DISABILITY',
  Pensioner = 'PENSIONER',
  SelfFundedRetiree = 'SELF_FUNDED_RETIREE',
  Veteran = 'VETERAN',
}

export type Pensioner = {
  __typename?: 'Pensioner';
  code?: Maybe<Scalars['String']['output']>;
  pensionType: PensionType;
};

export type PensionerInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  pensionType: PensionType;
};

export enum Period {
  Annually = 'Annually',
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}

export type PhotoId = {
  __typename?: 'PhotoId';
  number: Scalars['String']['output'];
  state: AddressState;
};

export type PhotoIdInput = {
  number: Scalars['String']['input'];
  state: AddressState;
};

export type PhysicalProduct = {
  __typename?: 'PhysicalProduct';
  name: Scalars['String']['output'];
};

export type PhysicalProductFilter = {
  category?: InputMaybe<SlugFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PhysicalProductSort = {
  name?: InputMaybe<SortDir>;
};

/** The stages of the pipeline */
export enum PipelineLeadStage {
  ApplicationApproved = 'APPLICATION_APPROVED',
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  AwaitingVendor = 'AWAITING_VENDOR',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  InstallationApproved = 'INSTALLATION_APPROVED',
  InstallationCompleted = 'INSTALLATION_COMPLETED',
  LeadAcknowledged = 'LEAD_ACKNOWLEDGED',
  Lost = 'LOST',
  New = 'NEW',
  NewlySold = 'NEWLY_SOLD',
  Quoted = 'QUOTED',
  QuoteAccepted = 'QUOTE_ACCEPTED',
}

export enum PipelineStage {
  ApplicationApproved = 'APPLICATION_APPROVED',
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  AwaitingVendor = 'AWAITING_VENDOR',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  InstallationApproved = 'INSTALLATION_APPROVED',
  InstallationCompleted = 'INSTALLATION_COMPLETED',
  LeadAcknowledged = 'LEAD_ACKNOWLEDGED',
  Lost = 'LOST',
  New = 'NEW',
  NewlySold = 'NEWLY_SOLD',
  Quoted = 'QUOTED',
  QuoteAccepted = 'QUOTE_ACCEPTED',
}

export type PipelineStageFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PostLoginInput = {
  applicantType?: InputMaybe<ApplicantType>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['String']['input'];
};

export type PreMarketplaceBundleConfig = {
  __typename?: 'PreMarketplaceBundleConfig';
  /** Whether to show bundle subcategory selection */
  enabled: Scalars['Boolean']['output'];
  /** Category-to-subcategory mapping for bundle selection */
  subcategories?: Maybe<Scalars['JSONObject']['output']>;
};

export type PreMarketplaceCategoriesConfig = {
  __typename?: 'PreMarketplaceCategoriesConfig';
  /** Category selection style: true = checkboxes (multi), false = radio (single) */
  multiSelection: Scalars['Boolean']['output'];
  /** Allowed categories (CATEGORY enum values as strings). Empty/null = all categories. */
  options?: Maybe<Array<Scalars['String']['output']>>;
};

export type PreMarketplaceConfig = {
  __typename?: 'PreMarketplaceConfig';
  /** Per-step configuration, keyed by the camelCase form of the matching stepFlow.id. */
  stepConfiguration: PreMarketplaceStepConfiguration;
  /** Ordered pre-marketplace steps with required flag */
  stepFlow: Array<PartnerConfigStepFlow>;
};

export type PreMarketplaceEducationConfig = {
  __typename?: 'PreMarketplaceEducationConfig';
  /** Education content version rendered by the marketplace on the `education` step. Supported values: "commbank" | "default". "default" is the partner-neutral content, and what the marketplace falls back to when this block is absent. */
  version: Scalars['String']['output'];
};

export type PreMarketplaceEligibilityCheckConfig = {
  __typename?: 'PreMarketplaceEligibilityCheckConfig';
  /** Eligibility criteria displayed as a bullet list on the eligibility-check step. */
  items: Array<Scalars['String']['output']>;
};

export type PreMarketplaceFinancingInterestConfig = {
  __typename?: 'PreMarketplaceFinancingInterestConfig';
  /** Financing-interest content version rendered by the marketplace. Supported values: "commbank" | "brighte". */
  version: Scalars['String']['output'];
};

export type PreMarketplaceIntroductionConfig = {
  __typename?: 'PreMarketplaceIntroductionConfig';
  /** Which introduction narrative the pre-marketplace shows: "BRIGHTE_INTRODUCTION" | "PARTNER_INTRODUCTION". Set to BRIGHTE_INTRODUCTION when the journey starts on brighte.com.au even if the partner is not "brighte". When omitted, consumers fall back to partner-based defaulting. */
  introductionType?: Maybe<Scalars['String']['output']>;
  /** URL of the "next steps guide" rendered inside the "Already chosen a vendor?" callout on the introduction step. When null, the callout is hidden. */
  stepGuideLink?: Maybe<Scalars['String']['output']>;
};

export type PreMarketplaceRecommendedVendorsConfig = {
  __typename?: 'PreMarketplaceRecommendedVendorsConfig';
  /** Allow redirect to full marketplace to pick own vendors */
  pickVendorsInMarketplace: Scalars['Boolean']['output'];
  /** Show vendor selection UI. If false, suggested vendors are auto-selected. */
  selectVendors: Scalars['Boolean']['output'];
};

export type PreMarketplaceStepConfiguration = {
  __typename?: 'PreMarketplaceStepConfiguration';
  /** Config for the `bundle-categories` step. Required when stepFlow contains this step. */
  bundleCategories?: Maybe<PreMarketplaceBundleConfig>;
  /** Config for the `categories` step. Required when stepFlow contains this step. */
  categories?: Maybe<PreMarketplaceCategoriesConfig>;
  /** Config for the `education` step. Required when stepFlow contains this step. */
  education?: Maybe<PreMarketplaceEducationConfig>;
  /** Config for the `eligibility-check` step. Required when stepFlow contains this step. */
  eligibilityCheck?: Maybe<PreMarketplaceEligibilityCheckConfig>;
  /** Config for the `financing-interest` step. Required when stepFlow contains this step. */
  financingInterest?: Maybe<PreMarketplaceFinancingInterestConfig>;
  /** Config for the `introduction` step. Optional — set when the channel wants the "Already chosen a vendor?" callout or an explicit introduction type. */
  introduction?: Maybe<PreMarketplaceIntroductionConfig>;
  /** Config for the `recommended-vendors` step. */
  recommendedVendors: PreMarketplaceRecommendedVendorsConfig;
  /** Config for the `topics` step. Required when stepFlow contains this step. */
  topics?: Maybe<PreMarketplaceTopicsConfig>;
};

export type PreMarketplaceTopicsConfig = {
  __typename?: 'PreMarketplaceTopicsConfig';
  /** Which option value reveals the free-text "Tell us more" field, e.g. "other". The value is also the one that carries no answer content, so selecting it alone skips the `education` step. Null/omitted = no free-text option. */
  noteOption?: Maybe<Scalars['String']['output']>;
  /** Education topics offered on the `topics` step, in render order. Values only — labels and the answer content for each live in the marketplace, like `financing-interest`. */
  options: Array<Scalars['String']['output']>;
};

export type PrepopEnterprisePartnerConfig = {
  __typename?: 'PrepopEnterprisePartnerConfig';
  brighteSiteSlug?: Maybe<Scalars['String']['output']>;
  /** Slug identifying the channel. Present when the quote resolved to an enterprise lead with a channel. */
  channelSlug?: Maybe<Scalars['String']['output']>;
  /** Hygraph content slug for channel-specific rich content. Falls back to financial-product content when unset. */
  cmsContentSlug?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the channel has its own header logo asset, as opposed to using the partner-level logo. Null/false when the channel has no dedicated logo. */
  hasChannelLogo?: Maybe<Scalars['Boolean']['output']>;
  hasCoBrandedLogo?: Maybe<Scalars['Boolean']['output']>;
  packageEnabled?: Maybe<Scalars['Boolean']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerWebsiteUrl?: Maybe<Scalars['String']['output']>;
  progressSteps?: Maybe<Array<ProgressStep>>;
  /** Channel title shown as the package-flow heading (e.g. "Home Upgrade Program"). Falls back to the financial product name when unset. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PresignedUrlInput = {
  courseId: Scalars['String']['input'];
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  url: Scalars['String']['output'];
};

export type PrimaryCustomer = {
  __typename?: 'PrimaryCustomer';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PrimaryIncome = {
  __typename?: 'PrimaryIncome';
  amount: Scalars['Float']['output'];
  bankStatementToken?: Maybe<Scalars['String']['output']>;
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  period: Period;
};

export type PrimaryIncomeInput = {
  amount: Scalars['Float']['input'];
  bankStatementToken?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  period: Period;
};

export type ProductCategory = Entity &
  Node & {
    __typename?: 'ProductCategory';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    detailContent?: Maybe<RichText>;
    detailHeading?: Maybe<Scalars['String']['output']>;
    detailImage?: Maybe<Asset>;
    /** Get the document in other stages */
    documentInStages: Array<ProductCategory>;
    gasSummary?: Maybe<GasProductSummary>;
    heroContent?: Maybe<Scalars['String']['output']>;
    heroHeading?: Maybe<Scalars['String']['output']>;
    heroImage?: Maybe<Asset>;
    /** List of ProductCategory versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    loanType: GreenOrPersonal;
    marketplaceSlug: Scalars['String']['output'];
    name?: Maybe<Scalars['String']['output']>;
    productCategoryGroup?: Maybe<ProductCategoryGroup>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
    sharingDescription?: Maybe<Scalars['String']['output']>;
    sharingImage?: Maybe<Asset>;
    sharingTitle?: Maybe<Scalars['String']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type ProductCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryDetailImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ProductCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ProductCategoryGasSummaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryHeroImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ProductCategoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ProductCategoryProductCategoryGroupArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ProductCategorySharingImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ProductCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryGroup = Entity &
  Node & {
    __typename?: 'ProductCategoryGroup';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<ProductCategoryGroup>;
    /** List of ProductCategoryGroup versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    productCategories: Array<ProductCategory>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    /** System stage field */
    stage: Stage;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type ProductCategoryGroupCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryGroupDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type ProductCategoryGroupHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type ProductCategoryGroupProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

export type ProductCategoryGroupPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryGroupScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ProductCategoryGroupUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductCategoryGroupWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductCategoryGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryGroupWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  sortOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sortOrder_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  sortOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductCategoryGroupWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryGroupWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryGroupWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryGroupWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductCategoryGroupWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export enum ProductCategoryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DetailHeadingAsc = 'detailHeading_ASC',
  DetailHeadingDesc = 'detailHeading_DESC',
  HeroContentAsc = 'heroContent_ASC',
  HeroContentDesc = 'heroContent_DESC',
  HeroHeadingAsc = 'heroHeading_ASC',
  HeroHeadingDesc = 'heroHeading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LoanTypeAsc = 'loanType_ASC',
  LoanTypeDesc = 'loanType_DESC',
  MarketplaceSlugAsc = 'marketplaceSlug_ASC',
  MarketplaceSlugDesc = 'marketplaceSlug_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  SharingDescriptionAsc = 'sharingDescription_ASC',
  SharingDescriptionDesc = 'sharingDescription_DESC',
  SharingTitleAsc = 'sharingTitle_ASC',
  SharingTitleDesc = 'sharingTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** This contains a set of filters that can be used to compare values internally */
export type ProductCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  detailHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  detailHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  detailHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  detailHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  detailHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  detailHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  detailHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  detailHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  detailHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  detailHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<AssetWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryWhereStageInput>;
  gasSummary?: InputMaybe<GasProductSummaryWhereInput>;
  heroContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  loanType?: InputMaybe<GreenOrPersonal>;
  /** All values that are contained in given list. */
  loanType_in?: InputMaybe<Array<InputMaybe<GreenOrPersonal>>>;
  /** Any other value that exists and is not equal to the given value. */
  loanType_not?: InputMaybe<GreenOrPersonal>;
  /** All values that are not contained in given list. */
  loanType_not_in?: InputMaybe<Array<InputMaybe<GreenOrPersonal>>>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketplaceSlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketplaceSlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketplaceSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketplaceSlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketplaceSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketplaceSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketplaceSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketplaceSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketplaceSlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategoryGroup?: InputMaybe<ProductCategoryGroupWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  sharingImage?: InputMaybe<AssetWhereInput>;
  sharingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sharingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sharingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sharingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sharingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sharingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sharingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sharingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sharingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sharingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  sortOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sortOrder_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  sortOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export type ProductConfiguration = {
  __typename?: 'ProductConfiguration';
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  annualFee: Scalars['Float']['output'];
  applicationFee: Scalars['Float']['output'];
  cashPaymentEnabled?: Maybe<Scalars['Boolean']['output']>;
  comparisonRate?: Maybe<Scalars['Float']['output']>;
  defaultPaymentCycle: Scalars['String']['output'];
  enableExpressSettlement: Scalars['Boolean']['output'];
  establishmentFee: Scalars['Float']['output'];
  firstPaymentDelayDays: Scalars['Int']['output'];
  forceCcaProcess: Scalars['Boolean']['output'];
  interestRate: Scalars['Float']['output'];
  introducerFee: Scalars['Float']['output'];
  invoiceRequired: Scalars['Boolean']['output'];
  latePaymentFee: Scalars['Float']['output'];
  manualSettlementRequired: Scalars['Boolean']['output'];
  maxFinanceAmount?: Maybe<Scalars['Float']['output']>;
  maxRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  minFinanceAmount?: Maybe<Scalars['Float']['output']>;
  minRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  preventApplicationsAfterEndDate: Scalars['Boolean']['output'];
  riskBasedPricing: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  weeklyAccountFee: Scalars['Float']['output'];
};

export type ProductConfigurationOverride = {
  __typename?: 'ProductConfigurationOverride';
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  firstPaymentDelayDays?: Maybe<Scalars['Int']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  maxRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  minRepaymentMonth?: Maybe<Scalars['Int']['output']>;
  riskBasedPricing?: Maybe<Scalars['Boolean']['output']>;
  weeklyAccountFee?: Maybe<Scalars['Float']['output']>;
};

export type ProductConfigurationOverrideInput = {
  establishmentFee?: InputMaybe<Scalars['Float']['input']>;
  firstPaymentDelayDays?: InputMaybe<Scalars['Int']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  maxRepaymentMonth?: InputMaybe<Scalars['Int']['input']>;
  minRepaymentMonth?: InputMaybe<Scalars['Int']['input']>;
  riskBasedPricing?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyAccountFee?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductConfigurationsFilter = {
  activeFrom?: InputMaybe<DateFilter>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  financialProductSlug?: InputMaybe<FinancialProductSlugs>;
};

export type ProductConfigurationsSort = {
  activeFrom?: InputMaybe<SortDir>;
  activeTo?: InputMaybe<SortDir>;
  establishmentFee?: InputMaybe<SortDir>;
  financialProductSlug?: InputMaybe<SortDir>;
  interestRate?: InputMaybe<SortDir>;
  introducerFee?: InputMaybe<SortDir>;
  latePaymentFee?: InputMaybe<SortDir>;
  version?: InputMaybe<SortDir>;
  weeklyAccountFee?: InputMaybe<SortDir>;
};

export type ProductSettings = {
  introducerFee?: InputMaybe<Scalars['Boolean']['input']>;
  termMonths?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum ProductType {
  Loan = 'Loan',
  PaymentPlan = 'PaymentPlan',
}

export type ProgressStep = {
  __typename?: 'ProgressStep';
  /** Short summary of what happens at this step. Pair with `items` for the full detail. */
  content?: Maybe<Scalars['String']['output']>;
  /** Structured detail shown under the step summary (`content`). Null/omitted = no checklist. */
  items?: Maybe<Array<ProgressStepItem>>;
  /** Step heading, e.g. "Vendors will be in touch". */
  title: Scalars['String']['output'];
};

export type ProgressStepItem = {
  __typename?: 'ProgressStepItem';
  /** Sub-bullets rendered under this set. */
  subitems: Array<Scalars['String']['output']>;
  /** Heading for this set of bullets. */
  title: Scalars['String']['output'];
};

export type Promotion = {
  __typename?: 'Promotion';
  autoApply: Scalars['Boolean']['output'];
  categories: Array<CategoryPromotion>;
  code: Scalars['String']['output'];
  configuration?: Maybe<PromotionConfiguration>;
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  enterprisePartners: Array<EnterprisePartnerPromotion>;
  financialProducts: Array<FinancialProduct>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  manufacturers: Array<ManufacturerPromotion>;
  productConfiguration?: Maybe<ProductConfigurationOverride>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  vendors: Array<VendorPromotion>;
  visibleOnMarketplace: Scalars['Boolean']['output'];
};

export type PromotionConfiguration = {
  __typename?: 'PromotionConfiguration';
  maxAmount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<PromotionConfigurationType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PromotionConfigurationInput = {
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<PromotionConfigurationType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum PromotionConfigurationType {
  FixedDiscount = 'FixedDiscount',
  PercentageDiscount = 'PercentageDiscount',
}

export type PromotionCreateInput = {
  autoApply: Scalars['Boolean']['input'];
  batteryManufacturerSlugs: Array<Scalars['String']['input']>;
  categorySlugs: Array<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  configuration: PromotionConfigurationInput;
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  enterprisePartnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  productConfiguration: ProductConfigurationOverrideInput;
  productIds: Array<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['DateTime']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  vendorIds: Array<Scalars['String']['input']>;
  visibleOnMarketplace: Scalars['Boolean']['input'];
};

export type PromotionOption = {
  __typename?: 'PromotionOption';
  categorySlugs: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export enum PromotionPartner {
  Act = 'act',
  Brighte = 'brighte',
  Commbank = 'commbank',
  Rewiringau = 'rewiringau',
}

export type PromotionUpdateInput = {
  autoApply?: InputMaybe<Scalars['Boolean']['input']>;
  batteryManufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  code: Scalars['String']['input'];
  configuration?: InputMaybe<PromotionConfigurationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  enterprisePartnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  productConfiguration?: InputMaybe<ProductConfigurationOverrideInput>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visibleOnMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type PromotionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PromotionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  codes_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  codes_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  codes_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  codes_not?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  document?: InputMaybe<AssetWhereInput>;
  documentInStages_every?: InputMaybe<PromotionWhereStageInput>;
  documentInStages_none?: InputMaybe<PromotionWhereStageInput>;
  documentInStages_some?: InputMaybe<PromotionWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageBanner?: InputMaybe<AssetWhereInput>;
  imageSquare?: InputMaybe<AssetWhereInput>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPrimary_not?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<PromotionPartner>;
  /** All values that are contained in given list. */
  partnership_in?: InputMaybe<Array<InputMaybe<PromotionPartner>>>;
  /** Any other value that exists and is not equal to the given value. */
  partnership_not?: InputMaybe<PromotionPartner>;
  /** All values that are not contained in given list. */
  partnership_not_in?: InputMaybe<Array<InputMaybe<PromotionPartner>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  products_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  products_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  products_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  products_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  summary_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  summary_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  summary_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  summary_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  summary_starts_with?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tag_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tag_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tag_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tag_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tag_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PromotionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PromotionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export type PromotionsFilterArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<StringFilter>;
  end?: InputMaybe<DateFilter>;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  manufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
  visibleOnMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromotionsSortArgs = {
  code?: InputMaybe<SortDir>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyTitleOwnerOutput = {
  __typename?: 'PropertyTitleOwnerOutput';
  aiIncomeCalculated?: Maybe<Scalars['Float']['output']>;
  declaredIncome?: Maybe<Scalars['Float']['output']>;
  documents: Array<ApplicationDocument>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idMatrixReference?: Maybe<Scalars['String']['output']>;
  incomeType?: Maybe<TitleOwnerIncomeType>;
  isIncomeVerified?: Maybe<Scalars['Boolean']['output']>;
  partyType: Scalars['String']['output'];
  verificationMethod?: Maybe<TitleOwnerVerificationMethod>;
  verificationStatus?: Maybe<TitleOwnerVerificationStatus>;
};

export type PropertyTitleSearchAddressInput = {
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Proposal = {
  __typename?: 'Proposal';
  documentUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['String']['output'];
};

export type ProprietaryLimitedCompanyDetail = {
  __typename?: 'ProprietaryLimitedCompanyDetail';
  beneficialOwners?: Maybe<Array<EnterpriseIdentityWithIdentification>>;
  directors?: Maybe<Array<SmeDirector>>;
};

export type ProprietaryLimitedCompanyDetailInput = {
  beneficialOwners?: InputMaybe<Array<EnterpriseIdentityWithIdentificationInput>>;
  directors?: InputMaybe<Array<SmeDirectorInput>>;
};

export type PurchaseItem = {
  __typename?: 'PurchaseItem';
  category: PurchaseItemCategory;
  categoryComponents?: Maybe<CategoryComponent>;
  categorySlug: Scalars['String']['output'];
  description: Scalars['String']['output'];
  replacedProduct: Scalars['String']['output'];
};

export type PurchaseItemCategory = {
  __typename?: 'PurchaseItemCategory';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  abrAbnLookup: AbrAbnLookupResult;
  abrAbnSearch: Array<Maybe<AbrAbnSearchResult>>;
  /** Required scopes: read:finance-accounts */
  accountStatement: AccountStatementResponse;
  /** Required scopes: read:finance-accounts */
  accountSummaryByStatusGroup: AccountSummaryByStatusGroupResponse;
  /** Get paginated log notes for an application */
  accreditationApplicationLogNotes: AccreditationLogNotesResponse;
  /** Get applications */
  accreditationApplications: AccreditationApplicationsResponse;
  /** Get presigned URL for document preview/download */
  accreditationViewDocument: Scalars['String']['output'];
  /** Get a specific workflow execution by applicationId, workflowId, and executionId */
  accreditationWorkflowExecution?: Maybe<AccreditationApplicationWorkflowExecution>;
  addressSuggestions?: Maybe<Array<Maybe<AddressSuggestionsResult>>>;
  addresses?: Maybe<AddressesResult>;
  analyzeIncomeTransactions: AggregatedIncomeResult;
  application?: Maybe<Application>;
  /** Get application by ID */
  applicationById?: Maybe<AccreditationApplication>;
  applicationDocumentPresignedUrl: Scalars['String']['output'];
  /** Retrieve a single articleCuration */
  articleCuration?: Maybe<ArticleCuration>;
  brands: Array<Brand>;
  calculateRebates: Rebates;
  categories: Array<Category>;
  categoriesCount: Scalars['Float']['output'];
  category: Category;
  consumerEnergyResourcesComponents: Array<ConsumerEnergyResourcesComponent>;
  countCourses?: Maybe<Scalars['Int']['output']>;
  countUsers: Scalars['Float']['output'];
  course?: Maybe<Course>;
  courses: Array<Course>;
  documentRequest: DocumentRequestWithType;
  documentRequests: Array<DocumentRequest>;
  dwellingTypes: Array<DwellingType>;
  enterpriseApplications: Array<EnterpriseApplication>;
  enterpriseDocument?: Maybe<EnterpriseDocument>;
  enterpriseDocuments: Array<EnterpriseDocument>;
  /** @deprecated Use enterprisePartners instead */
  enterpriseGroups: Array<EnterprisePartner>;
  enterpriseLead: EnterpriseLead;
  enterpriseLeadStatuses: Array<EnterpriseLeadStatus>;
  enterpriseLeads: EnterpriseLeadsResponse;
  enterprisePartner?: Maybe<EnterprisePartner>;
  enterprisePartnerByChannel?: Maybe<EnterprisePartner>;
  enterprisePartners: Array<EnterprisePartner>;
  enterprisePipelineStage: EnterprisePipelineStage;
  enterprisePipelineStages: Array<EnterprisePipelineStage>;
  externalCourses: Array<ExternalCourse>;
  /** Required scopes: read:finance-accounts */
  financeAccount: Account;
  /** Required scopes: read:finance-accounts */
  financeAccountByTrackingId: Account;
  financeAccountCalculator: AccountCalculatorResponse;
  financeAccountCustomerConfirmationDetails: CustomerConfirmationDetails;
  /** Required scopes: read:finance-accounts */
  financeAccountDocumentPresignedUrl: Scalars['String']['output'];
  /** Required scopes: read:finance-accounts */
  financeAccountDocumentTypeValidation?: Maybe<DocumentTypeValidation>;
  /** Required scopes: read:finance-accounts */
  financeAccounts: AccountsResponse;
  /** Required scopes: read:finance-accounts */
  financeAccountsCount: Scalars['Int']['output'];
  /** @deprecated Use financialInstitutionLookup instead */
  financialInstitution: FinancialInstitution;
  financialInstitutionLookup: FinancialInstitutionLookupResponse;
  financialProduct: FinancialProduct;
  financialProductConfiguration: FinancialProductConfiguration;
  financialProducts: Array<FinancialProduct>;
  getApplicantForApplicationByTrackingId: Applicant;
  getApplicationStatus?: Maybe<Scalars['String']['output']>;
  getBankStatementIframe: BankStatementIframe;
  /** Get a list of occupations, optionally filtered by job title. */
  getOccupationData: Array<Occupation>;
  getPackageForOpportunity?: Maybe<PackageDetails>;
  getPresignedUrl: PresignedUrlResponse;
  /** Return the property title owners for a tracking id, with their uploaded documents and any declared/AI-derived income. Empty list if the Equifax delivery has not yet completed. */
  getPropertyTitleOwner: GetPropertyTitleOwnerOutput;
  getReplicatedUsers: Array<User>;
  /** Return the current status and result for a title-owner document verification request. */
  getTitleOwnerDocumentVerification: TitleOwnerDocumentVerificationOutput;
  /** CT-3015. Return the property title owners for an application id with income type, verification method/status, declared/AI income and documents. */
  getTitleSearchOwner: GetPropertyTitleOwnerOutput;
  hierarchicalCategories: Array<ParentCategory>;
  isCourseEnrollmentCompleted: CourseEnrollmentResponse;
  /** Required scopes: read:leads */
  lead: VendorLead;
  /** Required scopes: read:leads */
  leadAttachmentPresignedUrl: Scalars['String']['output'];
  leadIntents: Array<LeadIntentOption>;
  /** Required scopes: read:leads */
  leads: Array<VendorLead>;
  /** Required scopes: read:leads */
  leadsCount: Scalars['Int']['output'];
  manufacturer: ManufacturersResponse;
  manufacturers: Array<ManufacturersResponse>;
  manufacturersCount: Scalars['Int']['output'];
  marketplaceVendors: MarketplaceVendorsResponse;
  me: Me;
  occupationMatch: OccupationMatchResponse;
  openBankingConsentUrl: OpenBankingConsentUrl;
  openBankingConsents: Array<OpenBankingConsent>;
  openBankingData?: Maybe<OpenBankingDataDto>;
  openBankingIncome: OpenBankingIncomeDto;
  openDocumentRequests: Array<OpenDocumentRequestSummary>;
  /** Required scopes: read:finance-accounts */
  orderStatusHistory?: Maybe<Array<OrderStatusHistoryResponse>>;
  /** Required scopes: read:finance-accounts */
  orderStatuses: Array<Scalars['String']['output']>;
  packagesByOpportunity: Array<OpportunityPackageStatus>;
  paymentIFrameUrl: CreditCardUrl;
  paymentMethod: PaymentMethodUnion;
  paymentMethods: Array<PaymentMethodUnion>;
  /** Required scopes: read:payments, admin:payments */
  payments: Array<Payment>;
  /** Required scopes: read:payments, admin:payments */
  paymentsCount: Scalars['Int']['output'];
  physicalProducts: Array<PhysicalProduct>;
  /** Generate a preview of the unsigned contract and return it as a base64-encoded DOCX */
  previewContract: Scalars['String']['output'];
  /** User profile */
  profile: UserProfile;
  promotion: Promotion;
  promotionOptions: Array<PromotionOption>;
  promotions: Array<Promotion>;
  /** Required scopes: read:finance-referrals */
  proposalDownloadLink: Scalars['String']['output'];
  /**
   * Required scopes: read:finance-quotes
   * @deprecated Use `referral` query for quotes identified by trackingId. This query uses numeric ID.
   */
  quote: Quote;
  quoteByIdAndToken: Quote;
  /**
   * Required scopes: read:finance-quotes
   * @deprecated Use `referral` query instead (requires `read:finance-referrals` scope). Note: returns a Referral type, not Quote.
   */
  quoteByTrackingId: Quote;
  quotePrepopValuesByTrackingId: QuotePrepopValues;
  /** Required scopes: read:quote-requests */
  quoteRequests: Array<QuoteRequest>;
  /**
   * Required scopes: read:finance-quotes
   * @deprecated Use `referrals` query instead.
   */
  quotes: QuotesResponse;
  /**
   * Required scopes: read:finance-quotes
   * @deprecated Use `referralsCount` query instead.
   */
  quotesCount: Scalars['Int']['output'];
  /** Required scopes: read:finance-referrals */
  referral: Referral;
  /** Required scopes: read:finance-referrals */
  referrals: ReferralsResponse;
  /** Required scopes: read:finance-referrals */
  referralsCount: Scalars['Int']['output'];
  repaymentOptions: RepaymentOptionsResponse;
  repaymentOptionsByTrackingId: RepaymentOptionsResponse;
  resolveCallers: Array<CallerIdentity>;
  serviceAreas: Array<ServiceArea>;
  solarSavingsProfile: SolarSavingsProfileResponse;
  supportedIncomeDocumentTypes: Array<IncomeDocumentType>;
  tags: TagsResponse;
  /** Return a presigned GET URL so the FE can preview / download a title-owner document. */
  titleOwnerDocumentPresignedUrl: Scalars['String']['output'];
  totalSolarInstallationsInPostcode: Scalars['Int']['output'];
  unimprovedValue: UnimprovedValueUnion;
  /** Required scopes: read:leads */
  uniqueLeadsCount: Scalars['Int']['output'];
  user: User;
  userByAzureId: User;
  userHistory: Array<UserHistory>;
  users: Array<User>;
  /** Required scopes: read:my-vendors, read:vendors */
  vendor?: Maybe<Vendor>;
  /** Required scopes: read:my-vendors, read:vendors */
  vendorById: Vendor;
  /**
   * Required scopes: read:finance-accounts
   * @deprecated Use accountSummaryByStatusGroup instead, which returns { count, totalFinancedAmount } for an AccountsFilter.
   */
  vendorDasboardMetrics: VendorDashboardMetricsResponse;
  vendorDocumentPresignedUrl: Scalars['String']['output'];
  vendorEnrolledFinancialProducts: Array<EnrolledFinancialProduct>;
  /** Required scopes: read:vendor-flags */
  vendorFlag: VendorFlagDefinition;
  /** Required scopes: read:vendor-flags */
  vendorFlags: VendorFlagsResponse;
  vendorLeadStatuses: Array<VendorLeadStatusOption>;
  vendorLicenses: Array<License>;
  /** Returns paginated score history for a marketplace vendor. The path vendorId must be included in the vendorIds claim of the JWT. */
  vendorMarketplaceScoreHistory?: Maybe<MarketplaceVendorScoreHistory>;
  /** Batch query for gateway stitching: returns vendor memberships (with AC status and managerId) grouped by userId, in the same order as the input array. Each element is an array of VendorUserVendorLink for that user (empty if no memberships). */
  vendorMembershipsByUserIds: Array<Array<VendorUserVendorLink>>;
  /** Required scopes: read:vendor-rebates */
  vendorRebate: VendorRebate;
  /** Required scopes: read:vendor-rebates */
  vendorRebates: VendorRebatesResponse;
  vendorSearchLicenseByNumber?: Maybe<Scalars['JSON']['output']>;
  vendorStatusGroupSubscriptionOptions: Array<VendorStatusGroupSubscriptionOption>;
  vendorUserIssues: Array<VendorUserIssueWithUserDetails>;
  vendorUserIssuesCount: Scalars['Int']['output'];
  /** Lists VENDOR/TEAM users (paginated per user) with their vendor memberships. For admins with no vendor filter, users with no membership appear with an empty `vendors` list; VENDOR/TEAM callers and any vendor/manager/business-name filter are scoped to matching memberships. Note: a very broad business-name filter (matching a large number of vendors) can be slow — prefer a specific vendor or manager. */
  vendorUsers: VendorUsersResponse;
  /** Required scopes: read:my-vendors, read:vendors */
  vendors: Array<Vendor>;
};

export type QueryAbrAbnLookupArgs = {
  input: AbrAbnLookupInput;
};

export type QueryAbrAbnSearchArgs = {
  input: AbrAbnSearchInput;
};

export type QueryAccountStatementArgs = {
  input: AccountStatementInput;
};

export type QueryAccountSummaryByStatusGroupArgs = {
  filter?: InputMaybe<AccountsFilter>;
};

export type QueryAccreditationApplicationLogNotesArgs = {
  applicationId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAccreditationApplicationsArgs = {
  filter?: InputMaybe<AccreditationApplicationsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AccreditationApplicationsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAccreditationViewDocumentArgs = {
  input: AccreditationViewDocumentInput;
};

export type QueryAccreditationWorkflowExecutionArgs = {
  input: AccreditationGetWorkflowExecutionInput;
};

export type QueryAddressSuggestionsArgs = {
  input: AddressSuggestionsInput;
};

export type QueryAddressesArgs = {
  input: AddressesInput;
};

export type QueryAnalyzeIncomeTransactionsArgs = {
  transactions: OpenBankingTransactionsInput;
};

export type QueryApplicationArgs = {
  id: Scalars['String']['input'];
};

export type QueryApplicationByIdArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryApplicationDocumentPresignedUrlArgs = {
  ApplicationDocumentGetPresignedUrlInput: ApplicationDocumentOperationInput;
};

export type QueryArticleCurationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ArticleCurationWhereUniqueInput;
};

export type QueryBrandsArgs = {
  filter?: InputMaybe<BrandsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCalculateRebatesArgs = {
  input: RebateCalculatorInput;
};

export type QueryCategoriesArgs = {
  filter?: InputMaybe<CategoriesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CategoriesSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCategoriesCountArgs = {
  filter?: InputMaybe<CategoriesFilter>;
};

export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsumerEnergyResourcesComponentsArgs = {
  filter: ConsumerEnergyResourcesComponentsFilter;
};

export type QueryCountCoursesArgs = {
  filter?: InputMaybe<CourseFilter>;
};

export type QueryCountUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCourseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCoursesArgs = {
  filter?: InputMaybe<CourseFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDocumentRequestArgs = {
  DocumentRequestInput: DocumentRequestInput;
};

export type QueryDocumentRequestsArgs = {
  DocumentRequestsInput: DocumentRequestsInput;
};

export type QueryEnterpriseDocumentArgs = {
  documentId: Scalars['String']['input'];
};

export type QueryEnterpriseDocumentsArgs = {
  filter?: InputMaybe<EnterpriseDocumentFilter>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type QueryEnterpriseLeadArgs = {
  id: Scalars['String']['input'];
};

export type QueryEnterpriseLeadsArgs = {
  filter?: InputMaybe<EnterpriseLeadFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryEnterprisePartnerArgs = {
  id: Scalars['String']['input'];
};

export type QueryEnterprisePartnerByChannelArgs = {
  channelSlug: Scalars['String']['input'];
};

export type QueryEnterprisePartnersArgs = {
  filter?: InputMaybe<EnterprisePartnerFilter>;
};

export type QueryEnterprisePipelineStageArgs = {
  filter?: InputMaybe<EnterprisePipelineStageFilter>;
  pipelineStage: PipelineLeadStage;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type QueryEnterprisePipelineStagesArgs = {
  filter?: InputMaybe<EnterpriseLeadFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFinanceAccountArgs = {
  id: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFinanceAccountByTrackingIdArgs = {
  trackingId: Scalars['String']['input'];
};

export type QueryFinanceAccountCalculatorArgs = {
  input: AccountCalculatorInput;
};

export type QueryFinanceAccountCustomerConfirmationDetailsArgs = {
  accountId: Scalars['String']['input'];
  tokenPlain: Scalars['String']['input'];
};

export type QueryFinanceAccountDocumentPresignedUrlArgs = {
  accountId: Scalars['String']['input'];
  documentId: Scalars['Int']['input'];
};

export type QueryFinanceAccountDocumentTypeValidationArgs = {
  accountId: Scalars['String']['input'];
  documentId: Scalars['Int']['input'];
};

export type QueryFinanceAccountsArgs = {
  filter?: InputMaybe<AccountsFilter>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AccountsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFinanceAccountsCountArgs = {
  filter?: InputMaybe<AccountsFilter>;
};

export type QueryFinancialInstitutionArgs = {
  bsbNumber: Scalars['String']['input'];
};

export type QueryFinancialInstitutionLookupArgs = {
  input: FinancialInstitutionLookupInput;
};

export type QueryFinancialProductArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<FinancialProductSlugs>;
};

export type QueryFinancialProductConfigurationArgs = {
  batteryManufacturer?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<FinancialProductSlugs>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFinancialProductsArgs = {
  filter?: InputMaybe<FinancialProductsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetApplicantForApplicationByTrackingIdArgs = {
  trackingId: Scalars['String']['input'];
  type: ApplicantType;
};

export type QueryGetApplicationStatusArgs = {
  trackingId: Scalars['String']['input'];
};

export type QueryGetBankStatementIframeArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetOccupationDataArgs = {
  jobTitle?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetPackageForOpportunityArgs = {
  opportunityId: Scalars['String']['input'];
};

export type QueryGetPresignedUrlArgs = {
  input: PresignedUrlInput;
};

export type QueryGetPropertyTitleOwnerArgs = {
  input: GetPropertyTitleOwnerInput;
};

export type QueryGetReplicatedUsersArgs = {
  input: CreateUserInput;
};

export type QueryGetTitleOwnerDocumentVerificationArgs = {
  input: GetTitleOwnerDocumentVerificationInput;
};

export type QueryGetTitleSearchOwnerArgs = {
  input: GetTitleSearchOwnerInput;
};

export type QueryHierarchicalCategoriesArgs = {
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryIsCourseEnrollmentCompletedArgs = {
  financialProductId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLeadArgs = {
  id: Scalars['Int']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLeadAttachmentPresignedUrlArgs = {
  documentId: Scalars['String']['input'];
  leadId: Scalars['Int']['input'];
};

export type QueryLeadsArgs = {
  filter?: InputMaybe<LeadsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LeadsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLeadsCountArgs = {
  filter?: InputMaybe<LeadsFilter>;
};

export type QueryManufacturerArgs = {
  id: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryManufacturersArgs = {
  filter?: InputMaybe<ManufacturersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ManufacturersSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryManufacturersCountArgs = {
  filter?: InputMaybe<ManufacturersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ManufacturersSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMarketplaceVendorsArgs = {
  filter?: InputMaybe<MarketplaceVendorsFilter>;
  postcode: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MarketplaceVendorsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOccupationMatchArgs = {
  input: OccupationMatchInput;
};

export type QueryOpenBankingConsentUrlArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryOpenBankingDataArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryOpenBankingIncomeArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryOpenDocumentRequestsArgs = {
  OpenDocumentRequestsInput: OpenDocumentRequestsInput;
};

export type QueryOrderStatusHistoryArgs = {
  orderId: Scalars['String']['input'];
};

export type QueryPackagesByOpportunityArgs = {
  opportunityId: Scalars['String']['input'];
};

export type QueryPaymentIFrameUrlArgs = {
  source: PaymentMethodSource;
};

export type QueryPaymentMethodArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryPaymentMethodsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type QueryPaymentsArgs = {
  accountId: Scalars['String']['input'];
  filter?: InputMaybe<PaymentsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PaymentsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaymentsCountArgs = {
  accountId: Scalars['String']['input'];
  filter?: InputMaybe<PaymentsFilter>;
};

export type QueryPhysicalProductsArgs = {
  filter?: InputMaybe<PhysicalProductFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PhysicalProductSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPreviewContractArgs = {
  input: AccreditationPreviewContractInput;
};

export type QueryPromotionArgs = {
  code: Scalars['String']['input'];
};

export type QueryPromotionOptionsArgs = {
  batteryManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
  financialProductId: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type QueryPromotionsArgs = {
  filter?: InputMaybe<PromotionsFilterArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PromotionsSortArgs>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryProposalDownloadLinkArgs = {
  proposalId: Scalars['String']['input'];
};

export type QueryQuoteArgs = {
  id: Scalars['Int']['input'];
};

export type QueryQuoteByIdAndTokenArgs = {
  id: Scalars['Int']['input'];
  tokenPlain: Scalars['String']['input'];
};

export type QueryQuoteByTrackingIdArgs = {
  joint?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId: Scalars['String']['input'];
};

export type QueryQuotePrepopValuesByTrackingIdArgs = {
  joint?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId: Scalars['String']['input'];
};

export type QueryQuoteRequestsArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
};

export type QueryQuotesArgs = {
  filter?: InputMaybe<QuotesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuotesSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryQuotesCountArgs = {
  filter?: InputMaybe<QuotesFilter>;
};

export type QueryReferralArgs = {
  id: Scalars['ID']['input'];
  joint?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryReferralsArgs = {
  filter?: InputMaybe<ReferralsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ReferralsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryReferralsCountArgs = {
  filter?: InputMaybe<ReferralsFilter>;
};

export type QueryRepaymentOptionsArgs = {
  input: RepaymentOptionsInput;
};

export type QueryRepaymentOptionsByTrackingIdArgs = {
  input: RepaymentOptionsByTrackingIdInput;
};

export type QueryResolveCallersArgs = {
  mobiles: Array<Scalars['String']['input']>;
};

export type QuerySolarSavingsProfileArgs = {
  input: SolarSavingsProfileInput;
};

export type QueryTitleOwnerDocumentPresignedUrlArgs = {
  input: TitleOwnerDocumentOperationInput;
};

export type QueryTotalSolarInstallationsInPostcodeArgs = {
  input: SolarInstallationsInput;
};

export type QueryUnimprovedValueArgs = {
  input: UnimprovedValueInput;
};

export type QueryUniqueLeadsCountArgs = {
  filter?: InputMaybe<LeadsFilter>;
};

export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

export type QueryUserByAzureIdArgs = {
  azureId: Scalars['String']['input'];
};

export type QueryUserHistoryArgs = {
  userId: Scalars['String']['input'];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryVendorArgs = {
  filter?: InputMaybe<VendorsUniqueFilter>;
};

export type QueryVendorByIdArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVendorDasboardMetricsArgs = {
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVendorDocumentPresignedUrlArgs = {
  documentId: Scalars['Int']['input'];
  vendorPublicId: Scalars['String']['input'];
};

export type QueryVendorEnrolledFinancialProductsArgs = {
  activationStatus?: InputMaybe<EnrolledFinancialProductActivationStatusFilter>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  financialProductSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  includeDisenrolled?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['String']['input'];
};

export type QueryVendorFlagArgs = {
  name: Scalars['String']['input'];
};

export type QueryVendorLicensesArgs = {
  vendorId: Scalars['String']['input'];
};

export type QueryVendorMarketplaceScoreHistoryArgs = {
  limit?: InputMaybe<Scalars['MarketplacePositiveInt']['input']>;
  offset?: InputMaybe<Scalars['MarketplaceNonNegativeInt']['input']>;
  vendorId: Scalars['String']['input'];
};

export type QueryVendorMembershipsByUserIdsArgs = {
  userIds: Array<Scalars['String']['input']>;
};

export type QueryVendorRebateArgs = {
  id: Scalars['Int']['input'];
};

export type QueryVendorRebatesArgs = {
  filter?: InputMaybe<VendorRebatesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VendorRebatesSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryVendorSearchLicenseByNumberArgs = {
  licenseNumber: Scalars['String']['input'];
};

export type QueryVendorUserIssuesArgs = {
  input: VendorUserIssueInput;
};

export type QueryVendorUserIssuesCountArgs = {
  input: VendorUserIssueInput;
};

export type QueryVendorUsersArgs = {
  filter?: InputMaybe<VendorUsersFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryVendorsArgs = {
  filter?: InputMaybe<VendorsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VendorsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Quote = {
  __typename?: 'Quote';
  abn?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  account?: Maybe<Account>;
  /** @deprecated Legacy numeric identifier retained for deep-links to the legacy admin portal. Use `account.id` for new integrations. */
  accountLegacyId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<QuoteAddressType>;
  agent: Employee;
  application?: Maybe<Application>;
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  category: Category;
  categoryComponents: CategoryComponent;
  concessionType?: Maybe<ConcessionType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: QuoteCustomer;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  /** @deprecated Energy bundle is no longer offered */
  energyBundle?: Maybe<Scalars['Boolean']['output']>;
  enterprisePartner?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  establishmentFee?: Maybe<Scalars['Float']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  evChargerManufacturer?: Maybe<Manufacturer>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  insulationType?: Maybe<InsulationType>;
  /** @deprecated Use `productConfiguration` instead */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `productConfiguration` instead */
  introducerFee: Scalars['Float']['output'];
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  nationalMeterIdentifier?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nonProfit?: Maybe<Scalars['Boolean']['output']>;
  /** Required scopes: read:finance-quotes */
  oauthClientId?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  /** @deprecated Use `opportunity` instead */
  opportunityCategories?: Maybe<Array<OpportunityCategory>>;
  /** @deprecated Use `opportunity` instead */
  opportunityId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Payment stages are no longer offered */
  paymentStages?: Maybe<Array<Scalars['Float']['output']>>;
  /** @deprecated replaced with concessionType */
  pensionerType?: Maybe<ConcessionType>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productConfigVersion: Scalars['Float']['output'];
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  promotionDiscount: Scalars['Float']['output'];
  proposals?: Maybe<Array<Proposal>>;
  /** @deprecated Use `categoryComponents` instead */
  purchaseItems: Array<PurchaseItem>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  recipient?: Maybe<BaseIdentity>;
  referenceNumber: Scalars['String']['output'];
  relatedQuotes?: Maybe<Array<RelatedQuote>>;
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  repaymentTerm?: Maybe<Scalars['Int']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  resendDate?: Maybe<Scalars['DateTime']['output']>;
  selectedPackage?: Maybe<Package>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  stoveType?: Maybe<StoveType>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalPurchaseAmount: Scalars['Float']['output'];
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export type QuoteAddressInput = {
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  isManuallyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  occupancyStatus?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: AddressState;
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteAddressType = {
  __typename?: 'QuoteAddressType';
  dwellingType?: Maybe<Scalars['String']['output']>;
  isManuallyEntered?: Maybe<Scalars['Boolean']['output']>;
  occupancyStatus?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  propertyValue?: Maybe<Scalars['Float']['output']>;
  state: AddressState;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  unimprovedValue?: Maybe<Scalars['Float']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type QuoteBusinessDetailsInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  nonProfit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuoteCustomer = {
  __typename?: 'QuoteCustomer';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type QuoteCustomerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteItem = {
  batteryCapacity?: InputMaybe<Scalars['Float']['input']>;
  batteryManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  ceiling?: InputMaybe<Scalars['Boolean']['input']>;
  depositAmount: Scalars['Float']['input'];
  estimatedInstallationDate?: InputMaybe<Scalars['DateTime']['input']>;
  evChargerManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  existingInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  floor?: InputMaybe<Scalars['Boolean']['input']>;
  heatingCoolingSystemCapacity?: InputMaybe<Scalars['Float']['input']>;
  heatingCoolingSystemType?: InputMaybe<Scalars['String']['input']>;
  hwhpTankCapacity?: InputMaybe<Scalars['Float']['input']>;
  installCategorySlug: Scalars['String']['input'];
  insulationType?: InputMaybe<InsulationType>;
  inverterCapacity?: InputMaybe<Scalars['Float']['input']>;
  inverterManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  isBatteryRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isInverterRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPanelRequired?: InputMaybe<Scalars['Boolean']['input']>;
  newInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  productCategoryDetails?: InputMaybe<QuoteItemProductCategoryDetailsInput>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  proposals?: InputMaybe<Array<Scalars['String']['input']>>;
  pvPanelCapacity?: InputMaybe<Scalars['Float']['input']>;
  pvPanelManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  rebateDiscount?: InputMaybe<Scalars['Float']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  replacedProduct?: InputMaybe<Scalars['String']['input']>;
  stoveType?: InputMaybe<Scalars['String']['input']>;
  totalInsulationRValue?: InputMaybe<Scalars['Float']['input']>;
  totalPurchaseAmount: Scalars['Float']['input'];
  walls?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuoteItemProductCategoryDetails = {
  __typename?: 'QuoteItemProductCategoryDetails';
  batteryModelNumber?: Maybe<Scalars['String']['output']>;
  doubleGlazingWindowsManufacturerSlug?: Maybe<Scalars['String']['output']>;
  doubleGlazingWindowsModelNumber?: Maybe<Scalars['String']['output']>;
  doubleGlazingWindowsUValue?: Maybe<Scalars['Float']['output']>;
  electricCargoBikeManufacturerName?: Maybe<Scalars['String']['output']>;
  electricCargoBikeModelNumber?: Maybe<Scalars['String']['output']>;
  electricHeatingCoolingManufacturerSlug?: Maybe<Scalars['String']['output']>;
  electricHeatingCoolingModelNumber?: Maybe<Scalars['String']['output']>;
  evChargerModelNumber?: Maybe<Scalars['String']['output']>;
  hotWaterHeatPumpManufacturerSlug?: Maybe<Scalars['String']['output']>;
  hotWaterHeatPumpModelNumber?: Maybe<Scalars['String']['output']>;
  inductionCooktopManufacturerName?: Maybe<Scalars['String']['output']>;
  inductionCooktopModelNumber?: Maybe<Scalars['String']['output']>;
  inductionCooktopPermanentInstallAgreement?: Maybe<Scalars['Boolean']['output']>;
  inverterModelNumber?: Maybe<Scalars['String']['output']>;
  panelModelNumber?: Maybe<Scalars['String']['output']>;
  solarHotWaterManufacturerSlug?: Maybe<Scalars['String']['output']>;
  solarHotWaterModelNumber?: Maybe<Scalars['String']['output']>;
};

export type QuoteItemProductCategoryDetailsInput = {
  batteryModelNumber?: InputMaybe<Scalars['String']['input']>;
  doubleGlazingWindowsManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  doubleGlazingWindowsModelNumber?: InputMaybe<Scalars['String']['input']>;
  doubleGlazingWindowsUValue?: InputMaybe<Scalars['Float']['input']>;
  electricCargoBikeManufacturerName?: InputMaybe<Scalars['String']['input']>;
  electricCargoBikeModelNumber?: InputMaybe<Scalars['String']['input']>;
  electricHeatingCoolingManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  electricHeatingCoolingModelNumber?: InputMaybe<Scalars['String']['input']>;
  evChargerModelNumber?: InputMaybe<Scalars['String']['input']>;
  hotWaterHeatPumpManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  hotWaterHeatPumpModelNumber?: InputMaybe<Scalars['String']['input']>;
  inductionCooktopManufacturerName?: InputMaybe<Scalars['String']['input']>;
  inductionCooktopModelNumber?: InputMaybe<Scalars['String']['input']>;
  inductionCooktopPermanentInstallAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  inverterModelNumber?: InputMaybe<Scalars['String']['input']>;
  panelModelNumber?: InputMaybe<Scalars['String']['input']>;
  solarHotWaterManufacturerSlug?: InputMaybe<Scalars['String']['input']>;
  solarHotWaterModelNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteOpportunity = {
  __typename?: 'QuoteOpportunity';
  categories: Array<OpportunityCategory>;
  householdIncome?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  status: OpportunityStatus;
  vendorsAwaitingQuotes?: Maybe<Array<Vendor>>;
};

export type QuotePackage = {
  __typename?: 'QuotePackage';
  applicationQuote: ApplicationQuote;
  packageId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type QuotePrepopValues = {
  __typename?: 'QuotePrepopValues';
  email?: Maybe<Scalars['String']['output']>;
  enterprisePartnerConfig?: Maybe<PrepopEnterprisePartnerConfig>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  financialProduct: FinancialProduct;
  maskedEmail?: Maybe<Scalars['String']['output']>;
  maskedPhone?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  phone?: Maybe<Scalars['String']['output']>;
  status: QuoteStatus;
  verificationType: Scalars['String']['output'];
};

export type QuoteProductCategoryDetails = {
  __typename?: 'QuoteProductCategoryDetails';
  insulation: QuoteProductCategoryDetailsInsulation;
};

export type QuoteProductCategoryDetailsInput = {
  insulation: QuoteProductCategoryDetailsInsulationInput;
};

export type QuoteProductCategoryDetailsInsulation = {
  __typename?: 'QuoteProductCategoryDetailsInsulation';
  location: QuoteProductCategoryDetailsInsulationLocation;
};

export type QuoteProductCategoryDetailsInsulationInput = {
  location: QuoteProductCategoryDetailsInsulationLocationInput;
};

export type QuoteProductCategoryDetailsInsulationLocation = {
  __typename?: 'QuoteProductCategoryDetailsInsulationLocation';
  ceiling: Scalars['Boolean']['output'];
  floor: Scalars['Boolean']['output'];
  walls: Scalars['Boolean']['output'];
};

export type QuoteProductCategoryDetailsInsulationLocationInput = {
  ceiling: Scalars['Boolean']['input'];
  floor: Scalars['Boolean']['input'];
  walls: Scalars['Boolean']['input'];
};

export type QuoteRequest = {
  __typename?: 'QuoteRequest';
  leads: Array<Lead>;
  opportunityId: Scalars['String']['output'];
};

export type QuoteRequestFilter = {
  OR?: InputMaybe<Array<QuoteRequestFilterFields>>;
  category?: InputMaybe<SlugFilter>;
  created?: InputMaybe<DateFilter>;
  /** Filter quote requests by enterprise-partner attributes. Intersected with any explicit enterprisePartnerId filter. */
  enterprisePartner?: InputMaybe<LeadEnterprisePartnerFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type QuoteRequestFilterFields = {
  category?: InputMaybe<SlugFilter>;
  created?: InputMaybe<DateFilter>;
  enterprisePartnerId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type QuoteStartedInput = {
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['String']['input'];
};

export enum QuoteStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Sent = 'SENT',
  Started = 'STARTED',
}

export type QuoteStatusFilter = {
  equals?: InputMaybe<QuoteStatus>;
  in?: InputMaybe<Array<QuoteStatus>>;
};

export type QuotesFilter = {
  OR?: InputMaybe<Array<QuotesFilterFields>>;
  cancelled?: InputMaybe<DateFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<DateFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasPromotion?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<QuoteStatusFilter>;
  submitted?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<NumberFilter>;
};

export type QuotesFilterFields = {
  cancelled?: InputMaybe<DateFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<DateFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasPromotion?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<QuoteStatusFilter>;
  submitted?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<NumberFilter>;
};

export type QuotesResponse = {
  __typename?: 'QuotesResponse';
  quotes: Array<Quote>;
};

export type QuotesSort = {
  created?: InputMaybe<SortDir>;
  email?: InputMaybe<SortDir>;
  expiryDate?: InputMaybe<SortDir>;
  firstName?: InputMaybe<SortDir>;
  id?: InputMaybe<SortDir>;
  lastName?: InputMaybe<SortDir>;
  referenceNumber?: InputMaybe<SortDir>;
  repaymentTerm?: InputMaybe<SortDir>;
  totalPurchaseAmount?: InputMaybe<SortDir>;
};

export type RatingResponse = {
  __typename?: 'RatingResponse';
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewTotal?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<Maybe<Review>>>;
};

export type RawImportLog = {
  __typename?: 'RawImportLog';
  created: Scalars['DateTimeISO']['output'];
  documentId: Scalars['String']['output'];
  errorDetails?: Maybe<Scalars['String']['output']>;
  importStats?: Maybe<Scalars['JSON']['output']>;
  rawData: Scalars['JSON']['output'];
  status: ImportStatus;
};

export type Rebate = {
  __typename?: 'Rebate';
  categorySlug: Scalars['String']['output'];
  rebateAmount: Scalars['Float']['output'];
  reference?: Maybe<Scalars['String']['output']>;
};

export type RebateCalculatorInput = {
  financialProductSlug: Scalars['String']['input'];
  purchaseItems: Array<RebatePurchaseItem>;
  skipIncomeVerification?: InputMaybe<Scalars['Boolean']['input']>;
  yearlyHouseholdGrossIncome?: InputMaybe<Scalars['Float']['input']>;
};

export type RebatePurchaseItem = {
  categorySlug: Scalars['String']['input'];
  purchaseTotal: Scalars['Float']['input'];
  reference: Scalars['String']['input'];
};

export type Rebates = {
  __typename?: 'Rebates';
  rebates: Array<Rebate>;
  totalRebateAmount: Scalars['Float']['output'];
};

export type RecurringExpense = {
  __typename?: 'RecurringExpense';
  amount: Scalars['Float']['output'];
  period: Period;
};

export type RecurringExpenseCheck = {
  __typename?: 'RecurringExpenseCheck';
  amount: Scalars['Float']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  period: Period;
};

export type RecurringExpenseCheckInput = {
  amount: Scalars['Float']['input'];
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  period: Period;
};

export type RecurringExpenseInput = {
  amount: Scalars['Float']['input'];
  period: Period;
};

export type Redirect = Entity &
  Node & {
    __typename?: 'Redirect';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Get the document in other stages */
    documentInStages: Array<Redirect>;
    /** e.g. /my-short-url */
    fromURL?: Maybe<Scalars['String']['output']>;
    /** List of Redirect versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    /** System stage field */
    stage: Stage;
    /** Can be a URL on our site (e.g. /homeowners) or a full URL outside of brighte.com.au (e.g. https://portal.brighte.com.au/foo) */
    toURL?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type RedirectCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RedirectDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type RedirectHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type RedirectPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RedirectScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type RedirectUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type Referral = {
  __typename?: 'Referral';
  abn?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  account?: Maybe<Account>;
  /** @deprecated Legacy numeric identifier retained for deep-links to the legacy admin portal. Use `account.id` for new integrations. */
  accountLegacyId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<QuoteAddressType>;
  agent: Employee;
  application?: Maybe<Application>;
  batteryCapacity?: Maybe<Scalars['Float']['output']>;
  batteryManufacturer?: Maybe<Manufacturer>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  category: Category;
  categoryComponents: CategoryComponent;
  concessionType?: Maybe<ConcessionType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: QuoteCustomer;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Float']['output'];
  enterpriseLead?: Maybe<ReferralEnterpriseLead>;
  enterprisePartner?: Maybe<Scalars['String']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  evChargerManufacturer?: Maybe<Manufacturer>;
  existingInsulationRValue?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  financialProduct: FinancialProduct;
  heatingCoolingSystemCapacity?: Maybe<Scalars['Float']['output']>;
  heatingCoolingSystemType?: Maybe<HeatingCoolingSystemType>;
  hwhpTankCapacity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  insulationType?: Maybe<InsulationType>;
  inverterCapacity?: Maybe<Scalars['Float']['output']>;
  inverterManufacturer?: Maybe<Manufacturer>;
  /** @deprecated Legacy numeric database identifier. Use `id` for referral identification. */
  legacyId: Scalars['Int']['output'];
  nationalMeterIdentifier?: Maybe<Scalars['String']['output']>;
  newInsulationRValue?: Maybe<Scalars['Float']['output']>;
  nonProfit?: Maybe<Scalars['Boolean']['output']>;
  opportunity?: Maybe<QuoteOpportunity>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productConfigVersion: Scalars['Float']['output'];
  productConfiguration?: Maybe<FinancialProductConfiguration>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  promotionDiscount: Scalars['Float']['output'];
  proposals?: Maybe<Array<Proposal>>;
  pvPanelCapacity?: Maybe<Scalars['Float']['output']>;
  pvPanelManufacturer?: Maybe<Manufacturer>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  recipient?: Maybe<BaseIdentity>;
  referenceNumber: Scalars['String']['output'];
  relatedReferrals?: Maybe<Array<RelatedReferral>>;
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  repaymentTerm?: Maybe<Scalars['Int']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  resendDate?: Maybe<Scalars['DateTime']['output']>;
  selectedPackage?: Maybe<SelectedPackage>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  stoveType?: Maybe<StoveType>;
  submitted?: Maybe<Scalars['DateTime']['output']>;
  totalInsulationRValue?: Maybe<Scalars['Float']['output']>;
  totalPurchaseAmount: Scalars['Float']['output'];
  /** @deprecated This property is now available as `id`. Use that instead. */
  trackingId: Scalars['String']['output'];
  vendor: Vendor;
};

export type ReferralBusinessDetails = {
  abn: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  nonProfit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReferralEnterpriseLead = {
  __typename?: 'ReferralEnterpriseLead';
  applications?: Maybe<Array<ReferralEnterpriseLeadApplication>>;
};

export type ReferralEnterpriseLeadApplication = {
  __typename?: 'ReferralEnterpriseLeadApplication';
  cancellable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ReferralsFilter = {
  AND?: InputMaybe<Array<ReferralsFilterFields>>;
  OR?: InputMaybe<Array<ReferralsFilterFields>>;
  cancelled?: InputMaybe<DateFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<DateFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasPromotion?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<QuoteStatusFilter>;
  submitted?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<StringFilter>;
};

export type ReferralsFilterFields = {
  cancelled?: InputMaybe<DateFilter>;
  created?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<DateFilter>;
  financialProductId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasPromotion?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  referenceNumber?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  status?: InputMaybe<QuoteStatusFilter>;
  submitted?: InputMaybe<DateFilter>;
  vendorId?: InputMaybe<StringFilter>;
};

export type ReferralsResponse = {
  __typename?: 'ReferralsResponse';
  referrals: Array<Referral>;
};

export type ReferralsSort = {
  created?: InputMaybe<SortDir>;
  email?: InputMaybe<SortDir>;
  expiryDate?: InputMaybe<SortDir>;
  firstName?: InputMaybe<SortDir>;
  lastName?: InputMaybe<SortDir>;
  referenceNumber?: InputMaybe<SortDir>;
  repaymentTerm?: InputMaybe<SortDir>;
  totalPurchaseAmount?: InputMaybe<SortDir>;
  trackingId?: InputMaybe<SortDir>;
};

export type RelatedQuote = {
  __typename?: 'RelatedQuote';
  agent: Employee;
  category: RelatedQuoteCategory;
  categoryComponents: CategoryComponent;
  depositAmount: Scalars['Float']['output'];
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** @deprecated Use `opportunity` instead */
  opportunityId?: Maybe<Scalars['String']['output']>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<Proposal>>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  referenceNumber: Scalars['String']['output'];
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  status: QuoteStatus;
  totalPurchaseAmount: Scalars['Float']['output'];
  trackingId: Scalars['String']['output'];
  vendor: RelatedQuoteVendor;
};

export type RelatedQuoteCategory = {
  __typename?: 'RelatedQuoteCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type RelatedQuoteVendor = {
  __typename?: 'RelatedQuoteVendor';
  details: Array<VendorDetail>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  legacyId: Scalars['Int']['output'];
  legalName: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tradingName: Scalars['String']['output'];
};

export type RelatedQuotesInput = {
  id: Scalars['String']['input'];
  repaymentTerm?: InputMaybe<RepaymentTermInput>;
};

export type RelatedReferral = {
  __typename?: 'RelatedReferral';
  agent: Employee;
  category: RelatedQuoteCategory;
  categoryComponents: CategoryComponent;
  depositAmount: Scalars['Float']['output'];
  estimatedInstallationDate?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  financedAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use `opportunity` instead */
  opportunityId?: Maybe<Scalars['String']['output']>;
  productCategoryDetails?: Maybe<QuoteProductCategoryDetails>;
  productDescription?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<Proposal>>;
  rebate?: Maybe<Scalars['Float']['output']>;
  rebateDiscount: Scalars['Float']['output'];
  referenceNumber: Scalars['String']['output'];
  repaymentOptions?: Maybe<Array<RepaymentOption>>;
  repaymentSummary?: Maybe<Scalars['String']['output']>;
  replacedProduct?: Maybe<Scalars['String']['output']>;
  status: QuoteStatus;
  totalPurchaseAmount: Scalars['Float']['output'];
  /** @deprecated This property is now available as `id`. Use that instead. */
  trackingId: Scalars['String']['output'];
  vendor: RelatedQuoteVendor;
};

export type RepaymentOption = {
  __typename?: 'RepaymentOption';
  dateMaturity?: Maybe<Scalars['String']['output']>;
  interestCycle: RepaymentOptionsInterestFrequency;
  interestRate: Scalars['Float']['output'];
  numberOfPayments: Scalars['Int']['output'];
  paymentCycle: RepaymentOptionsFrequency;
  repaymentAmount: Scalars['Float']['output'];
  termMonths: Scalars['Int']['output'];
  totalInterest: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
};

export type RepaymentOptionsByTrackingIdInput = {
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export enum RepaymentOptionsFrequency {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type RepaymentOptionsInput = {
  financialProductId: Scalars['String']['input'];
  loanAmount: Scalars['Float']['input'];
};

export enum RepaymentOptionsInterestFrequency {
  Every_10Years = 'EVERY_10_YEARS',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
}

export type RepaymentOptionsResponse = {
  __typename?: 'RepaymentOptionsResponse';
  repaymentOptions: Array<RepaymentOption>;
};

export type RepaymentTerm = {
  __typename?: 'RepaymentTerm';
  amount?: Maybe<Scalars['Float']['output']>;
  dateMaturity?: Maybe<Scalars['String']['output']>;
  interestCycle?: Maybe<Scalars['String']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  paymentCountRegular?: Maybe<Scalars['Int']['output']>;
  paymentCycle?: Maybe<Scalars['String']['output']>;
  paymentRegularFirstDate?: Maybe<Scalars['String']['output']>;
  term: Scalars['Float']['output'];
  termInMonths?: Maybe<Scalars['Int']['output']>;
  termNumberOfPayments?: Maybe<Scalars['Int']['output']>;
  totalInterest?: Maybe<Scalars['Float']['output']>;
  totalPayments?: Maybe<Scalars['Float']['output']>;
};

export type RepaymentTermInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  dateMaturity?: InputMaybe<Scalars['String']['input']>;
  interestCycle?: InputMaybe<Scalars['String']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  paymentCountRegular?: InputMaybe<Scalars['Int']['input']>;
  paymentCycle?: InputMaybe<Scalars['String']['input']>;
  paymentRegularFirstDate?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['Float']['input'];
  termInMonths?: InputMaybe<Scalars['Int']['input']>;
  termNumberOfPayments?: InputMaybe<Scalars['Int']['input']>;
  totalInterest?: InputMaybe<Scalars['Float']['input']>;
  totalPayments?: InputMaybe<Scalars['Float']['input']>;
};

export enum RepaymentTermMonths {
  Term_1 = 'TERM_1',
  Term_6 = 'TERM_6',
  Term_12 = 'TERM_12',
  Term_18 = 'TERM_18',
  Term_24 = 'TERM_24',
  Term_30 = 'TERM_30',
  Term_36 = 'TERM_36',
  Term_40 = 'TERM_40',
  Term_42 = 'TERM_42',
  Term_48 = 'TERM_48',
  Term_50 = 'TERM_50',
  Term_60 = 'TERM_60',
  Term_72 = 'TERM_72',
  Term_84 = 'TERM_84',
  Term_96 = 'TERM_96',
  Term_108 = 'TERM_108',
  Term_120 = 'TERM_120',
}

export type RequestAdditionalUserResponse = {
  __typename?: 'RequestAdditionalUserResponse';
  success: Scalars['Boolean']['output'];
};

export type RequestApplicationDocumentInput = {
  applicantIds: Array<Scalars['String']['input']>;
  applicationId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};

export type RequestApplicationDocumentsInput = {
  applicantId: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
  requests: Array<DocumentRequestItemInput>;
};

export type RequestApplicationDocumentsResult = {
  __typename?: 'RequestApplicationDocumentsResult';
  applicantId: Scalars['String']['output'];
  applicantType: Scalars['String']['output'];
  expiredRequestIds: Array<Scalars['Int']['output']>;
  requests: Array<DocumentRequestItem>;
};

export type RequestFinanceAccountPaymentDto = {
  accountId: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['Int']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  installationDate?: InputMaybe<Scalars['String']['input']>;
  installerLicenceNumber?: InputMaybe<Scalars['String']['input']>;
  installerName?: InputMaybe<Scalars['String']['input']>;
  nationalMeterIdentifier?: InputMaybe<Scalars['String']['input']>;
  otherInstallerNames?: InputMaybe<Scalars['String']['input']>;
  vendorDeclaration: Scalars['Boolean']['input'];
  vendorDeclarationStatement: Scalars['String']['input'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
};

export type RequestPaymentRequirementsType = {
  __typename?: 'RequestPaymentRequirementsType';
  certificateOfElectricalSafetyRequired: Scalars['Boolean']['output'];
  certificateOfElectricalWorksRequired: Scalars['Boolean']['output'];
  certificateOfOccupancyAndUseRequired: Scalars['Boolean']['output'];
  electricalSafetyInspectionReportRequired: Scalars['Boolean']['output'];
  gasSupplyCertificateOfComplianceOptional: Scalars['Boolean']['output'];
  gasSupplyCertificateOfComplianceRequired: Scalars['Boolean']['output'];
  invoiceRequired: Scalars['Boolean']['output'];
  plumbingCertificateOfComplianceOptional: Scalars['Boolean']['output'];
  proposalRequired: Scalars['Boolean']['output'];
  smallScaleTechnologyCertificateOptional: Scalars['Boolean']['output'];
  smallScaleTechnologyCertificateRequired: Scalars['Boolean']['output'];
};

export enum RequestedDocumentType {
  BankStatement = 'BankStatement',
  CentrelinkStatement = 'CentrelinkStatement',
  NoticeOfAssessment = 'NoticeOfAssessment',
  Others = 'Others',
  Payslip = 'Payslip',
  PensionStatement = 'PensionStatement',
  SuperannuationStatement = 'SuperannuationStatement',
  TaxAssessment = 'TaxAssessment',
}

export type RequiredCategory = {
  __typename?: 'RequiredCategory';
  /** Human-readable category name, e.g. "Smart Energy Device". */
  name: Scalars['String']['output'];
  /** Category slug, e.g. "smart-energy-device". */
  slug: Scalars['String']['output'];
};

export type ResendQuoteInput = {
  id: Scalars['Int']['input'];
};

export type ResendReferralInput = {
  id: Scalars['ID']['input'];
};

export type RestoreUserInput = {
  userId: Scalars['String']['input'];
};

export type Review = {
  __typename?: 'Review';
  authorName?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  relativeTimeDescription?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

export type RevokeOpenBankingConsentDto = {
  __typename?: 'RevokeOpenBankingConsentDto';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type Role = {
  __typename?: 'Role';
  displayName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum RoleName {
  Admin = 'ADMIN',
  AdminOperations = 'ADMIN_OPERATIONS',
  Client = 'CLIENT',
  Installer = 'INSTALLER',
  Manager = 'MANAGER',
  Service = 'SERVICE',
  Superadmin = 'SUPERADMIN',
  Team = 'TEAM',
  Tv = 'TV',
  Vendor = 'VENDOR',
}

/** Scheduled Operation system model */
export type ScheduledOperation = Entity &
  Node & {
    __typename?: 'ScheduledOperation';
    affectedDocuments: Array<ScheduledOperationAffectedDocument>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Operation description */
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<ScheduledOperation>;
    /** Operation error message */
    errorMessage?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    /** Raw operation payload including all details, this field is subject to change */
    rawPayload: Scalars['Json']['output'];
    /** The release this operation is scheduled for */
    release?: Maybe<ScheduledRelease>;
    /** System stage field */
    stage: Stage;
    /** operation Status */
    status: ScheduledOperationStatus;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument =
  | Article
  | ArticleAuthor
  | ArticleCuration
  | ArticleTag
  | Asset
  | DocumentList
  | Faq
  | Hub
  | HubCategory
  | Loan
  | Metric
  | Notice
  | Page
  | ProductCategory
  | ProductCategoryGroup
  | Redirect
  | SupportArticle;

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity &
  Node & {
    __typename?: 'ScheduledRelease';
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    /** Release description */
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<ScheduledRelease>;
    /** Release error message */
    errorMessage?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Whether scheduled release should be run */
    isActive: Scalars['Boolean']['output'];
    /** Whether scheduled release is implicit */
    isImplicit: Scalars['Boolean']['output'];
    /** Operations to run with this release */
    operations: Array<ScheduledOperation>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    /** Release date and time */
    releaseAt?: Maybe<Scalars['DateTime']['output']>;
    /** System stage field */
    stage: Stage;
    /** Release Status */
    status: ScheduledReleaseStatus;
    /** Release Title */
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type SelectQuoteForOpportunityInput = {
  confirmRegenerate?: InputMaybe<Scalars['Boolean']['input']>;
  isCashPayment: Scalars['Boolean']['input'];
  opportunityId: Scalars['String']['input'];
  trackingIds: Array<Scalars['String']['input']>;
};

export type SelectQuoteForOpportunityResponse = {
  __typename?: 'SelectQuoteForOpportunityResponse';
  applicationUrl?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['ID']['output'];
  requiresRegenerateConfirmation?: Maybe<Scalars['Boolean']['output']>;
};

export type SelectedPackage = {
  __typename?: 'SelectedPackage';
  packageId: Scalars['String']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type SelfEmployed = {
  __typename?: 'SelfEmployed';
  abn: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  isSameMobileNumber?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SelfEmployedInput = {
  abn: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  isSameMobileNumber?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SendEmailVerificationResponse = {
  __typename?: 'SendEmailVerificationResponse';
  email: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  statusText: Scalars['String']['output'];
};

export type SendSmsVerificationResponse = {
  __typename?: 'SendSmsVerificationResponse';
  mobile: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  statusText: Scalars['String']['output'];
};

export type ServiceArea = {
  __typename?: 'ServiceArea';
  name: Scalars['String']['output'];
  postcodes: Array<Scalars['String']['output']>;
  state: ServiceAreaState;
};

export type ServiceAreaState = {
  __typename?: 'ServiceAreaState';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SlugFilter = {
  slug?: InputMaybe<StringFilter>;
};

export type SmeDirector = {
  __typename?: 'SmeDirector';
  address: Address;
  dateOfBirth: Scalars['String']['output'];
  drivingLicense?: Maybe<DrivingLicense>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isGuarantor?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  privacyAndCreditStatement?: Maybe<Scalars['String']['output']>;
};

export type SmeDirectorInput = {
  address: AddressInput;
  dateOfBirth: Scalars['String']['input'];
  drivingLicense?: InputMaybe<DrivingLicenseInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isGuarantor?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  privacyAndCreditStatement?: InputMaybe<Scalars['String']['input']>;
};

export type SoftDeleteUserInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SolarInstallationsInput = {
  postcode: Scalars['String']['input'];
};

export type SolarSavingsProfileElectricityBillInput = {
  amount: Scalars['Float']['input'];
  period: ElectricityBillPeriod;
};

export type SolarSavingsProfileInput = {
  electricityBill: SolarSavingsProfileElectricityBillInput;
  electricityDayUsePercentage: Scalars['Float']['input'];
  financialProductSlug?: InputMaybe<FinancialProductSlugs>;
  postcode: Scalars['String']['input'];
  repaymentTerm?: InputMaybe<RepaymentTermMonths>;
};

export type SolarSavingsProfileResponse = {
  __typename?: 'SolarSavingsProfileResponse';
  annualElectricityBillSavings: Scalars['Float']['output'];
  annualElectricityBillSavingsAfterFinanceCosts: Scalars['Float']['output'];
  annualElectricityBillWithSolar: Scalars['Float']['output'];
  annualElectricityBillWithoutSolar: Scalars['Float']['output'];
  dailyElectricityUsageKwh: Scalars['Float']['output'];
  fortnightlyRepaymentAmount: Scalars['Float']['output'];
  systemRecommendation: SolarSavingsProfileSystemRecommendation;
};

export type SolarSavingsProfileSystemRecommendation = {
  __typename?: 'SolarSavingsProfileSystemRecommendation';
  numberOf330WSolarPanels: Scalars['Int']['output'];
  solarInverterSizeKw: Scalars['Float']['output'];
  solarSystemSizeKw: Scalars['Float']['output'];
  systemOutputKwh: Scalars['Float']['output'];
};

export type SoleTraderDetail = {
  __typename?: 'SoleTraderDetail';
  individual: SmeDirector;
};

export type SoleTraderDetailInput = {
  individual: SmeDirectorInput;
};

export enum SortDir {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED',
}

export type StartPropertyTitleSearchInput = {
  address: PropertyTitleSearchAddressInput;
  trackingId: Scalars['ID']['input'];
};

export type StartPropertyTitleSearchOutput = {
  __typename?: 'StartPropertyTitleSearchOutput';
  searchStatus: Scalars['String']['output'];
  trackingId: Scalars['ID']['output'];
};

export enum Status {
  BadFit = 'BAD_FIT',
  FinalAttempt = 'FINAL_ATTEMPT',
  FirstAttempt = 'FIRST_ATTEMPT',
  IntroTextSent = 'INTRO_TEXT_SENT',
  New = 'NEW',
  NotReadyYet = 'NOT_READY_YET',
  NoLongerInterested = 'NO_LONGER_INTERESTED',
  PriceFishing = 'PRICE_FISHING',
  Qualified = 'QUALIFIED',
  Quoted = 'QUOTED',
  ReadyToCall = 'READY_TO_CALL',
  SecondAttempt = 'SECOND_ATTEMPT',
  ThirdAttempt = 'THIRD_ATTEMPT',
  UnableToContact = 'UNABLE_TO_CONTACT',
}

export type StepVisibilityClause = {
  __typename?: 'StepVisibilityClause';
  /** Comparison operator: "equals" | "notEquals" | "in" | "notIn". */
  operator: Scalars['String']['output'];
  /** stepFlow.id of a PRIOR step whose answer this clause tests, e.g. "intent". */
  questionId: Scalars['String']['output'];
  /** Option value(s) compared against the buyer's answer to `questionId`. */
  values: Array<Scalars['String']['output']>;
};

export type StepVisibilityCondition = {
  __typename?: 'StepVisibilityCondition';
  /** Clauses evaluated against prior answers. */
  clauses: Array<StepVisibilityClause>;
  /** How clauses combine: "all" (AND, default) or "any" (OR). */
  match?: Maybe<Scalars['String']['output']>;
};

export enum StoveType {
  Ceramic = 'CERAMIC',
  Induction = 'INDUCTION',
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitApplicationDocumentsInput = {
  applicationId: Scalars['String']['input'];
  assistedUploadConsent?: InputMaybe<Scalars['String']['input']>;
  documentIds: Array<Scalars['String']['input']>;
  joint?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitDocumentRequestsInput = {
  applicantId: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
  assistedUploadConsent?: InputMaybe<Scalars['String']['input']>;
  income?: InputMaybe<SubmitIncomeInput>;
  submissions: Array<DocumentRequestSubmissionInput>;
};

export type SubmitDocumentRequestsResult = {
  __typename?: 'SubmitDocumentRequestsResult';
  submitted: Array<DocumentRequestItem>;
};

export type SubmitEnrollmentInput = {
  completed?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type SubmitIncomeInput = {
  additional?: InputMaybe<DeclaredIncomeInput>;
  primary?: InputMaybe<DeclaredIncomeInput>;
};

export type SubmitTitleOwnerIncomeInput = {
  applicationId: Scalars['ID']['input'];
  owners: Array<SubmitTitleOwnerIncomeOwnerInput>;
  ownershipDisputed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitTitleOwnerIncomeOutput = {
  __typename?: 'SubmitTitleOwnerIncomeOutput';
  applicationId: Scalars['ID']['output'];
  owners: Array<SubmittedTitleOwner>;
};

export type SubmitTitleOwnerIncomeOwnerInput = {
  declaredIncome: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  isIncomeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isPensioner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitTitleSearchOwnerInput = {
  applicationId: Scalars['ID']['input'];
  owners: Array<SubmitTitleSearchOwnerOwnerInput>;
  ownershipDisputed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitTitleSearchOwnerOutput = {
  __typename?: 'SubmitTitleSearchOwnerOutput';
  applicationId: Scalars['ID']['output'];
  owners: Array<SubmittedTitleSearchOwner>;
};

export type SubmitTitleSearchOwnerOwnerInput = {
  declaredIncome?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  idMatrixReference?: InputMaybe<Scalars['String']['input']>;
  isIncomeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfFundedRetireeDeclared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmittedTitleOwner = {
  __typename?: 'SubmittedTitleOwner';
  aiIncomeCalculated?: Maybe<Scalars['Float']['output']>;
  declaredIncome: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isIncomeVerified: Scalars['Boolean']['output'];
  isPensioner?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmittedTitleSearchOwner = {
  __typename?: 'SubmittedTitleSearchOwner';
  aiIncomeCalculated?: Maybe<Scalars['Float']['output']>;
  declaredIncome?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  incomeType?: Maybe<TitleOwnerIncomeType>;
  isIncomeVerified: Scalars['Boolean']['output'];
  verificationMethod?: Maybe<TitleOwnerVerificationMethod>;
  verificationStatus?: Maybe<TitleOwnerVerificationStatus>;
};

export type SummaryByStatusGroup = {
  __typename?: 'SummaryByStatusGroup';
  count: Scalars['Float']['output'];
  statusGroup: Scalars['String']['output'];
  statusGroupId?: Maybe<Scalars['Float']['output']>;
  totalFinancedAmount: Scalars['Float']['output'];
};

export type SupportArticle = Entity &
  Node & {
    __typename?: 'SupportArticle';
    content?: Maybe<SupportArticleContentRichText>;
    /** The time the document was created */
    createdAt: Scalars['DateTime']['output'];
    /** User that created this document */
    createdBy?: Maybe<HyGraphUser>;
    description?: Maybe<Scalars['String']['output']>;
    /** Get the document in other stages */
    documentInStages: Array<SupportArticle>;
    heading?: Maybe<Scalars['String']['output']>;
    /** List of SupportArticle versions */
    history: Array<Version>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Absolute URL to the image */
    image?: Maybe<Scalars['String']['output']>;
    /** Description of the image for vision impaired visitors. */
    imageAlt?: Maybe<Scalars['String']['output']>;
    /** The time the document was published. Null on documents in draft stage. */
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    /** User that last published this document */
    publishedBy?: Maybe<HyGraphUser>;
    scheduledIn: Array<ScheduledOperation>;
    slug?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    title?: Maybe<Scalars['String']['output']>;
    /** The time the document was updated */
    updatedAt: Scalars['DateTime']['output'];
    /** User that last updated this document */
    updatedBy?: Maybe<HyGraphUser>;
  };

export type SupportArticleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SupportArticleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type SupportArticleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};

export type SupportArticlePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SupportArticleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type SupportArticleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SupportArticleContentRichText = {
  __typename?: 'SupportArticleContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<SupportArticleContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type SupportArticleContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SupportArticleContentRichTextEmbeddedTypes = Asset;

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION',
}

export type Tag = {
  __typename?: 'Tag';
  displayName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type TagsResponse = {
  __typename?: 'TagsResponse';
  tags: Array<Tag>;
};

export type Term = {
  __typename?: 'Term';
  months: Scalars['Int']['output'];
  payments: Scalars['Int']['output'];
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  applicationEligibilityAgreement?: Maybe<Scalars['String']['output']>;
  authoriseBrighteStatement?: Maybe<Scalars['String']['output']>;
  beCompletedPropertyOwner?: Maybe<Scalars['String']['output']>;
  beGovSchemeHomeOwner?: Maybe<Scalars['String']['output']>;
  beOver18?: Maybe<Scalars['String']['output']>;
  businessEligibilityCriteriaAgreement?: Maybe<Scalars['String']['output']>;
  capacityToPay?: Maybe<Scalars['String']['output']>;
  consentCreditCheck?: Maybe<Scalars['String']['output']>;
  consentCreditReport?: Maybe<Scalars['String']['output']>;
  consentCustomerDeclaration?: Maybe<Scalars['String']['output']>;
  consentElectronicCommunication?: Maybe<Scalars['String']['output']>;
  consentGovSchemeTerms?: Maybe<Scalars['String']['output']>;
  consentPrivacyPolicy?: Maybe<Scalars['String']['output']>;
  creditAndTermsAgreement?: Maybe<Scalars['String']['output']>;
  customerDeclarationAgreement?: Maybe<Scalars['String']['output']>;
  directDebitStatement?: Maybe<Scalars['String']['output']>;
  enterprisePartnerTerms?: Maybe<Scalars['String']['output']>;
  haveActiveMortgage?: Maybe<Scalars['String']['output']>;
  haveAustralianIncome?: Maybe<Scalars['String']['output']>;
  haveEligibleNetIncome?: Maybe<Scalars['String']['output']>;
  haveFilledOwnDetails?: Maybe<Scalars['String']['output']>;
  haveReadDisclosureOfCreditInformation?: Maybe<Scalars['String']['output']>;
  privacyAndElectronicCommunicationAgreement?: Maybe<Scalars['String']['output']>;
};

export type TermsAndConditionsInput = {
  applicationEligibilityAgreement?: InputMaybe<Scalars['String']['input']>;
  authoriseBrighteStatement?: InputMaybe<Scalars['String']['input']>;
  beCompletedPropertyOwner?: InputMaybe<Scalars['String']['input']>;
  beGovSchemeHomeOwner?: InputMaybe<Scalars['String']['input']>;
  beOver18?: InputMaybe<Scalars['String']['input']>;
  businessEligibilityCriteriaAgreement?: InputMaybe<Scalars['String']['input']>;
  capacityToPay?: InputMaybe<Scalars['String']['input']>;
  consentCreditCheck?: InputMaybe<Scalars['String']['input']>;
  consentCreditReport?: InputMaybe<Scalars['String']['input']>;
  consentCustomerDeclaration?: InputMaybe<Scalars['String']['input']>;
  consentElectronicCommunication?: InputMaybe<Scalars['String']['input']>;
  consentGovSchemeTerms?: InputMaybe<Scalars['String']['input']>;
  consentPrivacyPolicy?: InputMaybe<Scalars['String']['input']>;
  creditAndTermsAgreement?: InputMaybe<Scalars['String']['input']>;
  customerDeclarationAgreement?: InputMaybe<Scalars['String']['input']>;
  directDebitStatement?: InputMaybe<Scalars['String']['input']>;
  enterprisePartnerTerms?: InputMaybe<Scalars['String']['input']>;
  haveActiveMortgage?: InputMaybe<Scalars['String']['input']>;
  haveAustralianIncome?: InputMaybe<Scalars['String']['input']>;
  haveEligibleNetIncome?: InputMaybe<Scalars['String']['input']>;
  haveFilledOwnDetails?: InputMaybe<Scalars['String']['input']>;
  haveReadDisclosureOfCreditInformation?: InputMaybe<Scalars['String']['input']>;
  privacyAndElectronicCommunicationAgreement?: InputMaybe<Scalars['String']['input']>;
};

export enum Ternary {
  Maybe = 'MAYBE',
  No = 'NO',
  Yes = 'YES',
}

export enum Theme {
  Blue = 'Blue',
  BlueSoft = 'BlueSoft',
  Dark = 'Dark',
  Green = 'Green',
  GreenSoft = 'GreenSoft',
  Outline = 'Outline',
  Red = 'Red',
  RedSoft = 'RedSoft',
  Yellow = 'Yellow',
  YellowSoft = 'YellowSoft',
}

export type TitleOwnerDocumentOperationInput = {
  applicationId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  titleSearchOwnerId: Scalars['ID']['input'];
};

export type TitleOwnerDocumentVerificationOutput = {
  __typename?: 'TitleOwnerDocumentVerificationOutput';
  requestId: Scalars['ID']['output'];
  result?: Maybe<VerifyIncomeDocumentUploadResult>;
  verificationStatus: TitleOwnerVerificationStatus;
};

export enum TitleOwnerIncomeType {
  Employed = 'EMPLOYED',
  NoIncome = 'NO_INCOME',
  Pensioner = 'PENSIONER',
  Retiree = 'RETIREE',
  SelfEmployed = 'SELF_EMPLOYED',
}

export enum TitleOwnerVerificationMethod {
  Idmatrix = 'IDMATRIX',
  Noa = 'NOA',
  None = 'NONE',
  NoIncome = 'NO_INCOME',
  Superannuation = 'SUPERANNUATION',
}

export enum TitleOwnerVerificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Verified = 'VERIFIED',
}

export type TrainingFinancialProduct = {
  __typename?: 'TrainingFinancialProduct';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TrainingFinancialProductInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TrustDetail = {
  __typename?: 'TrustDetail';
  beneficialOwners?: Maybe<Array<EnterpriseIdentityWithIdentification>>;
  corporateEntities?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<SmeDirector>>;
  ownershipType: OwnershipType;
};

export type TrustDetailInput = {
  beneficialOwners?: InputMaybe<Array<EnterpriseIdentityWithIdentificationInput>>;
  corporateEntities?: InputMaybe<Scalars['String']['input']>;
  directors?: InputMaybe<Array<SmeDirectorInput>>;
  ownershipType: OwnershipType;
};

export type UnimprovedValueAddressInput = {
  postcode: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UnimprovedValueError = {
  __typename?: 'UnimprovedValueError';
  dwellingTypeUvLimit: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  status: UnimprovedValueStatus;
  value: Scalars['Int']['output'];
};

export type UnimprovedValueInput = {
  address: UnimprovedValueAddressInput;
  dwellingType: Scalars['String']['input'];
  financialProductSlug?: Scalars['String']['input'];
  installCategorySlug?: Scalars['String']['input'];
};

export enum UnimprovedValueStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
}

export type UnimprovedValueSuccess = {
  __typename?: 'UnimprovedValueSuccess';
  status: UnimprovedValueStatus;
  value: Scalars['Int']['output'];
};

export type UnimprovedValueUnion = UnimprovedValueError | UnimprovedValueSuccess;

export type UpdateAccountAmounts = {
  accountId: Scalars['String']['input'];
  deposit: Scalars['Float']['input'];
  purchaseAmount: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
};

export type UpdateAccountPaymentMethod = {
  accountId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};

export type UpdateAccountReferenceNumber = {
  accountId: Scalars['String']['input'];
  referenceNumber: Scalars['String']['input'];
};

export type UpdateApplicantInputForAdmin = {
  applicationId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Home Energy Saver Discount */
  hesdClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** NatHERS Assessment */
  nathersAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  /** NSW Safeguard incentives */
  nswSafeguardClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Replaces existing equipment */
  replacesExistingEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Small-scale Technology Certificates */
  sresClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ApplicantStatus>;
  type: ApplicantType;
};

export type UpdateApplicationDocumentUploadedResult = {
  __typename?: 'UpdateApplicationDocumentUploadedResult';
  document: ApplicationDocument;
};

export type UpdateApplicationInput = {
  applicant?: InputMaybe<ApplicantInput>;
  approved?: InputMaybe<Scalars['DateTime']['input']>;
  customerType: CustomerType;
  deposit?: InputMaybe<Scalars['Float']['input']>;
  enterprise?: InputMaybe<EnterpriseInput>;
  financedAmount?: InputMaybe<Scalars['Float']['input']>;
  financialProductId: Scalars['String']['input'];
  hasJointApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  hasVulnerableApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  incomeVerification?: InputMaybe<IncomeVerificationInput>;
  isCashApplication?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentDetailsInput>;
  primarySignatoryEmail?: InputMaybe<Scalars['String']['input']>;
  primarySignatoryName?: InputMaybe<Scalars['String']['input']>;
  promotionDiscount?: InputMaybe<Scalars['Float']['input']>;
  purchaseAmount?: InputMaybe<Scalars['Float']['input']>;
  rebate?: InputMaybe<Scalars['Float']['input']>;
  rebateDiscount?: InputMaybe<Scalars['Float']['input']>;
  secondarySignatoryEmail?: InputMaybe<Scalars['String']['input']>;
  secondarySignatoryName?: InputMaybe<Scalars['String']['input']>;
  status: ApplicationFormStatus;
  step: ApplicationStep;
  subStatus?: InputMaybe<Scalars['String']['input']>;
  submitted?: InputMaybe<Scalars['DateTime']['input']>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
  withdrawn?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateApplicationTermInput = {
  id: Scalars['String']['input'];
  repaymentTerm: RepaymentTermInput;
};

export type UpdateCategoryDataInput = {
  accessFields?: InputMaybe<AccessFields>;
  financialProductSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  group?: InputMaybe<CategoryGroup>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCategorySlug?: InputMaybe<Scalars['String']['input']>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCategoryInput = {
  data: UpdateCategoryDataInput;
  slug: Scalars['String']['input'];
};

export type UpdateCategoryResponse = {
  __typename?: 'UpdateCategoryResponse';
  category: Category;
};

export type UpdateCourseInput = {
  bannerDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  financialProducts?: InputMaybe<Array<TrainingFinancialProductInput>>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<RoleName>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentUploadedResultDto = {
  __typename?: 'UpdateDocumentUploadedResultDto';
  document: Document;
};

export type UpdateEnrollmentProgressInput = {
  id: Scalars['ID']['input'];
  progress: Scalars['Float']['input'];
};

export type UpdateEnterpriseLeadCategoryInternalNotesInput = {
  category: Scalars['String']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  leadId: Scalars['String']['input'];
};

export type UpdateManufacturerInput = {
  battery: Scalars['Boolean']['input'];
  batteryPremium?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  electricHeatingAndCooling: Scalars['Boolean']['input'];
  electricHeatingAndCoolingPremium?: InputMaybe<Scalars['Boolean']['input']>;
  evCharging: Scalars['Boolean']['input'];
  evChargingPremium?: InputMaybe<Scalars['Boolean']['input']>;
  glazingWindow: Scalars['Boolean']['input'];
  glazingWindowPremium?: InputMaybe<Scalars['Boolean']['input']>;
  hotWaterHeatPump: Scalars['Boolean']['input'];
  hotWaterHeatPumpPremium?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  inverter: Scalars['Boolean']['input'];
  inverterPremium?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pvPanel: Scalars['Boolean']['input'];
  pvPanelPremium?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  solarHotWater: Scalars['Boolean']['input'];
  solarHotWaterPremium?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMarketplaceSettingsInput = {
  settings: MarketplaceSettings;
  vendorId: Scalars['String']['input'];
};

export type UpdateMeInput = {
  metadata?: InputMaybe<MetadataInput>;
};

export type UpdateMyEnterpriseLeadCategoryContentInput = {
  category: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyEnterpriseLeadContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyVendorEnrolledProductSettingsInput = {
  /** Vendor-side toggle of the enrolled financial product */
  activationStatus?: InputMaybe<ActivationStatus>;
  /** Slug of the FinancialProduct (owned by the finance service) whose settings this update applies to */
  financialProductSlug: Scalars['String']['input'];
  /** FULL replacement set of repayment terms in months (portal-owned, via finance; vendor-level, shared across all of the vendor’s products) — terms missing from the list are removed; an empty list clears all terms */
  terms?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Public ID of the vendor whose product settings are updated */
  vendorId: Scalars['String']['input'];
};

export type UpdateNotificationSettingsInput = {
  settings: NotificationSettings;
  vendorId: Scalars['String']['input'];
};

export type UpdateProductSettingsInput = {
  settings: ProductSettings;
  vendorId: Scalars['String']['input'];
};

export type UpdateQuoteInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientUserId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<QuoteStatus>;
  trackingId: Scalars['String']['input'];
};

export type UpdateReferralInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientUserId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<QuoteStatus>;
};

export type UpdateTitleSearchOwnerInput = {
  applicationId: Scalars['ID']['input'];
  owners: Array<UpdateTitleSearchOwnerOwnerInput>;
  ownershipDisputed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTitleSearchOwnerOutput = {
  __typename?: 'UpdateTitleSearchOwnerOutput';
  applicationId: Scalars['ID']['output'];
  owners: Array<UpdatedTitleSearchOwner>;
};

export type UpdateTitleSearchOwnerOwnerInput = {
  declaredIncome: Scalars['Float']['input'];
  hasNoIncome?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idMatrixReference?: InputMaybe<Scalars['String']['input']>;
  incomeType: TitleOwnerIncomeType;
  isIncomeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfFundedRetireeDeclared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<AddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  salesforceUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUsersInput = {
  ids: Array<Scalars['String']['input']>;
  remittanceAdviceGroup: Scalars['Boolean']['input'];
};

export type UpdateVendorAccountDmsInput = {
  /** true sets the locked timestamp to now, false clears it; omit to leave unchanged */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Public ID (U number) of the user to set as the vendor manager; omit to leave unchanged */
  managerId?: InputMaybe<Scalars['String']['input']>;
  /** Maximum repayment term in months; omit to leave unchanged */
  maxTerm?: InputMaybe<Scalars['Int']['input']>;
  /** Public ID (U number) of the user to set as the primary user; omit to leave unchanged */
  primaryUserId?: InputMaybe<Scalars['String']['input']>;
  /** Public ID (remote_id, E/B number) of the vendor to update */
  vendorId: Scalars['String']['input'];
};

export type UpdateVendorAccountSettingsFlagsInput = {
  /** Which account-level flag set the replacement applies to — only GENERAL and MARKETPLACE are editable via this mutation (product feature flags are managed via vendorUpdateEnrolledProductSettings). */
  flagType: AccountSettingsFlagType;
  /** FULL replacement set of the vendor's visible flag names of the chosen flagType (portal-owned, via finance). Unknown names, hidden (`visible: false`) flags, soft-deleted flags and flags of a different type are rejected; hidden assignments are never removed by the replacement; an empty list clears all flags of that type. */
  flags: Array<Scalars['String']['input']>;
  /** Public ID of the vendor whose account-level flags are updated */
  vendorId: Scalars['String']['input'];
};

export type UpdateVendorDetailInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressDetail?: InputMaybe<AddressInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorEnrolledProductSettingsInput = {
  /** Vendor-side toggle of the enrolled financial product */
  activationStatus?: InputMaybe<ActivationStatus>;
  /** Admin approval of the enrolled financial product */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Slug of the FinancialProduct (owned by the finance service) whose settings this update applies to */
  financialProductSlug: Scalars['String']['input'];
  /** FULL replacement set of the picked product's visible PRODUCT_FEATURE flag names (portal-owned, via finance). Unknown names, hidden (`visible: false`) flags and flags that are not features of this financialProductSlug are rejected; hidden assignments are never removed by the replacement. */
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum repayment term in months (portal-owned, via finance) */
  maxTerm?: InputMaybe<Scalars['Int']['input']>;
  /** FULL replacement set of repayment terms in months (portal-owned, via finance; vendor-level, shared across all of the vendor’s products) — terms missing from the list are removed; an empty list clears all terms */
  terms?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Public ID of the vendor whose product settings are updated */
  vendorId: Scalars['String']['input'];
};

export type UpdateVendorFlagDataInput = {
  bdmCanToggle?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductSlug?: InputMaybe<Scalars['String']['input']>;
  flagType?: InputMaybe<FlagType>;
  label?: InputMaybe<Scalars['String']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateVendorFlagInput = {
  data: UpdateVendorFlagDataInput;
  flagName: Scalars['String']['input'];
};

export type UpdateVendorFlagsResponse = {
  __typename?: 'UpdateVendorFlagsResponse';
  flag: VendorFlagDefinition;
};

export type UpdateVendorLicenseInput = {
  details?: InputMaybe<Scalars['JSON']['input']>;
  licenseId: Scalars['String']['input'];
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LicenseStatus>;
};

export type UpdateVendorLogoInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  vendorId: Scalars['String']['input'];
};

export type UpdateVendorLogoResponse = {
  __typename?: 'UpdateVendorLogoResponse';
  fieldsJson?: Maybe<Scalars['String']['output']>;
  image: Image;
  url?: Maybe<Scalars['String']['output']>;
};

export type UpdateVendorRebateInput = {
  dollar?: InputMaybe<Scalars['Float']['input']>;
  finishDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Float']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  rebateType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateVendorUserInput = {
  /** Vendor public ids to end the user’s authority contact on. Rejected if it would leave a vendor with no active authority contact. */
  authorityContactsToClear?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Vendor public ids to make the user the authority contact for. */
  authorityContactsToSet?: InputMaybe<Array<Scalars['String']['input']>>;
  /** User's email. Rejected downstream if it belongs to another user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User's Australian mobile number. */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Role to set. Only VENDOR and TEAM are valid. */
  role?: InputMaybe<VendorUserRoleName>;
  /** Public id of the user to update, for example U142173. */
  userId: Scalars['String']['input'];
  /** Vendor public ids to link the user to. */
  vendorsToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Vendor public ids to unlink the user from. Requires authorityContactsToClear for any active AC. */
  vendorsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateVendorUserLinksInput = {
  /** User public ID in U number format */
  userId: Scalars['String']['input'];
  /** Vendor public IDs to link in E number or B number format */
  vendorsToAdd?: Array<Scalars['String']['input']>;
  /** Vendor public IDs to unlink in E number or B number format */
  vendorsToRemove?: Array<Scalars['String']['input']>;
};

export type UpdateVendorUserLinksResponse = {
  __typename?: 'UpdateVendorUserLinksResponse';
  /** Vendor public IDs the user was actually linked to as a result of this request (already-linked vendors are skipped and excluded) */
  linkedVendorIds: Array<Scalars['String']['output']>;
  /** Vendor public IDs the user was actually unlinked from as a result of this request (vendors the user was not linked to are excluded) */
  unlinkedVendorIds: Array<Scalars['String']['output']>;
  /** User public ID in U number format */
  userId: Scalars['String']['output'];
};

export type UpdateVendorUserResult = {
  __typename?: 'UpdateVendorUserResult';
  memberships: Array<VendorUserVendorLink>;
  userId: Scalars['ID']['output'];
};

export type UpdateVendorsForUserInput = {
  /** User public ID in U number format */
  userId: Scalars['String']['input'];
  /** Vendor public IDs to add in E number or B number format */
  vendorsToAdd?: Array<Scalars['String']['input']>;
  /** Vendor public IDs to remove in E number or B number format */
  vendorsToRemove?: Array<Scalars['String']['input']>;
};

export type UpdateVendorsForUserResponse = {
  __typename?: 'UpdateVendorsForUserResponse';
  /** User public ID in U number format */
  userId: Scalars['String']['output'];
  vendors: Array<Vendor>;
};

export type UpdatedTitleSearchOwner = {
  __typename?: 'UpdatedTitleSearchOwner';
  declaredIncome?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  incomeType?: Maybe<TitleOwnerIncomeType>;
  verificationStatus?: Maybe<TitleOwnerVerificationStatus>;
};

export type UploadedDocument = {
  __typename?: 'UploadedDocument';
  declaredDocumentType?: Maybe<RequestedDocumentType>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  activated: Scalars['Boolean']['output'];
  address?: Maybe<AddressType>;
  addressId?: Maybe<Scalars['Int']['output']>;
  azureId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fpSynced?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  initialized: Scalars['Boolean']['output'];
  issues?: Maybe<Array<UserIssue>>;
  lastLogin?: Maybe<Scalars['DateTimeISO']['output']>;
  lastName: Scalars['String']['output'];
  legacyId: Scalars['Int']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTimeISO']['output']>;
  remittanceAdviceGroup?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Role>;
  roleId: Scalars['Int']['output'];
  salesforceContactId?: Maybe<Scalars['String']['output']>;
  salesforceUserId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  vendors?: Maybe<Array<BaseVendor>>;
};

export type UserHistory = {
  __typename?: 'UserHistory';
  created: Scalars['DateTimeISO']['output'];
  operation: Scalars['String']['output'];
  operator?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type UserIssue = {
  __typename?: 'UserIssue';
  created: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  resolved?: Maybe<Scalars['DateTimeISO']['output']>;
  subject: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

/** System User Kind */
export enum UserKind {
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK',
}

export type UserProfile = {
  __typename?: 'UserProfile';
  /** user address */
  address?: Maybe<UserProfileAddress>;
  /** date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  /** email */
  email?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Initialized flag to indicate if user agreed to T&Cs */
  initialized?: Maybe<Scalars['Boolean']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** mobile */
  mobile?: Maybe<Scalars['String']['output']>;
  /** remote id */
  remoteId?: Maybe<Scalars['String']['output']>;
  /** role */
  role?: Maybe<Scalars['String']['output']>;
  /** userId */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserProfileAddress = {
  __typename?: 'UserProfileAddress';
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Post code */
  postCode?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Street name */
  streetName?: Maybe<Scalars['String']['output']>;
  /** Street number */
  streetNumber?: Maybe<Scalars['String']['output']>;
  /** Suburb */
  suburb?: Maybe<Scalars['String']['output']>;
  /** Unit number */
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export enum UserSearchCondition {
  EmailAndMobile = 'EMAIL_AND_MOBILE',
  EmailOnly = 'EMAIL_ONLY',
}

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

export type UsersFilter = {
  AND?: InputMaybe<Array<UsersFilterFields>>;
  OR?: InputMaybe<Array<UsersFilterFields>>;
  activated?: InputMaybe<BooleanFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  /** Required for current table relationship, as it uses the legacy id */
  legacyId?: InputMaybe<NumberFilter>;
  /** Filter by the user's vendor manager public id. Relation-backed: supports equals and in only. */
  managerId?: InputMaybe<IdFilter>;
  mobile?: InputMaybe<StringFilter>;
  openIssues?: InputMaybe<BooleanFilter>;
  remittanceAdviceGroup?: InputMaybe<BooleanFilter>;
  roleId?: InputMaybe<NumberFilter>;
  /** Filter by the user's role name. Relation-backed: supports equals and in only. */
  roleName?: InputMaybe<IdFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  suspended?: InputMaybe<BooleanFilter>;
  /** Filter by the user's vendor public id. Relation-backed: supports equals and in only. */
  vendorId?: InputMaybe<IdFilter>;
};

export type UsersFilterFields = {
  activated?: InputMaybe<BooleanFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  /** Required for current table relationship, as it uses the legacy id */
  legacyId?: InputMaybe<NumberFilter>;
  /** Filter by the user's vendor manager public id. Relation-backed: supports equals and in only. */
  managerId?: InputMaybe<IdFilter>;
  mobile?: InputMaybe<StringFilter>;
  openIssues?: InputMaybe<BooleanFilter>;
  remittanceAdviceGroup?: InputMaybe<BooleanFilter>;
  roleId?: InputMaybe<NumberFilter>;
  /** Filter by the user's role name. Relation-backed: supports equals and in only. */
  roleName?: InputMaybe<IdFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  suspended?: InputMaybe<BooleanFilter>;
  /** Filter by the user's vendor public id. Relation-backed: supports equals and in only. */
  vendorId?: InputMaybe<IdFilter>;
};

export type ValidateDocumentRequestDocumentInput = {
  applicationId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  documentRequestId: Scalars['Int']['input'];
};

export type ValidateDocumentRequestDocumentResult = {
  __typename?: 'ValidateDocumentRequestDocumentResult';
  document: ValidatedRequestedDocument;
  documentRequestId: Scalars['Int']['output'];
};

export type ValidatedRequestedDocument = {
  __typename?: 'ValidatedRequestedDocument';
  documentType: RequestedDocumentType;
  failureCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  validation: Scalars['String']['output'];
};

export type Vendor = {
  __typename?: 'Vendor';
  abn?: Maybe<Scalars['String']['output']>;
  acn?: Maybe<Scalars['String']['output']>;
  /** Required scopes: read:vendor-rebates */
  activeRebate?: Maybe<VendorRebate>;
  advancePayBalance?: Maybe<Scalars['Float']['output']>;
  /** Required scopes: read:my-vendor-agents, read:vendor-agents */
  agents?: Maybe<Array<Employee>>;
  approvedFinancialProducts?: Maybe<Array<FinancialProduct>>;
  authorityContacts?: Maybe<Array<AuthorityContact>>;
  availableTermOptions: Array<Term>;
  avgSettleTime: Scalars['Int']['output'];
  baseScore?: Maybe<Scalars['Int']['output']>;
  brands?: Maybe<Array<VendorBrand>>;
  businessName?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Category>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  details: Array<VendorDetail>;
  documents: Array<VendorDocument>;
  enrolledFinancialProducts?: Maybe<Array<EnrolledFinancialProduct>>;
  financialProducts?: Maybe<VendorFinancialProducts>;
  flags?: Maybe<Array<Flag>>;
  id: Scalars['ID']['output'];
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  isLocked: Scalars['Boolean']['output'];
  /** Required scopes: read:my-vendor-agents, read:vendor-agents */
  leadsAgent?: Maybe<Employee>;
  leadsCount?: Maybe<Scalars['Int']['output']>;
  leadsLimit?: Maybe<Scalars['Int']['output']>;
  /** Required scopes: read:leads-limits */
  leadsLimitReached?: Maybe<Scalars['DateTime']['output']>;
  legacyId: Scalars['Int']['output'];
  legalName: Scalars['String']['output'];
  licenses?: Maybe<Array<License>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<VendorPublicUser>;
  managerId?: Maybe<Scalars['ID']['output']>;
  marketplacePromotions: Array<Promotion>;
  maxTerm: Scalars['Int']['output'];
  openingHours: Array<VendorOpeningHours>;
  parentId?: Maybe<Scalars['String']['output']>;
  primaryUser?: Maybe<VendorPublicUser>;
  primaryUserId?: Maybe<Scalars['ID']['output']>;
  publicId: Scalars['String']['output'];
  rates: Array<VendorRate>;
  rating?: Maybe<RatingResponse>;
  rebates?: Maybe<Array<VendorRebate>>;
  remittanceAdviceGroupUsers: Array<Agent>;
  serviceAreas: Array<ServiceArea>;
  sfAccountId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  subscriptions: Array<VendorSubscription>;
  terms: Array<Term>;
  termsMonths: Array<Scalars['Int']['output']>;
  tier: Scalars['String']['output'];
  tier1Deposit: Scalars['Float']['output'];
  tradingName: Scalars['String']['output'];
  userLimit: Scalars['Int']['output'];
  users?: Maybe<Array<VendorUser>>;
  vendorFlags: Array<VendorFlag>;
};

export type VendorMarketplacePromotionsArgs = {
  filter?: InputMaybe<MarketplacePromotionsFilter>;
};

export type VendorAccountSettingsFlags = {
  __typename?: 'VendorAccountSettingsFlags';
  /** The account-level flag type this update applied to */
  flagType: FlagType;
  /** The vendor's visible flags of this flagType after the update */
  flags: Array<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
};

export type VendorActivityLog = {
  __typename?: 'VendorActivityLog';
  action: ActivityLogAction;
  actorRole: ActorRole;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** { context?, before, after } — the value-level diff. */
  log: Scalars['JSON']['output'];
  /** Human-readable description of what happened. */
  message: Scalars['String']['output'];
  /** Actor public id; null for system writes. */
  userId?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
};

export type VendorActivityLogsFilter = {
  /** The vendor's publicId. */
  vendorId: Scalars['String']['input'];
};

export type VendorActivityLogsMeta = {
  __typename?: 'VendorActivityLogsMeta';
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type VendorActivityLogsResponse = {
  __typename?: 'VendorActivityLogsResponse';
  items: Array<VendorActivityLog>;
  meta: VendorActivityLogsMeta;
};

/** Address */
export type VendorBffAddressBff = {
  __typename?: 'VendorBFFAddressBff';
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Post code */
  postCode?: Maybe<Scalars['Int']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Street name */
  streetName?: Maybe<Scalars['String']['output']>;
  /** Street number */
  streetNumber?: Maybe<Scalars['String']['output']>;
  /** Suburb */
  suburb?: Maybe<Scalars['String']['output']>;
  /** Unit number */
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type VendorBffAddressInput = {
  /** country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** postcode */
  postCode: Scalars['Int']['input'];
  /** state */
  state: Scalars['String']['input'];
  /** street name */
  streetName: Scalars['String']['input'];
  /** street number */
  streetNumber: Scalars['String']['input'];
  /** suburb */
  suburb: Scalars['String']['input'];
  /** unit number */
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input type */
export type VendorBffCreateAppFeedbackInput = {
  /** comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** email */
  email: Scalars['String']['input'];
  /** name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** score between 1 - 5 */
  score: Scalars['Int']['input'];
  /** user id */
  userId: Scalars['ID']['input'];
};

export type VendorBffCreateAppFeedbackResponse = {
  __typename?: 'VendorBFFCreateAppFeedbackResponse';
  /** survey ID */
  id: Scalars['ID']['output'];
};

/** Input type */
export type VendorBffCreateSupportTicketInput = {
  /** email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Profile address */
  enquiryType?: InputMaybe<VendorBffEnquiryType>;
  /** message */
  message?: InputMaybe<Scalars['String']['input']>;
  /** mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VendorBffCreateSupportTicketResponse = {
  __typename?: 'VendorBFFCreateSupportTicketResponse';
  /** support ticket */
  ticket?: Maybe<VendorBffSupportTicket>;
};

export enum VendorBffEnquiryType {
  BusinessEnquiry = 'BUSINESS_ENQUIRY',
  HomeownerEnquiry = 'HOMEOWNER_ENQUIRY',
  VendorEnquiry = 'VENDOR_ENQUIRY',
}

export type VendorBffSupportTicket = {
  __typename?: 'VendorBFFSupportTicket';
  /** ticket ID */
  id: Scalars['ID']['output'];
};

/** Input type */
export type VendorBffUpdateProfileInput = {
  /** Profile address */
  address?: InputMaybe<VendorBffAddressInput>;
  /** date of birth */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Initialized flag to indicate if user agreed to T&Cs */
  initialized?: InputMaybe<Scalars['Boolean']['input']>;
  /** last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
};

/** Types */
export type VendorBffUserProfile = {
  __typename?: 'VendorBFFUserProfile';
  /** user address */
  address?: Maybe<VendorBffAddressBff>;
  /** date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  /** email */
  email?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Initialized flag to indicate if user agreed to T&Cs */
  initialized?: Maybe<Scalars['Boolean']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** mobile */
  mobile?: Maybe<Scalars['String']['output']>;
  /** remote id */
  remoteId?: Maybe<Scalars['String']['output']>;
  /** role */
  role?: Maybe<Scalars['String']['output']>;
  /** userId */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type VendorBrand = {
  __typename?: 'VendorBrand';
  name?: Maybe<Scalars['String']['output']>;
};

export type VendorCategoryPricingInput = {
  categorySlug: Scalars['String']['input'];
  indicativePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type VendorDashboardMetricsResponse = {
  __typename?: 'VendorDashboardMetricsResponse';
  summaries: Array<SummaryByStatusGroup>;
};

export type VendorDeclarationStatementsInput = {
  actVendorDeclarationStatement?: InputMaybe<Scalars['String']['input']>;
  heslVendorDeclarationStatement?: InputMaybe<Scalars['String']['input']>;
};

export type VendorDetail = {
  __typename?: 'VendorDetail';
  address?: Maybe<Scalars['String']['output']>;
  addressDetail?: Maybe<AddressType>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type VendorDocument = {
  __typename?: 'VendorDocument';
  created: Scalars['DateTime']['output'];
  documentType: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
};

export type VendorEmailConfig = {
  __typename?: 'VendorEmailConfig';
  /** Promo panel shown after the category box in the vendor lead-received email. The button links to vendorGuidelineUrl. */
  leadReceivedPanel?: Maybe<VendorLeadReceivedPanel>;
};

export type VendorExportJobResponse = {
  __typename?: 'VendorExportJobResponse';
  downloadUrl: Scalars['String']['output'];
};

export type VendorExportRequestInput = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  isLocked?: Scalars['Boolean']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type VendorFinancialProducts = {
  __typename?: 'VendorFinancialProducts';
  actSHS: Scalars['Boolean']['output'];
};

export type VendorFlag = {
  __typename?: 'VendorFlag';
  flag: FinanceVendorFlag;
  modified?: Maybe<Scalars['DateTime']['output']>;
  vendor: Vendor;
};

export type VendorFlagDefinition = {
  __typename?: 'VendorFlagDefinition';
  bdmCanToggle: Scalars['Boolean']['output'];
  children: Array<VendorFlagDefinition>;
  description: Scalars['String']['output'];
  financialProductSlug?: Maybe<Scalars['String']['output']>;
  flagType: FlagType;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<VendorFlagDefinition>;
  parentName?: Maybe<Scalars['String']['output']>;
  vendors: Array<VendorFlag>;
  visible: Scalars['Boolean']['output'];
};

export type VendorFlagsDmsInput = {
  /** Narrows which flags may be created/deleted (e.g. only PRODUCT_FEATURE flags of one financial product) */
  scope?: InputMaybe<VendorFlagsDmsScopeInput>;
  /** Flag names (the `flag` values from the vendor_flags table) to select */
  vendorFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Public ID (remote_id, E/B number) of the vendor */
  vendorId: Scalars['String']['input'];
};

export type VendorFlagsDmsScopeInput = {
  /** Only flags with this financial_product_slug */
  financialProductSlug?: InputMaybe<Scalars['String']['input']>;
  /** Only flags of this flag_type */
  flagType: FlagType;
};

export type VendorFlagsFilter = {
  some: VendorFlagsFilterSome;
};

export type VendorFlagsFilterSome = {
  flag: FlagsFilter;
};

export type VendorFlagsResponse = {
  __typename?: 'VendorFlagsResponse';
  flags: Array<VendorFlagDefinition>;
};

export type VendorLead = {
  __typename?: 'VendorLead';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  /** Required scopes: read:leads */
  address?: Maybe<AddressType>;
  /** Required scopes: read:user-details, read:my-vendor-agents */
  agent?: Maybe<Employee>;
  /** Required scopes: read:leads */
  attachments?: Maybe<Array<LeadAttachment>>;
  callTimePreference?: Maybe<Scalars['String']['output']>;
  /** Required scopes: read:my-vendor-categories, read:vendor-categories */
  category?: Maybe<Category>;
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer: LeadCustomer;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  enterprisePartnerId?: Maybe<Scalars['String']['output']>;
  existingConsumer: Scalars['Boolean']['output'];
  financialProduct?: Maybe<FinancialProduct>;
  hasLoan: Scalars['Boolean']['output'];
  hasPreApproval: Scalars['Boolean']['output'];
  householdSize?: Maybe<Scalars['String']['output']>;
  householdType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  interestedInFinance?: Maybe<Scalars['String']['output']>;
  leadId: Scalars['Int']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  progress?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  purchasePriority?: Maybe<Scalars['String']['output']>;
  /** Required scopes: read:finance-quotes */
  quotes: Array<Quote>;
  readDate?: Maybe<Scalars['DateTime']['output']>;
  /** Required scopes: read:leads */
  relatedLeads?: Maybe<Array<VendorLead>>;
  state?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** Required scopes: read:my-vendors, read:vendors */
  vendor?: Maybe<Vendor>;
  vendorNotes?: Maybe<Scalars['String']['output']>;
  wallType?: Maybe<Scalars['String']['output']>;
};

export type VendorLeadQuotesArgs = {
  filter?: InputMaybe<QuotesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuotesSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorLeadReceivedPanel = {
  __typename?: 'VendorLeadReceivedPanel';
  /** Body copy for the panel. */
  body: Scalars['String']['output'];
  /** Call-to-action label. Null when omitted; the vendor lead-received email then defaults it to "Learn more". */
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Heading for the channel-specific promo panel in the vendor lead-received email. */
  heading: Scalars['String']['output'];
};

export enum VendorLeadStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Assigned = 'ASSIGNED',
  Closed = 'CLOSED',
  Converted = 'CONVERTED',
  Open = 'OPEN',
}

export type VendorLeadStatusOption = {
  __typename?: 'VendorLeadStatusOption';
  label: Scalars['String']['output'];
  type: VendorLeadStatus;
};

export type VendorLeadsBulkInput = {
  leadIds: Array<Scalars['Float']['input']>;
  vendorId: Scalars['String']['input'];
};

export type VendorManager = {
  __typename?: 'VendorManager';
  id: Scalars['String']['output'];
};

export type VendorOpeningHours = {
  __typename?: 'VendorOpeningHours';
  day: VendorOperatingDays;
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type VendorOpeningHoursInput = {
  day: VendorOperatingDays;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum VendorOperatingDays {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed',
}

export type VendorPotentialDuplicateFilter = {
  /** ABN to match exactly, as stored: 11 digits, no spaces. Surrounding whitespace is trimmed. */
  abn?: InputMaybe<Scalars['String']['input']>;
  /** Business name. Matched case-insensitively against the vendor's business name, or its legal name when it has none. */
  businessName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorPromotion = {
  __typename?: 'VendorPromotion';
  created: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  vendor: Vendor;
  vendorId: Scalars['String']['output'];
};

export type VendorPublicUser = {
  __typename?: 'VendorPublicUser';
  activated?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  deleted?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialized?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['DateTimeISO']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTimeISO']['output']>;
  role?: Maybe<VendorPublicUserRole>;
};

export type VendorPublicUserRole = {
  __typename?: 'VendorPublicUserRole';
  displayName?: Maybe<Scalars['String']['output']>;
};

export type VendorRate = {
  __typename?: 'VendorRate';
  paymentTerm: Scalars['Float']['output'];
  vcfRetail?: Maybe<Scalars['Float']['output']>;
};

export type VendorRebate = {
  __typename?: 'VendorRebate';
  created: Scalars['DateTime']['output'];
  createdUser?: Maybe<Employee>;
  dollar?: Maybe<Scalars['Float']['output']>;
  finishDate: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedUser?: Maybe<Employee>;
  percentage?: Maybe<Scalars['Float']['output']>;
  rebateType: VendorRebateType;
  startDate: Scalars['DateTime']['output'];
  vendor?: Maybe<Vendor>;
};

export type VendorRebateResponse = {
  __typename?: 'VendorRebateResponse';
  vendorRebate: VendorRebate;
};

export enum VendorRebateType {
  Longtail = 'LONGTAIL',
  Price = 'PRICE',
  Volume = 'VOLUME',
}

export type VendorRebatesFilter = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  finishDate?: InputMaybe<DateFilter>;
  rebateType?: InputMaybe<VendorRebateType>;
  startDate?: InputMaybe<DateFilter>;
  vendorPublicId?: InputMaybe<Scalars['String']['input']>;
};

export type VendorRebatesResponse = {
  __typename?: 'VendorRebatesResponse';
  count: Scalars['Int']['output'];
  rebates: Array<VendorRebate>;
};

export type VendorRebatesSort = {
  created?: InputMaybe<SortDir>;
  finishDate?: InputMaybe<SortDir>;
  id?: InputMaybe<SortDir>;
  modified?: InputMaybe<SortDir>;
  rebateType?: InputMaybe<SortDir>;
  startDate?: InputMaybe<SortDir>;
  vendor?: InputMaybe<VendorsSort>;
};

export type VendorStatusGroupSubscriptionOption = {
  __typename?: 'VendorStatusGroupSubscriptionOption';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VendorSubscription = {
  __typename?: 'VendorSubscription';
  email: Scalars['String']['output'];
  statusGroups: Array<Scalars['String']['output']>;
  uniqueId: Scalars['Int']['output'];
};

export type VendorTermsDmsInput = {
  /** IDs of the terms (terms.id) to link/unlink */
  termIds: Array<Scalars['Int']['input']>;
  /** Public ID (remote_id, E/B number) of the vendor */
  vendorId: Scalars['String']['input'];
};

export type VendorUser = {
  __typename?: 'VendorUser';
  user?: Maybe<VendorPublicUser>;
  userId: Scalars['ID']['output'];
};

export type VendorUserIssue = {
  __typename?: 'VendorUserIssue';
  account?: Maybe<LinkedAccount>;
  adminUpdated?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  managerUpdated?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Array<Note>>;
  reporter: BaseIdentity;
  resolved?: Maybe<Scalars['DateTime']['output']>;
  subject: Scalars['String']['output'];
};

export type VendorUserIssueInput = {
  /** Filter issues by manager public ID (e.g. U1234) */
  managerId?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type VendorUserIssueWithUserDetails = {
  __typename?: 'VendorUserIssueWithUserDetails';
  account?: Maybe<LinkedAccount>;
  adminUpdated?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  managerUpdated?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Array<Note>>;
  reporter: BaseIdentity;
  resolved?: Maybe<Scalars['DateTime']['output']>;
  subject: Scalars['String']['output'];
  user: IssueUser;
  vendors: Array<IssueVendor>;
};

export type VendorUserListItem = {
  __typename?: 'VendorUserListItem';
  user?: Maybe<VendorPublicUser>;
  userId: Scalars['ID']['output'];
  vendors: Array<VendorUserVendorLink>;
};

export enum VendorUserRoleName {
  Team = 'TEAM',
  Vendor = 'VENDOR',
}

export type VendorUserVendorLink = {
  __typename?: 'VendorUserVendorLink';
  businessName?: Maybe<Scalars['String']['output']>;
  isAuthorityContact: Scalars['Boolean']['output'];
  managerId?: Maybe<Scalars['ID']['output']>;
  vendorId: Scalars['ID']['output'];
};

export type VendorUsersBooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorUsersFilter = {
  /** Filters by user activation state: equals true for active users, false for inactive. */
  activated?: InputMaybe<VendorUsersBooleanFilter>;
  /** Filters by user email. */
  email?: InputMaybe<VendorUsersStringFilter>;
  /** Filters by user first name. */
  firstName?: InputMaybe<VendorUsersStringFilter>;
  /** Filters by user last name. */
  lastName?: InputMaybe<VendorUsersStringFilter>;
  /** Filters by user mobile as stored in Users service; no phone number normalisation is applied. */
  mobile?: InputMaybe<VendorUsersStringFilter>;
  /** Filters users whose first name or last name matches this value. */
  name?: InputMaybe<VendorUsersStringFilter>;
  /** Filters by whether the user has open (unresolved) issues: equals true for users with open issues. */
  openIssues?: InputMaybe<VendorUsersBooleanFilter>;
  /** Filters by user role name. Only VENDOR and TEAM are valid for this vendor-user listing. */
  roleName?: InputMaybe<VendorUsersRoleFilter>;
  /** Global search across vendor business name and user profile fields: first name, last name, email, mobile, and user public ID. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filters by suspension state (backed by the Users deleted column): equals true for suspended users. */
  suspended?: InputMaybe<VendorUsersBooleanFilter>;
  /** Filters by user public ID, for example U123. */
  userId?: InputMaybe<VendorUsersIdFilter>;
  /** Filters by vendor business name only. */
  vendorBusinessName?: InputMaybe<VendorUsersStringFilter>;
  /** Filters by vendor public ID, for example E123. */
  vendorId?: InputMaybe<VendorUsersIdFilter>;
  /** Filters by the vendor's manager user public ID (Vendor.managerId), for example U123. */
  vendorManagerId?: InputMaybe<VendorUsersIdFilter>;
};

export type VendorUsersIdFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VendorUsersMeta = {
  __typename?: 'VendorUsersMeta';
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type VendorUsersResponse = {
  __typename?: 'VendorUsersResponse';
  items: Array<VendorUserListItem>;
  meta: VendorUsersMeta;
};

export type VendorUsersRoleFilter = {
  equals?: InputMaybe<VendorUserRoleName>;
  in?: InputMaybe<Array<VendorUserRoleName>>;
};

export type VendorUsersStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type VendorsFilter = {
  financialProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  includeLocked?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<StringFilter>;
  publicId?: InputMaybe<StringFilter>;
  search?: InputMaybe<StringFilter>;
  tradingName?: InputMaybe<StringFilter>;
  vendorFlags?: InputMaybe<VendorFlagsFilter>;
};

export type VendorsSort = {
  created?: InputMaybe<SortDir>;
  legalName?: InputMaybe<SortDir>;
  publicId?: InputMaybe<SortDir>;
  slug?: InputMaybe<SortDir>;
  tradingName?: InputMaybe<SortDir>;
};

export type VendorsUniqueFilter = {
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type VerifiedDocumentResult = {
  __typename?: 'VerifiedDocumentResult';
  documentId: Scalars['String']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  type: Scalars['String']['output'];
  validation: Scalars['String']['output'];
};

export type VerifyIdentityAddressInput = {
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyIdentityInput = {
  address: VerifyIdentityAddressInput;
  applicationId: Scalars['String']['input'];
  /** Date of birth in YYYY-MM-DD format */
  dateOfBirth: Scalars['String']['input'];
  documentType: IdentityVerificationDocumentType;
  driversLicence?: InputMaybe<DriversLicenceInput>;
  familyName: Scalars['String']['input'];
  firstGivenName: Scalars['String']['input'];
  medicare?: InputMaybe<MedicareDocInput>;
  otherGivenName?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<VerifyIdentityPassportInput>;
};

export type VerifyIdentityOutput = {
  __typename?: 'VerifyIdentityOutput';
  clientReference: Scalars['String']['output'];
  enquiryId: Scalars['String']['output'];
  overallOutcome: IdentityVerificationOverallOutcome;
  searchResults: Array<IdentityVerificationSearchResultOutput>;
};

export type VerifyIdentityPassportInput = {
  /** ISO 3166-1 alpha-3 country code (e.g. AUS, GBR, USA) */
  countryCode: Scalars['String']['input'];
  dateOfExpiry?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

export type VerifyIncomeDocumentUploadInput = {
  applicationId: Scalars['String']['input'];
  documentIds: Array<Scalars['String']['input']>;
  documentType?: InputMaybe<IncomeDocumentType>;
};

export type VerifyIncomeDocumentUploadResult = {
  __typename?: 'VerifyIncomeDocumentUploadResult';
  documents: Array<VerifiedDocumentResult>;
  numberOfDocumentsPassed: Scalars['Int']['output'];
  statusCode?: Maybe<Scalars['String']['output']>;
  validation: Scalars['String']['output'];
};

export type VerifyTitleOwnerDocumentsInput = {
  applicationId: Scalars['ID']['input'];
  documentIds: Array<Scalars['String']['input']>;
  titleSearchOwnerId: Scalars['ID']['input'];
  verificationMethod: TitleOwnerVerificationMethod;
};

export type VerifyTitleOwnerIncomeDocumentsInput = {
  applicationId: Scalars['ID']['input'];
  documentIds: Array<Scalars['String']['input']>;
  titleSearchOwnerId: Scalars['ID']['input'];
};

export type VerifyTitleSearchOwnerCentrelinkInput = {
  customerReferenceNumber: Scalars['String']['input'];
  dateOfBirth: Scalars['String']['input'];
  dateOfExpiry: Scalars['String']['input'];
  nameOnCard: Scalars['String']['input'];
};

export type VerifyTitleSearchOwnerPensionerInput = {
  applicationId: Scalars['ID']['input'];
  centrelink: VerifyTitleSearchOwnerCentrelinkInput;
  titleSearchOwnerId: Scalars['ID']['input'];
};

export type VerifyTitleSearchOwnerPensionerOutput = {
  __typename?: 'VerifyTitleSearchOwnerPensionerOutput';
  idMatrixReference?: Maybe<Scalars['String']['output']>;
  overallOutcome?: Maybe<Scalars['String']['output']>;
};

export type VerifyUpdatedUserEmailResponse = {
  __typename?: 'VerifyUpdatedUserEmailResponse';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type VerifyUpdatedUserMobileResponse = {
  __typename?: 'VerifyUpdatedUserMobileResponse';
  id: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VideoVimeo = Entity & {
  __typename?: 'VideoVimeo';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The share URL, e.g. https://vimeo.com/727717741/9d8f2d6dba */
  url: Scalars['String']['output'];
};

/** Identifies documents */
export type VideoVimeoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoVimeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type VideoYouTube = Entity & {
  __typename?: 'VideoYouTube';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The share URL, e.g. https://youtu.be/Z7q7gBsQhT8 */
  url: Scalars['String']['output'];
};

/** Identifies documents */
export type VideoYouTubeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoYouTubeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum Visibility {
  Public = 'Public',
  Unlisted = 'Unlisted',
}

export type WithdrawApplication = {
  accountId: Scalars['String']['input'];
  withdrawReason: Scalars['String']['input'];
};

export type WithdrawApplicationInput = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyEnterpriseLeadCategoriesMutationVariables = Exact<{
  categorySlugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UpdateMyEnterpriseLeadCategoriesMutation = {
  __typename?: 'Mutation';
  updateMyEnterpriseLeadCategories: {
    __typename?: 'EnterpriseLead';
    id: string;
    categories: Array<{ __typename?: 'EnterpriseLeadCategory'; category: string; content?: string | null }>;
  };
};

export type UpdateMyEnterpriseLeadCategoryContentMutationVariables = Exact<{
  input: UpdateMyEnterpriseLeadCategoryContentInput;
}>;

export type UpdateMyEnterpriseLeadCategoryContentMutation = {
  __typename?: 'Mutation';
  updateMyEnterpriseLeadCategoryContent: {
    __typename?: 'EnterpriseLead';
    id: string;
    categories: Array<{ __typename?: 'EnterpriseLeadCategory'; category: string; content?: string | null }>;
  };
};

export type UpdateMyEnterpriseLeadContactMutationVariables = Exact<{
  input: UpdateMyEnterpriseLeadContactInput;
}>;

export type UpdateMyEnterpriseLeadContactMutation = {
  __typename?: 'Mutation';
  updateMyEnterpriseLeadContact: {
    __typename?: 'EnterpriseLead';
    id: string;
    contact: { __typename?: 'EnterpriseLeadContact'; email: string; phone: string };
  };
};

export type AddressesQueryVariables = Exact<{
  input: AddressesInput;
}>;

export type AddressesQuery = {
  __typename?: 'Query';
  addresses?: {
    __typename?: 'AddressesResult';
    unitNumber?: string | null;
    streetNumber?: string | null;
    streetName?: string | null;
    suburb?: string | null;
    state?: string | null;
    country?: string | null;
    postcode?: string | null;
  } | null;
};

export type AddressSuggestionsQueryVariables = Exact<{
  input: AddressSuggestionsInput;
}>;

export type AddressSuggestionsQuery = {
  __typename?: 'Query';
  addressSuggestions?: Array<{
    __typename?: 'AddressSuggestionsResult';
    formattedAddress?: string | null;
  } | null> | null;
};

export type GetAvailablePromotionsQueryVariables = Exact<{
  filter?: InputMaybe<PromotionsFilterArgs>;
}>;

export type GetAvailablePromotionsQuery = {
  __typename?: 'Query';
  promotions: Array<{
    __typename?: 'Promotion';
    title: string;
    code: string;
    categories: Array<{ __typename?: 'CategoryPromotion'; categorySlug: string }>;
  }>;
};

export type EnterpriseLeadQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type EnterpriseLeadQuery = {
  __typename?: 'Query';
  enterpriseLead: {
    __typename?: 'EnterpriseLead';
    id: string;
    enterprisePartnerId: string;
    addressLine1?: string | null;
    addressLine2?: string | null;
    postcode?: string | null;
    state?: string | null;
    city?: string | null;
    intakeCompleted?: string | null;
    promotionCode?: string | null;
    channel?: { __typename?: 'PartnerConfigChannel'; slug: string } | null;
    contact: {
      __typename?: 'EnterpriseLeadContact';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phone: string;
    };
    categories: Array<{ __typename?: 'EnterpriseLeadCategory'; category: string; content?: string | null }>;
    vendors: Array<{ __typename?: 'EnterpriseLeadVendor'; vendor: { __typename?: 'Vendor'; id: string } }>;
    quotes: Array<{
      __typename?: 'EnterpriseQuote';
      id: string;
      trackingId: string;
      category: string;
      declinedAt?: string | null;
      cancelledAt?: string | null;
      expiredAt?: string | null;
      vendor: { __typename?: 'Vendor'; id: string };
    }>;
  };
};

export type HierarchicalCategoriesQueryVariables = Exact<{
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  enterprisePartnerId?: InputMaybe<Scalars['String']['input']>;
}>;

export type HierarchicalCategoriesQuery = {
  __typename?: 'Query';
  hierarchicalCategories: Array<{
    __typename?: 'ParentCategory';
    name: string;
    slug: string;
    subCategories?: Array<{ __typename?: 'Category'; name: string; slug: string }> | null;
  }>;
};

export type BrandsQueryVariables = Exact<{ [key: string]: never }>;

export type BrandsQuery = { __typename?: 'Query'; brands: Array<{ __typename?: 'Brand'; name: string }> };

export type MarketplaceChildCategoriesQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;

export type MarketplaceChildCategoriesQuery = {
  __typename?: 'Query';
  categories: Array<{
    __typename?: 'Category';
    name: string;
    slug: string;
    isVirtualPowerPlantCompatible: boolean;
  }>;
};

export type MarketplaceVendorsQueryVariables = Exact<{
  postcode: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  withPricing: Scalars['Boolean']['input'];
  sort?: InputMaybe<MarketplaceVendorsSort>;
  filter?: InputMaybe<MarketplaceVendorsFilter>;
  promotionsFilter?: InputMaybe<MarketplacePromotionsFilter>;
}>;

export type MarketplaceVendorsQuery = {
  __typename?: 'Query';
  marketplaceVendors: {
    __typename?: 'MarketplaceVendorsResponse';
    count: number;
    vendors: Array<{
      __typename?: 'MarketplaceVendor';
      tradingName: string;
      slug: string;
      isLocal?: boolean | null;
      logoUrl?: string | null;
      publicId: string;
      details: Array<{
        __typename?: 'VendorDetail';
        phone?: string | null;
        website?: string | null;
        description?: string | null;
        address?: string | null;
        placeId?: string | null;
        addressDetail?: { __typename?: 'AddressType'; suburb: string } | null;
      }>;
      categories?: Array<{
        __typename?: 'Category';
        name: string;
        slug: string;
        indicativePrice?: number | null;
        isVirtualPowerPlantCompatible: boolean;
      }> | null;
      marketplacePromotions: Array<{
        __typename?: 'Promotion';
        title: string;
        code: string;
        tag?: string | null;
        publicDescription?: string | null;
      }>;
      approvedFinancialProducts?: Array<{ __typename?: 'FinancialProduct'; slug: FinancialProductSlugs }> | null;
    }>;
  };
};

export type RecommendedVendorsQueryVariables = Exact<{
  postcode: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MarketplaceVendorsSort>;
  filter?: InputMaybe<MarketplaceVendorsFilter>;
}>;

export type RecommendedVendorsQuery = {
  __typename?: 'Query';
  marketplaceVendors: {
    __typename?: 'MarketplaceVendorsResponse';
    count: number;
    vendors: Array<{
      __typename?: 'MarketplaceVendor';
      publicId: string;
      slug: string;
      tradingName: string;
      logoUrl?: string | null;
      details: Array<{ __typename?: 'VendorDetail'; description?: string | null }>;
      categories?: Array<{
        __typename?: 'Category';
        name: string;
        slug: string;
        isVirtualPowerPlantCompatible: boolean;
      }> | null;
    }>;
  };
};

export type VendorEnrolledFinancialProductsQueryVariables = Exact<{
  vendorId: Scalars['String']['input'];
}>;

export type VendorEnrolledFinancialProductsQuery = {
  __typename?: 'Query';
  vendorEnrolledFinancialProducts: Array<{ __typename?: 'EnrolledFinancialProduct'; financialProductSlug: string }>;
};

export const UpdateMyEnterpriseLeadCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMyEnterpriseLeadCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'categorySlugs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMyEnterpriseLeadCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'categorySlugs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'categorySlugs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMyEnterpriseLeadCategoriesMutation,
  UpdateMyEnterpriseLeadCategoriesMutationVariables
>;
export const UpdateMyEnterpriseLeadCategoryContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMyEnterpriseLeadCategoryContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMyEnterpriseLeadCategoryContentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMyEnterpriseLeadCategoryContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMyEnterpriseLeadCategoryContentMutation,
  UpdateMyEnterpriseLeadCategoryContentMutationVariables
>;
export const UpdateMyEnterpriseLeadContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMyEnterpriseLeadContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMyEnterpriseLeadContactInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMyEnterpriseLeadContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMyEnterpriseLeadContactMutation, UpdateMyEnterpriseLeadContactMutationVariables>;
export const AddressesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Addresses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressesInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'unitNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suburb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressesQuery, AddressesQueryVariables>;
export const AddressSuggestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AddressSuggestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressSuggestionsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addressSuggestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'formattedAddress' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>;
export const GetAvailablePromotionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAvailablePromotions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PromotionsFilterArgs' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'promotions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'categorySlug' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAvailablePromotionsQuery, GetAvailablePromotionsQueryVariables>;
export const EnterpriseLeadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EnterpriseLead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enterpriseLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enterprisePartnerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intakeCompleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promotionCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vendors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vendor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'quotes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trackingId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vendor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'declinedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cancelledAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiredAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnterpriseLeadQuery, EnterpriseLeadQueryVariables>;
export const HierarchicalCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HierarchicalCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'financialProductId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enterprisePartnerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hierarchicalCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'financialProductId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'financialProductId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enterprisePartnerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'enterprisePartnerId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subCategories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HierarchicalCategoriesQuery, HierarchicalCategoriesQueryVariables>;
export const BrandsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Brands' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equals' },
                            value: { kind: 'StringValue', value: 'MANUFACTURER', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandsQuery, BrandsQueryVariables>;
export const MarketplaceChildCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketplaceChildCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isParentCategory' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVirtualPowerPlantCompatible' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarketplaceChildCategoriesQuery, MarketplaceChildCategoriesQueryVariables>;
export const MarketplaceVendorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketplaceVendors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'postcode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withPricing' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceVendorsSort' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceVendorsFilter' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'promotionsFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplacePromotionsFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceVendors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'postcode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'postcode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vendors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tradingName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLocal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressDetail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'suburb' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'indicativePrice' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'withPricing' } },
                                    },
                                  ],
                                },
                              ],
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVirtualPowerPlantCompatible' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplacePromotions' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'promotionsFilter' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'publicDescription' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approvedFinancialProducts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarketplaceVendorsQuery, MarketplaceVendorsQueryVariables>;
export const RecommendedVendorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RecommendedVendors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'postcode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceVendorsSort' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceVendorsFilter' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceVendors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'postcode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'postcode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vendors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tradingName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVirtualPowerPlantCompatible' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecommendedVendorsQuery, RecommendedVendorsQueryVariables>;
export const VendorEnrolledFinancialProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VendorEnrolledFinancialProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vendorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vendorEnrolledFinancialProducts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vendorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vendorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'financialProductSlug' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VendorEnrolledFinancialProductsQuery, VendorEnrolledFinancialProductsQueryVariables>;
